var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb2, mod) => function __require() {
  return mod || (0, cb2[__getOwnPropNames(cb2)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/BrandArea/xsolla-pattern.svg
var require_xsolla_pattern = __commonJS({
  "src/components/BrandArea/xsolla-pattern.svg"(exports, module2) {
    module2.exports = "./assets/xsolla-pattern.svg";
  }
});

// ../../node_modules/tslib/tslib.js
var require_tslib = __commonJS({
  "../../node_modules/tslib/tslib.js"(exports, module2) {
    var __extends2;
    var __assign2;
    var __rest2;
    var __decorate2;
    var __param2;
    var __metadata2;
    var __awaiter2;
    var __generator2;
    var __exportStar2;
    var __values2;
    var __read2;
    var __spread2;
    var __spreadArrays2;
    var __spreadArray2;
    var __await2;
    var __asyncGenerator2;
    var __asyncDelegator2;
    var __asyncValues2;
    var __makeTemplateObject2;
    var __importStar2;
    var __importDefault2;
    var __classPrivateFieldGet2;
    var __classPrivateFieldSet2;
    var __createBinding2;
    (function(factory) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module2 === "object" && typeof module2.exports === "object") {
        factory(createExporter(root, createExporter(module2.exports)));
      } else {
        factory(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v2) {
          return exports2[id] = previous ? previous(id, v2) : v2;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
        d2.__proto__ = b3;
      } || function(d2, b3) {
        for (var p2 in b3)
          if (Object.prototype.hasOwnProperty.call(b3, p2))
            d2[p2] = b3[p2];
      };
      __extends2 = function(d2, b3) {
        if (typeof b3 !== "function" && b3 !== null)
          throw new TypeError("Class extends value " + String(b3) + " is not a constructor or null");
        extendStatics(d2, b3);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b3 === null ? Object.create(b3) : (__.prototype = b3.prototype, new __());
      };
      __assign2 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest2 = function(s2, e2) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate2 = function(decorators, target, key, desc) {
        var c3 = arguments.length, r2 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c3 < 3 ? d2(r2) : c3 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c3 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param2 = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata2 = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter2 = function(thisArg, _arguments, P, generator) {
        function adopt(value) {
          return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
          });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e2) {
              reject(e2);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e2) {
              reject(e2);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator2 = function(thisArg, body) {
        var _ = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v2) {
            return step([n2, v2]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _.label++;
                  return { value: op[1], done: false };
                case 5:
                  _.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t2[1]) {
                    _.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _.label < t2[2]) {
                    _.label = t2[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e2) {
              op = [6, e2];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __exportStar2 = function(m2, o2) {
        for (var p2 in m2)
          if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(o2, p2))
            __createBinding2(o2, m2, p2);
      };
      __createBinding2 = Object.create ? function(o2, m2, k, k2) {
        if (k2 === void 0)
          k2 = k;
        Object.defineProperty(o2, k2, { enumerable: true, get: function() {
          return m2[k];
        } });
      } : function(o2, m2, k, k2) {
        if (k2 === void 0)
          k2 = k;
        o2[k2] = m2[k];
      };
      __values2 = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read2 = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar = [], e2;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar.push(r2.value);
        } catch (error) {
          e2 = { error };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e2)
              throw e2.error;
          }
        }
        return ar;
      };
      __spread2 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read2(arguments[i2]));
        return ar;
      };
      __spreadArrays2 = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k = 0, i2 = 0; i2 < il; i2++)
          for (var a3 = arguments[i2], j2 = 0, jl = a3.length; j2 < jl; j2++, k++)
            r2[k] = a3[j2];
        return r2;
      };
      __spreadArray2 = function(to, from, pack) {
        if (pack || arguments.length === 2)
          for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
            if (ar || !(i2 in from)) {
              if (!ar)
                ar = Array.prototype.slice.call(from, 0, i2);
              ar[i2] = from[i2];
            }
          }
        return to.concat(ar || Array.prototype.slice.call(from));
      };
      __await2 = function(v2) {
        return this instanceof __await2 ? (this.v = v2, this) : new __await2(v2);
      };
      __asyncGenerator2 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v2) {
              return new Promise(function(a3, b3) {
                q.push([n2, v2, a3, b3]) > 1 || resume(n2, v2);
              });
            };
        }
        function resume(n2, v2) {
          try {
            step(g2[n2](v2));
          } catch (e2) {
            settle(q[0][3], e2);
          }
        }
        function step(r2) {
          r2.value instanceof __await2 ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v2) {
          if (f2(v2), q.shift(), q.length)
            resume(q[0][0], q[0][1]);
        }
      };
      __asyncDelegator2 = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e2) {
          throw e2;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v2) {
            return (p2 = !p2) ? { value: __await2(o2[n2](v2)), done: n2 === "return" } : f2 ? f2(v2) : v2;
          } : f2;
        }
      };
      __asyncValues2 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values2 === "function" ? __values2(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v2) {
            return new Promise(function(resolve, reject) {
              v2 = o2[n2](v2), settle(resolve, reject, v2.done, v2.value);
            });
          };
        }
        function settle(resolve, reject, d2, v2) {
          Promise.resolve(v2).then(function(v3) {
            resolve({ value: v3, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject2 = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      var __setModuleDefault = Object.create ? function(o2, v2) {
        Object.defineProperty(o2, "default", { enumerable: true, value: v2 });
      } : function(o2, v2) {
        o2["default"] = v2;
      };
      __importStar2 = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
              __createBinding2(result, mod, k);
        }
        __setModuleDefault(result, mod);
        return result;
      };
      __importDefault2 = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet2 = function(receiver, state, kind, f2) {
        if (kind === "a" && !f2)
          throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f2 : !state.has(receiver))
          throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f2 : kind === "a" ? f2.call(receiver) : f2 ? f2.value : state.get(receiver);
      };
      __classPrivateFieldSet2 = function(receiver, state, value, kind, f2) {
        if (kind === "m")
          throw new TypeError("Private method is not writable");
        if (kind === "a" && !f2)
          throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f2 : !state.has(receiver))
          throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f2.call(receiver, value) : f2 ? f2.value = value : state.set(receiver, value), value;
      };
      exporter("__extends", __extends2);
      exporter("__assign", __assign2);
      exporter("__rest", __rest2);
      exporter("__decorate", __decorate2);
      exporter("__param", __param2);
      exporter("__metadata", __metadata2);
      exporter("__awaiter", __awaiter2);
      exporter("__generator", __generator2);
      exporter("__exportStar", __exportStar2);
      exporter("__createBinding", __createBinding2);
      exporter("__values", __values2);
      exporter("__read", __read2);
      exporter("__spread", __spread2);
      exporter("__spreadArrays", __spreadArrays2);
      exporter("__spreadArray", __spreadArray2);
      exporter("__await", __await2);
      exporter("__asyncGenerator", __asyncGenerator2);
      exporter("__asyncDelegator", __asyncDelegator2);
      exporter("__asyncValues", __asyncValues2);
      exporter("__makeTemplateObject", __makeTemplateObject2);
      exporter("__importStar", __importStar2);
      exporter("__importDefault", __importDefault2);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet2);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet2);
    });
  }
});

// ../../node_modules/@emotion/memoize/dist/memoize.browser.cjs.js
var require_memoize_browser_cjs = __commonJS({
  "../../node_modules/@emotion/memoize/dist/memoize.browser.cjs.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function memoize(fn) {
      var cache = {};
      return function(arg) {
        if (cache[arg] === void 0)
          cache[arg] = fn(arg);
        return cache[arg];
      };
    }
    exports.default = memoize;
  }
});

// ../../node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.cjs.js
var require_is_prop_valid_browser_cjs = __commonJS({
  "../../node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.cjs.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function _interopDefault(ex) {
      return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
    }
    var memoize = _interopDefault(require_memoize_browser_cjs());
    var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
    var index = memoize(function(prop) {
      return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
    });
    exports.default = index;
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Avatar: () => Avatar,
  Brand: () => Brand,
  BrandArea: () => BrandArea,
  Button: () => Button,
  ButtonInput: () => ButtonInput,
  ButtonMore: () => ButtonMore,
  ButtonSquare: () => ButtonSquare,
  CardBanner: () => CardBanner,
  Checkbox: () => Checkbox,
  Collapse: () => Collapse,
  Dots: () => Dots,
  Extra: () => Extra3,
  FieldGroup: () => FieldGroup,
  FieldRow: () => FieldRow3,
  FieldWrapper: () => FieldWrapper2,
  FloatingArea: () => FloatingArea,
  FormFooter: () => FormFooter,
  GlobalStyle: () => GlobalStyle,
  Grid: () => Grid,
  HintCircle: () => HintCircle,
  Input: () => Input2,
  InputCopy: () => InputCopy,
  InputPassword: () => InputPassword,
  List: () => List,
  ListItem: () => ListItem2,
  Notification: () => Notification,
  Pagination: () => Pagination,
  Pill: () => Pill,
  PillAction: () => PillAction,
  PillLink: () => PillLink,
  Popper: () => Popper,
  ProgressBar: () => ProgressBar,
  Radio: () => Radio,
  RadioGroup: () => RadioGroup,
  Select: () => Select,
  Spinner: () => Spinner,
  StatusDot: () => StatusDot,
  StyledRadioGroup: () => StyledRadioGroup,
  Switch: () => Switch,
  TabItem: () => TabItem,
  Tabs: () => Tabs,
  Textarea: () => Textarea,
  Title: () => Title,
  Tooltip: () => Tooltip6,
  TooltipEntry: () => TooltipEntry,
  UiProvider: () => UiProvider,
  ValidationMessage: () => ValidationMessage7,
  WorkArea: () => WorkArea,
  fixSafariFocus: () => fixSafariFocus,
  getRandomString: () => getRandomString,
  lightTheme: () => lightTheme,
  makeSafetyMap: () => makeSafetyMap,
  required: () => required,
  springTransition: () => springTransition,
  useMemoryTabs: () => useMemoryTabs,
  useUiContext: () => useUiContext
});
module.exports = __toCommonJS(src_exports);

// src/components/Avatar/Avatar.tsx
var import_react = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
var StyledAvatar = import_styled_components.default.img`
  background-color: ${(p2) => p2.theme.colors.stroke};
  display: inline-flex;
  object-fit: cover;
  border-radius: 50%;

  ${(p2) => p2.$size === "sm" && import_styled_components.css`
      width: 24px;
      height: 24px;
    `}

  ${(p2) => p2.$size === "md" && import_styled_components.css`
      width: 32px;
      height: 32px;
    `}

  ${(p2) => p2.$size === "lg" && import_styled_components.css`
      width: 40px;
      height: 40px;
    `}

  ${(p2) => p2.$stroked && import_styled_components.css`
      border: 1px solid ${(p3) => p3.theme.colors.white};
    `}

    ${(p2) => p2.$interactive && import_styled_components.css`
      cursor: pointer;
    `}
`;
var Avatar = (0, import_react.forwardRef)(function forwardedAvatar({ src, size = "md", stroked = false, ...rest }, ref) {
  return /* @__PURE__ */ import_react.default.createElement(StyledAvatar, {
    ...rest,
    ref,
    src,
    $size: size,
    $stroked: stroked,
    $interactive: !!rest.onClick
  });
});

// src/components/Brand/Brand.tsx
var import_react3 = __toESM(require("react"));
var import_react4 = require("react");
var import_styled_components2 = __toESM(require("styled-components"));

// src/components/Brand/BrandRaw.tsx
var import_react2 = __toESM(require("react"));
var BrandRaw = () => /* @__PURE__ */ import_react2.default.createElement("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ import_react2.default.createElement("path", {
  d: "M100 0H0V100H100V0Z",
  fill: "#0076FF"
}), /* @__PURE__ */ import_react2.default.createElement("path", {
  d: "M71.7443 52.0368C70.1063 52.0368 68.727 53.4161 68.727 55.0541C68.727 56.692 70.0201 57.9851 71.7443 57.9851C73.3822 57.9851 74.6753 56.692 74.6753 55.0541C74.7615 53.4161 73.3822 52.0368 71.7443 52.0368ZM71.7443 61.261C68.296 61.261 65.4512 58.5023 65.4512 55.0541C65.4512 51.6058 68.296 48.8472 71.7443 48.8472C75.1925 48.8472 77.9512 51.6058 77.9512 55.0541C78.0374 58.5023 75.1925 61.261 71.7443 61.261Z",
  fill: "#F6FAFF"
}), /* @__PURE__ */ import_react2.default.createElement("path", {
  d: "M49.2788 77.4139H46.0029V66.207H49.2788V77.4139Z",
  fill: "#F6FAFF"
}), /* @__PURE__ */ import_react2.default.createElement("path", {
  d: "M54.02 77.4139H50.7441V66.207H54.02V77.4139Z",
  fill: "#F6FAFF"
}), /* @__PURE__ */ import_react2.default.createElement("path", {
  d: "M64.3388 28.0968L67.5284 24.9072L65.2008 22.5796L62.0112 25.7693L59.6836 28.0968L63.8215 32.2348L60.6319 35.4244L62.9594 37.752L68.4767 32.2348L64.3388 28.0968Z",
  fill: "#F6FAFF"
}), /* @__PURE__ */ import_react2.default.createElement("path", {
  d: "M28.0154 54.6873L29.9399 57.9874H26.0881L28.0154 54.6873ZM28.0154 48.2153L20.4424 61.308H35.5883L28.0154 48.2153Z",
  fill: "#F6FAFF"
}), /* @__PURE__ */ import_react2.default.createElement("path", {
  d: "M42.4065 26.1137L40.0789 23.7861L36.1134 27.7516L32.1479 23.7861L29.8203 26.1137L33.7858 30.0792L29.8203 34.0448L32.1479 36.3723L36.1134 32.4068L40.0789 36.3723L42.4065 34.0448L38.441 30.0792L42.4065 26.1137Z",
  fill: "#F6FAFF"
}));

// src/components/Brand/Brand.tsx
var StyledBrand = import_styled_components2.default.div`
  display: inline-flex;
  flex-shrink: 0;
  svg {
    width: 100%;
    height: 100%;
  }
`;
var Brand = (0, import_react4.forwardRef)(function forwardedBrand({ size = 40, ...rest }, ref) {
  return /* @__PURE__ */ import_react3.default.createElement(StyledBrand, {
    ref,
    style: { width: size, height: size },
    ...rest
  }, /* @__PURE__ */ import_react3.default.createElement(BrandRaw, null));
});

// src/components/BrandArea/BrandArea.tsx
var import_react6 = __toESM(require("react"));
var import_styled_components7 = __toESM(require("styled-components"));

// src/components/Spinner/Spinner.tsx
var import_react5 = __toESM(require("react"));
var import_styled_components6 = __toESM(require("styled-components"));

// src/libs/makeSafetyMap.ts
var makeSafetyMap = (values) => {
  const map = new Map(values);
  return {
    entries: values,
    get: (key) => {
      return map.get(key) || values[0][1];
    }
  };
};

// src/tokens/colors.ts
var colors = {
  text: "#00244d",
  brand: "#0073f7",
  action: "#00c77e",
  magenta: "#ff005b",
  white: "#ffffff",
  tableCell: "#fafbfc",
  overlay: "#f7faff",
  muted: "#747e8a",
  disabled: "#a0abb8",
  stroke: "#c5d0db",
  danger: "#eb002f",
  info: "#ffc500",
  warning: "#ff8111",
  success: "#0bb200"
};

// src/tokens/gradients.ts
var import_styled_components3 = require("styled-components");
var gradients = {
  coralOrange: import_styled_components3.css`
    background-image: linear-gradient(225deg, #ff497f, #fcdd40);
  `,
  blueViolet: import_styled_components3.css`
    background-image: linear-gradient(225deg, #ac2eff, #37b9fb);
  `,
  brightSky: import_styled_components3.css`
    background-image: linear-gradient(225deg, #489dff, #00ffca);
  `,
  enabled: import_styled_components3.css`
    background-image: linear-gradient(225deg, #00e994, #00c77e);
  `,
  enabledAlt: import_styled_components3.css`
    background-image: linear-gradient(225deg, #0bb200, #0edf00);
  `,
  destruction: import_styled_components3.css`
    background-image: linear-gradient(225deg, #fc2b55, #eb002f);
  `,
  disabled: import_styled_components3.css`
    background-image: linear-gradient(225deg, #c9d0d7, #a0abb8);
  `
};

// ../../node_modules/colord/index.mjs
var r = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) };
var t = function(r2) {
  return typeof r2 == "string" ? r2.length > 0 : typeof r2 == "number";
};
var n = function(r2, t2, n2) {
  return t2 === void 0 && (t2 = 0), n2 === void 0 && (n2 = Math.pow(10, t2)), Math.round(n2 * r2) / n2 + 0;
};
var e = function(r2, t2, n2) {
  return t2 === void 0 && (t2 = 0), n2 === void 0 && (n2 = 1), r2 > n2 ? n2 : r2 > t2 ? r2 : t2;
};
var u = function(r2) {
  return (r2 = isFinite(r2) ? r2 % 360 : 0) > 0 ? r2 : r2 + 360;
};
var a = function(r2) {
  return { r: e(r2.r, 0, 255), g: e(r2.g, 0, 255), b: e(r2.b, 0, 255), a: e(r2.a) };
};
var o = function(r2) {
  return { r: n(r2.r), g: n(r2.g), b: n(r2.b), a: n(r2.a, 3) };
};
var i = /^#([0-9a-f]{3,8})$/i;
var s = function(r2) {
  var t2 = r2.toString(16);
  return t2.length < 2 ? "0" + t2 : t2;
};
var h = function(r2) {
  var t2 = r2.r, n2 = r2.g, e2 = r2.b, u2 = r2.a, a3 = Math.max(t2, n2, e2), o2 = a3 - Math.min(t2, n2, e2), i2 = o2 ? a3 === t2 ? (n2 - e2) / o2 : a3 === n2 ? 2 + (e2 - t2) / o2 : 4 + (t2 - n2) / o2 : 0;
  return { h: 60 * (i2 < 0 ? i2 + 6 : i2), s: a3 ? o2 / a3 * 100 : 0, v: a3 / 255 * 100, a: u2 };
};
var b = function(r2) {
  var t2 = r2.h, n2 = r2.s, e2 = r2.v, u2 = r2.a;
  t2 = t2 / 360 * 6, n2 /= 100, e2 /= 100;
  var a3 = Math.floor(t2), o2 = e2 * (1 - n2), i2 = e2 * (1 - (t2 - a3) * n2), s2 = e2 * (1 - (1 - t2 + a3) * n2), h2 = a3 % 6;
  return { r: 255 * [e2, i2, o2, o2, s2, e2][h2], g: 255 * [s2, e2, e2, i2, o2, o2][h2], b: 255 * [o2, o2, s2, e2, e2, i2][h2], a: u2 };
};
var g = function(r2) {
  return { h: u(r2.h), s: e(r2.s, 0, 100), l: e(r2.l, 0, 100), a: e(r2.a) };
};
var d = function(r2) {
  return { h: n(r2.h), s: n(r2.s), l: n(r2.l), a: n(r2.a, 3) };
};
var f = function(r2) {
  return b((n2 = (t2 = r2).s, { h: t2.h, s: (n2 *= ((e2 = t2.l) < 50 ? e2 : 100 - e2) / 100) > 0 ? 2 * n2 / (e2 + n2) * 100 : 0, v: e2 + n2, a: t2.a }));
  var t2, n2, e2;
};
var c = function(r2) {
  return { h: (t2 = h(r2)).h, s: (u2 = (200 - (n2 = t2.s)) * (e2 = t2.v) / 100) > 0 && u2 < 200 ? n2 * e2 / 100 / (u2 <= 100 ? u2 : 200 - u2) * 100 : 0, l: u2 / 2, a: t2.a };
  var t2, n2, e2, u2;
};
var l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i;
var p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i;
var v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i;
var m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i;
var y = { string: [[function(r2) {
  var t2 = i.exec(r2);
  return t2 ? (r2 = t2[1]).length <= 4 ? { r: parseInt(r2[0] + r2[0], 16), g: parseInt(r2[1] + r2[1], 16), b: parseInt(r2[2] + r2[2], 16), a: r2.length === 4 ? n(parseInt(r2[3] + r2[3], 16) / 255, 2) : 1 } : r2.length === 6 || r2.length === 8 ? { r: parseInt(r2.substr(0, 2), 16), g: parseInt(r2.substr(2, 2), 16), b: parseInt(r2.substr(4, 2), 16), a: r2.length === 8 ? n(parseInt(r2.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(r2) {
  var t2 = v.exec(r2) || m.exec(r2);
  return t2 ? t2[2] !== t2[4] || t2[4] !== t2[6] ? null : a({ r: Number(t2[1]) / (t2[2] ? 100 / 255 : 1), g: Number(t2[3]) / (t2[4] ? 100 / 255 : 1), b: Number(t2[5]) / (t2[6] ? 100 / 255 : 1), a: t2[7] === void 0 ? 1 : Number(t2[7]) / (t2[8] ? 100 : 1) }) : null;
}, "rgb"], [function(t2) {
  var n2 = l.exec(t2) || p.exec(t2);
  if (!n2)
    return null;
  var e2, u2, a3 = g({ h: (e2 = n2[1], u2 = n2[2], u2 === void 0 && (u2 = "deg"), Number(e2) * (r[u2] || 1)), s: Number(n2[3]), l: Number(n2[4]), a: n2[5] === void 0 ? 1 : Number(n2[5]) / (n2[6] ? 100 : 1) });
  return f(a3);
}, "hsl"]], object: [[function(r2) {
  var n2 = r2.r, e2 = r2.g, u2 = r2.b, o2 = r2.a, i2 = o2 === void 0 ? 1 : o2;
  return t(n2) && t(e2) && t(u2) ? a({ r: Number(n2), g: Number(e2), b: Number(u2), a: Number(i2) }) : null;
}, "rgb"], [function(r2) {
  var n2 = r2.h, e2 = r2.s, u2 = r2.l, a3 = r2.a, o2 = a3 === void 0 ? 1 : a3;
  if (!t(n2) || !t(e2) || !t(u2))
    return null;
  var i2 = g({ h: Number(n2), s: Number(e2), l: Number(u2), a: Number(o2) });
  return f(i2);
}, "hsl"], [function(r2) {
  var n2 = r2.h, a3 = r2.s, o2 = r2.v, i2 = r2.a, s2 = i2 === void 0 ? 1 : i2;
  if (!t(n2) || !t(a3) || !t(o2))
    return null;
  var h2 = function(r3) {
    return { h: u(r3.h), s: e(r3.s, 0, 100), v: e(r3.v, 0, 100), a: e(r3.a) };
  }({ h: Number(n2), s: Number(a3), v: Number(o2), a: Number(s2) });
  return b(h2);
}, "hsv"]] };
var N = function(r2, t2) {
  for (var n2 = 0; n2 < t2.length; n2++) {
    var e2 = t2[n2][0](r2);
    if (e2)
      return [e2, t2[n2][1]];
  }
  return [null, void 0];
};
var x = function(r2) {
  return typeof r2 == "string" ? N(r2.trim(), y.string) : typeof r2 == "object" && r2 !== null ? N(r2, y.object) : [null, void 0];
};
var M = function(r2, t2) {
  var n2 = c(r2);
  return { h: n2.h, s: e(n2.s + 100 * t2, 0, 100), l: n2.l, a: n2.a };
};
var H = function(r2) {
  return (299 * r2.r + 587 * r2.g + 114 * r2.b) / 1e3 / 255;
};
var $ = function(r2, t2) {
  var n2 = c(r2);
  return { h: n2.h, s: n2.s, l: e(n2.l + 100 * t2, 0, 100), a: n2.a };
};
var j = function() {
  function r2(r3) {
    this.parsed = x(r3)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return r2.prototype.isValid = function() {
    return this.parsed !== null;
  }, r2.prototype.brightness = function() {
    return n(H(this.rgba), 2);
  }, r2.prototype.isDark = function() {
    return H(this.rgba) < 0.5;
  }, r2.prototype.isLight = function() {
    return H(this.rgba) >= 0.5;
  }, r2.prototype.toHex = function() {
    return r3 = o(this.rgba), t2 = r3.r, e2 = r3.g, u2 = r3.b, i2 = (a3 = r3.a) < 1 ? s(n(255 * a3)) : "", "#" + s(t2) + s(e2) + s(u2) + i2;
    var r3, t2, e2, u2, a3, i2;
  }, r2.prototype.toRgb = function() {
    return o(this.rgba);
  }, r2.prototype.toRgbString = function() {
    return r3 = o(this.rgba), t2 = r3.r, n2 = r3.g, e2 = r3.b, (u2 = r3.a) < 1 ? "rgba(" + t2 + ", " + n2 + ", " + e2 + ", " + u2 + ")" : "rgb(" + t2 + ", " + n2 + ", " + e2 + ")";
    var r3, t2, n2, e2, u2;
  }, r2.prototype.toHsl = function() {
    return d(c(this.rgba));
  }, r2.prototype.toHslString = function() {
    return r3 = d(c(this.rgba)), t2 = r3.h, n2 = r3.s, e2 = r3.l, (u2 = r3.a) < 1 ? "hsla(" + t2 + ", " + n2 + "%, " + e2 + "%, " + u2 + ")" : "hsl(" + t2 + ", " + n2 + "%, " + e2 + "%)";
    var r3, t2, n2, e2, u2;
  }, r2.prototype.toHsv = function() {
    return r3 = h(this.rgba), { h: n(r3.h), s: n(r3.s), v: n(r3.v), a: n(r3.a, 3) };
    var r3;
  }, r2.prototype.invert = function() {
    return w({ r: 255 - (r3 = this.rgba).r, g: 255 - r3.g, b: 255 - r3.b, a: r3.a });
    var r3;
  }, r2.prototype.saturate = function(r3) {
    return r3 === void 0 && (r3 = 0.1), w(M(this.rgba, r3));
  }, r2.prototype.desaturate = function(r3) {
    return r3 === void 0 && (r3 = 0.1), w(M(this.rgba, -r3));
  }, r2.prototype.grayscale = function() {
    return w(M(this.rgba, -1));
  }, r2.prototype.lighten = function(r3) {
    return r3 === void 0 && (r3 = 0.1), w($(this.rgba, r3));
  }, r2.prototype.darken = function(r3) {
    return r3 === void 0 && (r3 = 0.1), w($(this.rgba, -r3));
  }, r2.prototype.rotate = function(r3) {
    return r3 === void 0 && (r3 = 15), this.hue(this.hue() + r3);
  }, r2.prototype.alpha = function(r3) {
    return typeof r3 == "number" ? w({ r: (t2 = this.rgba).r, g: t2.g, b: t2.b, a: r3 }) : n(this.rgba.a, 3);
    var t2;
  }, r2.prototype.hue = function(r3) {
    var t2 = c(this.rgba);
    return typeof r3 == "number" ? w({ h: r3, s: t2.s, l: t2.l, a: t2.a }) : n(t2.h);
  }, r2.prototype.isEqual = function(r3) {
    return this.toHex() === w(r3).toHex();
  }, r2;
}();
var w = function(r2) {
  return r2 instanceof j ? r2 : new j(r2);
};

// src/tokens/palettes.ts
var makePalette = (color2) => {
  const raw = w(color2);
  return {
    dark: raw.darken(0.05).toHex(),
    regular: color2,
    overlay: raw.alpha(0.32).toHex(),
    transparent: raw.alpha(0.08).toHex()
  };
};
var palettes = {
  action: makePalette(colors.action),
  brand: makePalette(colors.brand),
  danger: makePalette(colors.danger),
  muted: makePalette(colors.muted),
  warning: makePalette(colors.warning)
};

// src/tokens/typography.ts
var import_styled_components4 = require("styled-components");
var typography = {
  graphikFontFamily: import_styled_components4.css`
    font-family: 'GraphikLCWebUikit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      Helvetica, Arial, sans-serif;
  `,
  display: import_styled_components4.css`
    font-size: 30px;
    line-height: 40px;
    font-weight: 500;
    letter-spacing: -0.2px;
  `,
  title: import_styled_components4.css`
    font-size: 22px;
    line-height: 32px;
    font-weight: 500;
    letter-spacing: -0.2px;
  `,
  title2: import_styled_components4.css`
    font-size: 18px;
    line-height: 28px;
    font-weight: 500;
    letter-spacing: -0.2px;
  `,
  title2compact: import_styled_components4.css`
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    letter-spacing: -0.2px;
  `,
  subHeader: import_styled_components4.css`
    font-size: 15px;
    line-height: 24px;
    font-weight: 500;
  `,
  subHeader2: import_styled_components4.css`
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
  `,
  subHeader3: import_styled_components4.css`
    font-size: 13px;
    line-height: 20px;
    font-weight: 500;
  `,
  subHeader3compact: import_styled_components4.css`
    font-size: 13px;
    line-height: 16px;
    font-weight: 500;
  `,
  accent: import_styled_components4.css`
    font-size: 22px;
    line-height: 32px;
    letter-spacing: -0.2px;
  `,
  body: import_styled_components4.css`
    font-size: 15px;
    line-height: 24px;
  `,
  bodyCompact: import_styled_components4.css`
    font-size: 15px;
    line-height: 20px;
  `,
  description: import_styled_components4.css`
    font-size: 14px;
    line-height: 24px;
  `,
  descriptionCompact: import_styled_components4.css`
    font-size: 14px;
    line-height: 20px;
  `,
  caption: import_styled_components4.css`
    font-size: 13px;
    line-height: 20px;
  `,
  captionCompact: import_styled_components4.css`
    font-size: 13px;
    line-height: 16px;
  `,
  button: import_styled_components4.css`
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    letter-spacing: 1px;
    text-transform: uppercase;
  `,
  buttonLarge: import_styled_components4.css`
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    letter-spacing: 1px;
    text-transform: uppercase;
  `,
  label: import_styled_components4.css`
    font-size: 11px;
    line-height: 16px;
    font-weight: 500;
    letter-spacing: 0.4px;
    text-transform: uppercase;
  `,
  labelMini: import_styled_components4.css`
    font-size: 10px;
    line-height: 16px;
    font-weight: 500;
    letter-spacing: 0.4px;
    text-transform: uppercase;
  `,
  notification: import_styled_components4.css`
    font-size: 11px;
    line-height: 16px;
  `
};

// src/tokens/tokens.ts
var tokens = {
  colors,
  gradients,
  palettes,
  typography,
  misc: {
    transitionDurationSm: "80ms",
    transitionDurationMd: "120ms",
    transitionDurationLg: "160ms",
    borderRadiusSm: "4px",
    borderRadiusMd: "6px"
  }
};

// src/libs/styled/lightTheme.ts
var lightTheme = tokens;

// src/libs/styled/GlobalStyle.tsx
var import_styled_components5 = require("styled-components");
var overrideTypography = import_styled_components5.css`
  body {
    ${(p2) => p2.theme.typography.graphikFontFamily};
    ${(p2) => p2.theme.typography.body};
    color: ${(p2) => p2.theme.colors.text};
  }

  p {
    margin: 0 0 16px 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
var GlobalStyle = import_styled_components5.createGlobalStyle`
  * {
    outline: none;
  }
  ${overrideTypography};
`;

// src/components/Spinner/Spinner.tsx
var colorMap = makeSafetyMap([
  ["gray", lightTheme.colors.stroke],
  ["blue", lightTheme.colors.brand],
  ["black", lightTheme.colors.text],
  ["white", lightTheme.colors.white],
  ["inherit", "inherit"]
]);
var rotateAnimation = import_styled_components6.keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`;
var StyledSpinner = import_styled_components6.default.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 2px;
  box-sizing: border-box;
`;
var Spin = import_styled_components6.default.div`
  width: 100%;
  height: 100%;
  border: 2px solid transparent;
  border-bottom-color: ${(p2) => colorMap.get(p2.$color)};
  border-radius: 50%;
  flex-shrink: 0;
  animation: ${rotateAnimation} 750ms linear infinite;
`;
var Spinner = ({ size = 16, color: color2 = "gray" }) => /* @__PURE__ */ import_react5.default.createElement(StyledSpinner, {
  style: { width: size, height: size }
}, /* @__PURE__ */ import_react5.default.createElement(Spin, {
  $color: color2
}));

// src/components/BrandArea/BrandArea.tsx
var entryAnimation = import_styled_components7.keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
`;
var StyledBrandArea = import_styled_components7.default.div`
  background-image: url(${require_xsolla_pattern()});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: ${(p2) => p2.theme.colors.brand};
  color: ${(p2) => p2.theme.colors.white};
  box-shadow: 0 8px 32px rgba(196, 200, 204, 0.48), 0 1px 4px rgba(0, 36, 77, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: 64px;
  border-radius: 8px;
  box-sizing: border-box;
`;
var Entry = import_styled_components7.default.div`
  max-width: 468px;
  animation: ${entryAnimation} ease-in-out 80ms;
`;
var BrandArea = (0, import_react6.forwardRef)(function forwardedBrandArea({ children, fetching = false }, ref) {
  return /* @__PURE__ */ import_react6.default.createElement(StyledBrandArea, {
    ref
  }, /* @__PURE__ */ import_react6.default.createElement(Entry, null, fetching ? /* @__PURE__ */ import_react6.default.createElement(Spinner, {
    size: 24,
    color: "inherit"
  }) : children));
});

// src/components/Button/Button.tsx
var import_react7 = __toESM(require("react"));

// src/components/Button/styled.ts
var import_styled_components8 = __toESM(require("styled-components"));
var sizeMap = makeSafetyMap([
  ["md", { height: 44, padding: 32, fontSize: 12 }],
  ["sm", { height: 36, padding: 24, fontSize: 12 }],
  ["lg", { height: 52, padding: 44, fontSize: 14 }]
]);
var makeBasicLook = (palette) => import_styled_components8.css`
  background-color: ${palette.regular};
  border-color: ${palette.regular};
  color: ${(p2) => p2.theme.colors.white};
  border-radius: 40px;
  box-shadow: 0 4px 16px ${palette.overlay};

  &[data-hovered='true'],
  &:hover {
    background-color: ${palette.dark};
    border-color: ${palette.dark};
    box-shadow: 0 8px 16px ${palette.overlay};
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px ${palette.overlay};
  }

  &[disabled] {
    pointer-events: none;
    background-color: ${(p2) => p2.theme.colors.stroke};
    border-color: ${(p2) => p2.theme.colors.stroke};
    color: ${(p2) => p2.theme.colors.white};
    box-shadow: none;
  }
`;
var makeTertiaryLook = (palette) => import_styled_components8.css`
  background-color: transparent;
  border-color: ${palette.regular};
  color: ${palette.regular};
  border-radius: 40px;

  &[data-hovered='true'],
  &:hover {
    background-color: ${palette.transparent};
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px ${palette.overlay};
  }

  &[disabled] {
    pointer-events: none;
    background-color: ${(p2) => p2.theme.colors.stroke};
    border-color: ${(p2) => p2.theme.colors.stroke};
    color: ${(p2) => p2.theme.colors.white};
    box-shadow: none;
  }
`;
var makeLinkLook = (palette) => import_styled_components8.css`
  ${(p2) => p2.theme.typography.subHeader2};

  background-color: transparent;
  border: none;
  padding: 0;
  color: ${palette.regular};
  height: 24px;
  text-transform: none;
  letter-spacing: 0;
  border-radius: ${(p2) => p2.theme.misc.borderRadiusSm};

  &[data-hovered='true'],
  &:hover {
    color: ${palette.dark};
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px ${palette.overlay};
  }

  &[disabled] {
    pointer-events: none;
    color: ${(p2) => p2.theme.colors.stroke};
  }
`;
var makeIconLook = (palette) => import_styled_components8.css`
  background-color: transparent;
  border: none;
  justify-content: center;
  padding: 0;
  color: inherit;
  width: 24px;
  height: 24px;
  border-radius: ${(p2) => p2.theme.misc.borderRadiusSm};

  &[data-hovered='true'],
  &:hover {
    color: ${palette.dark};
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px ${palette.overlay};
  }

  &[disabled] {
    pointer-events: none;
    color: ${(p2) => p2.theme.colors.stroke};
  }
`;
var StyledButton = import_styled_components8.default.button`
  ${(p2) => p2.theme.typography.graphikFontFamily};
  ${(p2) => p2.theme.typography.button};

  position: relative;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  font-size: ${(p2) => sizeMap.get(p2.$size).fontSize}px;
  height: ${(p2) => sizeMap.get(p2.$size).height}px;
  padding: ${(p2) => `0 ${sizeMap.get(p2.$size).padding}px`};
  margin: 0;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
  transition: background-color ease-in-out 80ms, border-color ease-in-out 80ms,
    color ease-in-out 80ms, box-shadow ease-in-out 80ms, transform ease-in-out 80ms;

  ${(p2) => p2.$look === "default" && makeBasicLook(p2.theme.palettes[p2.$palette])}
  ${(p2) => p2.$look === "tertiary" && makeTertiaryLook(p2.theme.palettes[p2.$palette])}
  ${(p2) => p2.$look === "link" && makeLinkLook(p2.theme.palettes[p2.$palette])}
  ${(p2) => p2.$look === "icon" && makeIconLook(p2.theme.palettes[p2.$palette])}

  ${(p2) => p2.fetching && import_styled_components8.css`
      pointer-events: none;
      ${LabelWrapper} {
        filter: blur(12px);
        opacity: 0.4;
      }
    `}

  &:active {
    transform: scale(0.98);
  }
`;
var FetchingWrapper = import_styled_components8.default.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
var LabelWrapper = import_styled_components8.default.div`
  display: flex;
  align-items: center;

  svg {
    display: flex;
  }

  svg + span {
    margin-left: 4px;
  }

  span + svg {
    margin-left: 4px;
  }
`;

// src/components/Button/Button.tsx
var Button = (0, import_react7.forwardRef)(function forwardedButton({
  children,
  palette = "action",
  look = "default",
  size = "md",
  fetching = false,
  disabled = false,
  hovered = false,
  ...rest
}, ref) {
  if ((look == null ? void 0 : look.includes("-icon")) && typeof children !== "object") {
    throw Error("You must pass the icon to the button as a component.");
  }
  return /* @__PURE__ */ import_react7.default.createElement(StyledButton, {
    ref,
    $palette: palette,
    $look: look,
    $size: size,
    fetching,
    disabled,
    "data-hovered": hovered,
    ...rest
  }, fetching && /* @__PURE__ */ import_react7.default.createElement(FetchingWrapper, null, /* @__PURE__ */ import_react7.default.createElement(Spinner, {
    color: "inherit"
  })), /* @__PURE__ */ import_react7.default.createElement(LabelWrapper, null, children));
});

// src/components/ButtonInput/ButtonInput.tsx
var import_react8 = __toESM(require("react"));
var import_ui_icons = require("@xsolla/ui-icons");

// src/components/ButtonInput/styled.ts
var import_styled_components9 = __toESM(require("styled-components"));
var Icon = import_styled_components9.default.div`
  border-right: 1px solid ${(p2) => p2.theme.colors.stroke};
  display: flex;
  padding-right: 6px;
  margin-right: 8px;
  margin-left: -4px;
  color: ${(p2) => p2.theme.colors.muted};
  pointer-events: none;
  transition: border-color ease-in-out 80ms, color ease-in-out 80ms;
`;
var states = {
  hover: import_styled_components9.css`
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.brand};
    ${Icon} {
      border-right-color: ${(p2) => p2.theme.palettes.brand.overlay};
      color: ${(p2) => p2.theme.colors.brand};
    }
  `,
  focus: import_styled_components9.css`
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.brand};
    box-shadow: inset 0 0 0 1px ${(p2) => p2.theme.colors.brand};
    ${Icon} {
      border-right-color: ${(p2) => p2.theme.palettes.brand.overlay};
      color: ${(p2) => p2.theme.colors.brand};
    }
  `,
  idle: import_styled_components9.css`
    background-color: ${(p2) => p2.theme.colors.tableCell};
    pointer-events: none;
  `,
  error: import_styled_components9.css`
    border-color: ${(p2) => p2.theme.colors.danger};
    color: ${(p2) => p2.theme.colors.danger};
    ${Icon} {
      border-right-color: ${(p2) => p2.theme.palettes.danger.overlay};
      color: ${(p2) => p2.theme.colors.danger};
    }
  `,
  disabled: import_styled_components9.css`
    background-color: ${(p2) => p2.theme.colors.overlay};
    border-color: ${(p2) => p2.theme.colors.stroke};
    color: ${(p2) => p2.theme.colors.disabled};
    pointer-events: none;
    ${Icon} {
      border-right-color: ${(p2) => p2.theme.palettes.muted.overlay};
      color: ${(p2) => p2.theme.colors.disabled};
    }
  `
};
var StyledButtonInput = import_styled_components9.default.button`
  ${(p2) => p2.theme.typography.graphikFontFamily};
  ${(p2) => p2.theme.typography.body};

  background-color: ${(p2) => p2.theme.colors.white};
  border: 1px solid ${(p2) => p2.theme.colors.stroke};
  display: flex;
  align-items: center;
  padding: 5px 12px;
  margin: 0;
  cursor: pointer;
  color: ${(p2) => p2.theme.colors.text};
  white-space: nowrap;
  border-radius: ${(p2) => p2.theme.misc.borderRadiusMd};
  box-shadow: inset 0 0 0 1px transparent;
  user-select: none;
  transition: background-color ease-in-out 80ms, border-color ease-in-out 80ms,
    color ease-in-out 80ms, box-shadow ease-in-out 80ms;

  ${(p2) => p2.$idle && states.idle}
  ${(p2) => p2.$error && states.error}
  ${(p2) => p2.$hovered && states.hover}

  &:hover {
    ${states.hover}
  }

  &:focus {
    ${states.focus}
  }

  &[disabled] {
    ${states.disabled}
  }
`;

// src/components/ButtonInput/ButtonInput.tsx
var ButtonInput = (0, import_react8.forwardRef)(function forwardedButtonInput({
  children,
  extra,
  disabled = false,
  hovered = false,
  idle = false,
  error = false,
  ...rest
}, ref) {
  const isXsollaIcon = (0, import_ui_icons.useIsXsollaIcon)(extra);
  return /* @__PURE__ */ import_react8.default.createElement(StyledButtonInput, {
    ...rest,
    ref,
    disabled,
    $hovered: hovered,
    $idle: idle,
    $error: error,
    type: "button"
  }, extra && /* @__PURE__ */ import_react8.default.createElement(Icon, null, isXsollaIcon ? (0, import_react8.createElement)(extra, { size: 24 }) : (0, import_react8.createElement)(extra)), /* @__PURE__ */ import_react8.default.createElement("span", null, children));
});

// src/components/ButtonMore/ButtonMore.tsx
var import_react39 = __toESM(require("react"));
var import_ui_icons2 = require("@xsolla/ui-icons");

// src/components/ButtonMore/styled.tsx
var import_styled_components10 = __toESM(require("styled-components"));
var StyledButtonMore = import_styled_components10.default.div`
  position: relative;
  display: inline-flex;
`;
var Trigger = import_styled_components10.default.button`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background-color: transparent;
  border: none;
  width: 46px;
  padding: 0 2px 0 0;
  border-radius: 0 40px 40px 0;
  color: ${(p2) => p2.theme.colors.white};
  cursor: pointer;
  transition: background-color ease-in-out 80ms, box-shadow ease-in-out 80ms;

  ${(p2) => p2.hovered && import_styled_components10.css`
      background-color: ${p2.palette.dark};
      &:after {
        opacity: 0;
      }
    `}

  &:hover {
    background-color: ${(p2) => p2.palette.dark};
  }

  &:hover:after {
    opacity: 0;
  }

  &:active {
    box-shadow: 0 8px 16px ${(p2) => p2.palette.overlay};
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px red;
  }

  &:after {
    background-color: rgba(255, 255, 255, 0.2);
    position: absolute;
    left: 0;
    top: 12px;
    bottom: 12px;
    width: 1px;
    content: '';
    transition: opacity ease-in-out 80ms;
  }

  &[disabled] {
    pointer-events: none;
  }
`;
var Expander = import_styled_components10.default.div`
  position: relative;
  width: 32px;
  height: 20px;
  flex-shrink: 0;
`;

// src/components/Popper/Popper.tsx
var import_react38 = __toESM(require("react"));

// ../../node_modules/react-laag/dist/react-laag.esm.js
var import_react9 = require("react");
var import_react_dom = require("react-dom");

// ../../node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = false;
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }
    var text = "Warning: " + message;
    if (typeof console !== "undefined") {
      console.warn(text);
    }
    try {
      throw Error(text);
    } catch (x2) {
    }
  }
}
var tiny_warning_esm_default = warning;

// ../../node_modules/react-laag/dist/react-laag.esm.js
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
function _createForOfIteratorHelperLoose(o2, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it)
    return (it = it.call(o2)).next.bind(it);
  if (Array.isArray(o2) || (it = _unsupportedIterableToArray(o2)) || allowArrayLike && o2 && typeof o2.length === "number") {
    if (it)
      o2 = it;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length)
        return {
          done: true
        };
      return {
        done: false,
        value: o2[i2++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useTrackRef(onRefChange) {
  var storedReference = (0, import_react9.useRef)(null);
  function setter(element) {
    if (!element || element === storedReference.current) {
      return;
    }
    storedReference.current = element;
    onRefChange(element);
  }
  return setter;
}
function useMutableStore(initialState) {
  var state = (0, import_react9.useRef)(initialState);
  return (0, import_react9.useMemo)(function() {
    function set(setter) {
      if (typeof setter === "function") {
        state.current = setter(state.current);
      } else {
        state.current = setter;
      }
    }
    function get() {
      return state.current;
    }
    return [get, set];
  }, []);
}
function useEventSubscriptions() {
  var subscriptions = (0, import_react9.useRef)([]);
  return (0, import_react9.useMemo)(function() {
    function hasEventSubscriptions() {
      return subscriptions.current.length > 0;
    }
    function removeAllEventSubscriptions() {
      for (var _iterator = _createForOfIteratorHelperLoose(subscriptions.current), _step; !(_step = _iterator()).done; ) {
        var unsubscribe = _step.value;
        unsubscribe();
      }
      subscriptions.current = [];
    }
    function addEventSubscription(unsubscriber) {
      subscriptions.current.push(unsubscriber);
    }
    return {
      hasEventSubscriptions,
      removeAllEventSubscriptions,
      addEventSubscription
    };
  }, []);
}
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? import_react9.useLayoutEffect : import_react9.useEffect;
function useLastState(currentState, enabled) {
  var lastState = (0, import_react9.useRef)(currentState);
  if (!enabled) {
    lastState.current = null;
    return lastState;
  }
  lastState.current = currentState;
  return lastState;
}
function getPixelValue(value) {
  return parseFloat(value.replace("px", ""));
}
function limit(value, min, max) {
  return value < min ? min : value > max ? max : value;
}
function isSet(value) {
  return value === null || value === void 0 ? false : true;
}
function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function(element) {
    for (var _iterator = _createForOfIteratorHelperLoose(refs), _step; !(_step = _iterator()).done; ) {
      var ref = _step.value;
      if (!ref) {
        continue;
      }
      if (typeof ref === "function") {
        ref(element);
      } else {
        ref.current = element;
      }
    }
  };
}
function getResizeObserver(environment, polyfill) {
  if (typeof environment === "undefined") {
    return void 0;
  }
  return polyfill || environment.ResizeObserver;
}
function findScrollContainers(element, environment) {
  var result = [];
  if (!element || !environment || element === document.body) {
    return result;
  }
  var _environment$getCompu = environment.getComputedStyle(element), overflow = _environment$getCompu.overflow, overflowX = _environment$getCompu.overflowX, overflowY = _environment$getCompu.overflowY;
  if ([overflow, overflowX, overflowY].some(function(prop) {
    return ["auto", "scroll"].includes(prop);
  })) {
    result.push(element);
  }
  return [].concat(result, findScrollContainers(element.parentElement, environment));
}
function createReferenceError(subject) {
  return "react-laag: Could not find a valid reference for the " + subject + " element. There might be 2 causes:\n   - Make sure that the 'ref' is set correctly on the " + subject + ' element when isOpen: true. Also make sure your component forwards the ref with "forwardRef()".\n   - Make sure that you are actually rendering the ' + subject + " when the isOpen prop is set to true";
}
function useTrackElements(_ref) {
  var enabled = _ref.enabled, onChange = _ref.onChange, environment = _ref.environment, ResizeObserverPolyfill = _ref.ResizeObserverPolyfill, overflowContainer = _ref.overflowContainer, triggerOption = _ref.triggerOption;
  var ResizeObserver = getResizeObserver(environment, ResizeObserverPolyfill);
  (0, import_react9.useEffect)(function() {
    true ? tiny_warning_esm_default(ResizeObserver, "This browser does not support ResizeObserver out of the box. We recommend to add a polyfill in order to utilize the full capabilities of react-laag. See: https://github.com/everweij/react-laag#resize-observer") : void 0;
  }, [ResizeObserver]);
  var arrowRef = (0, import_react9.useRef)(null);
  var hasTriggerOption = Boolean(triggerOption);
  var _useMutableStore = useMutableStore({
    scrollContainers: [],
    trigger: null,
    layer: null
  }), get = _useMutableStore[0], set = _useMutableStore[1];
  var _useEventSubscription = useEventSubscriptions(), hasEventSubscriptions = _useEventSubscription.hasEventSubscriptions, addEventSubscription = _useEventSubscription.addEventSubscription, removeAllEventSubscriptions = _useEventSubscription.removeAllEventSubscriptions;
  var handleChange = (0, import_react9.useCallback)(function handleChange2() {
    var _get = get(), layer = _get.layer, trigger = _get.trigger, scrollContainers = _get.scrollContainers;
    var closestScrollContainer = scrollContainers[0];
    if (!layer) {
      throw new Error(createReferenceError("layer"));
    }
    if (!trigger && !hasTriggerOption) {
      throw new Error(createReferenceError("trigger"));
    }
    var scrollOffsets = {
      top: 0,
      left: 0
    };
    if (closestScrollContainer) {
      var scrollLeft = closestScrollContainer.scrollLeft, scrollTop = closestScrollContainer.scrollTop;
      scrollOffsets = {
        top: scrollTop,
        left: scrollLeft
      };
    } else {
      var scrollX = environment.scrollX, scrollY = environment.scrollY;
      scrollOffsets = {
        top: scrollY,
        left: scrollX
      };
    }
    var borderOffsets = {
      left: 0,
      top: 0
    };
    if (closestScrollContainer) {
      var _environment$getCompu2 = environment.getComputedStyle(closestScrollContainer), borderLeftWidth = _environment$getCompu2.borderLeftWidth, borderTopWidth = _environment$getCompu2.borderTopWidth;
      borderOffsets = {
        left: getPixelValue(borderLeftWidth) || 0,
        top: getPixelValue(borderTopWidth) || 0
      };
    }
    onChange({
      layer,
      trigger,
      scrollContainers,
      arrow: arrowRef.current
    }, scrollOffsets, borderOffsets);
  }, [get, onChange, environment, arrowRef, hasTriggerOption]);
  var addEventListeners = (0, import_react9.useCallback)(function addEventListeners2() {
    var _get2 = get(), trigger = _get2.trigger, layer = _get2.layer, scrollContainers = _get2.scrollContainers;
    if (!layer) {
      throw new Error(createReferenceError("layer"));
    }
    if (!trigger && !hasTriggerOption) {
      throw new Error(createReferenceError("trigger"));
    }
    if (ResizeObserver) {
      var ignoredInitialCall = false;
      var observerCallback = function observerCallback2() {
        if (!ignoredInitialCall) {
          ignoredInitialCall = true;
          return;
        }
        handleChange();
      };
      var observer = new ResizeObserver(observerCallback);
      for (var _i = 0, _arr = [trigger, layer, document.body]; _i < _arr.length; _i++) {
        var element = _arr[_i];
        if (element)
          observer.observe(element);
      }
      addEventSubscription(function() {
        for (var _i2 = 0, _arr2 = [trigger, layer, document.body]; _i2 < _arr2.length; _i2++) {
          var _element = _arr2[_i2];
          if (_element)
            observer.unobserve(_element);
        }
        observer.disconnect();
      });
    }
    var listenForScrollElements = [environment].concat(scrollContainers);
    var _loop = function _loop2() {
      var element2 = _step.value;
      element2.addEventListener("scroll", handleChange);
      addEventSubscription(function() {
        return element2.removeEventListener("scroll", handleChange);
      });
    };
    for (var _iterator = _createForOfIteratorHelperLoose(listenForScrollElements), _step; !(_step = _iterator()).done; ) {
      _loop();
    }
  }, [get, addEventSubscription, handleChange, environment, ResizeObserver, hasTriggerOption]);
  var resetWhenReferenceChangedWhileTracking = (0, import_react9.useCallback)(function(previous, next) {
    if (enabled && previous && previous !== next) {
      removeAllEventSubscriptions();
      addEventListeners();
      handleChange();
    }
  }, [removeAllEventSubscriptions, addEventListeners, handleChange, enabled]);
  var layerRef = useTrackRef((0, import_react9.useCallback)(function(layer) {
    var _get3 = get(), previousLayer = _get3.layer;
    set(function(state) {
      return _extends({}, state, {
        layer
      });
    });
    resetWhenReferenceChangedWhileTracking(previousLayer, layer);
  }, [get, set, resetWhenReferenceChangedWhileTracking]));
  var getScrollContainers = (0, import_react9.useCallback)(function handleScrollContainers(element) {
    var scrollContainers = findScrollContainers(element, environment);
    var closestScrollContainer = scrollContainers[0];
    if (closestScrollContainer) {
      var position = environment.getComputedStyle(closestScrollContainer).position;
      var closestScrollContainerHasCorrectStyling = ["relative", "absolute", "fixed"].includes(position) || overflowContainer;
      if (!closestScrollContainerHasCorrectStyling) {
        closestScrollContainer.style.position = "relative";
      }
      true ? tiny_warning_esm_default(closestScrollContainerHasCorrectStyling, `react-laag: Set the 'position' style of the nearest scroll-container to 'relative', 'absolute' or 'fixed', or set the 'overflowContainer' prop to true. This is needed in order to position the layer properly. Currently the scroll-container is positioned: "` + position + '". For now, "position: relative;" is added for you, but this behavior might be removed in the future. Visit https://react-laag.com/docs/#position-relative for more info.') : void 0;
    }
    return scrollContainers;
  }, [environment, overflowContainer]);
  var triggerRef = useTrackRef((0, import_react9.useCallback)(function(trigger) {
    var scrollContainers = getScrollContainers(trigger);
    var _get4 = get(), previousTrigger = _get4.trigger;
    set(function(state) {
      return _extends({}, state, {
        trigger,
        scrollContainers
      });
    });
    resetWhenReferenceChangedWhileTracking(previousTrigger, trigger);
  }, [get, set, resetWhenReferenceChangedWhileTracking, getScrollContainers]));
  var triggerOptionParent = triggerOption == null ? void 0 : triggerOption.getParent == null ? void 0 : triggerOption.getParent();
  useIsomorphicLayoutEffect(function() {
    if (!triggerOptionParent) {
      return;
    }
    set(function(state) {
      return _extends({}, state, {
        scrollContainers: getScrollContainers(triggerOptionParent)
      });
    });
  }, [triggerOptionParent, set, getScrollContainers]);
  useIsomorphicLayoutEffect(function() {
    if (enabled) {
      if (!hasEventSubscriptions()) {
        addEventListeners();
      }
    }
    return function() {
      if (hasEventSubscriptions()) {
        removeAllEventSubscriptions();
      }
    };
  }, [enabled, hasEventSubscriptions, addEventListeners, removeAllEventSubscriptions]);
  useIsomorphicLayoutEffect(function() {
    if (enabled) {
      handleChange();
    }
  });
  return {
    triggerRef,
    layerRef,
    arrowRef,
    closestScrollContainer: get().scrollContainers[0] || null
  };
}
var GroupContext = /* @__PURE__ */ (0, import_react9.createContext)({});
function GroupProvider(_ref) {
  var children = _ref.children, registrations = _ref.registrations;
  var handleRegister = (0, import_react9.useCallback)(function register(registration) {
    registrations.current.add(registration);
    return function() {
      return registrations.current.delete(registration);
    };
  }, [registrations]);
  return (0, import_react9.createElement)(GroupContext.Provider, {
    value: handleRegister
  }, children);
}
function getShouldCloseAccordingToChildren(registrations, event) {
  for (var _iterator = _createForOfIteratorHelperLoose(registrations), _step; !(_step = _iterator()).done; ) {
    var shouldCloseWhenClickedOutside = _step.value.shouldCloseWhenClickedOutside;
    if (!shouldCloseWhenClickedOutside(event)) {
      return false;
    }
  }
  return true;
}
function useGroup(_ref2) {
  var isOpen = _ref2.isOpen, onOutsideClick = _ref2.onOutsideClick, onParentClose = _ref2.onParentClose;
  var trigger = (0, import_react9.useRef)(null);
  var layer = (0, import_react9.useRef)(null);
  var registrations = (0, import_react9.useRef)(/* @__PURE__ */ new Set());
  var possibleRegisterFn = (0, import_react9.useContext)(GroupContext);
  var shouldCloseWhenClickedOutside = (0, import_react9.useCallback)(function shouldCloseWhenClickedOutside2(event) {
    var target = event.target;
    var clickedOnTrigger = trigger.current && trigger.current.contains(target);
    var clickedOnLayer = layer.current && layer.current.contains(target);
    var shouldCloseAccordingToChildren = getShouldCloseAccordingToChildren(registrations.current, event);
    if (clickedOnLayer && shouldCloseAccordingToChildren) {
      registrations.current.forEach(function(_ref3) {
        var closeChild = _ref3.closeChild;
        return closeChild();
      });
    }
    return !clickedOnTrigger && !clickedOnLayer && shouldCloseAccordingToChildren;
  }, [trigger, layer, registrations]);
  (0, import_react9.useEffect)(function() {
    if (typeof possibleRegisterFn !== "function") {
      return;
    }
    return possibleRegisterFn({
      shouldCloseWhenClickedOutside,
      closeChild: function closeChild() {
        true ? tiny_warning_esm_default(onParentClose, "react-laag: You are using useLayer() in a nested setting but forgot to set the 'onParentClose()' callback in the options. This could lead to unexpected behavior.") : void 0;
        if (onParentClose) {
          onParentClose();
        }
      }
    });
  }, [possibleRegisterFn, shouldCloseWhenClickedOutside, onParentClose, registrations]);
  (0, import_react9.useEffect)(function() {
    var isChild = typeof possibleRegisterFn === "function";
    var shouldNotListen = !isOpen || !onOutsideClick || isChild;
    if (shouldNotListen) {
      return;
    }
    function handleClick(event) {
      if (shouldCloseWhenClickedOutside(event)) {
        onOutsideClick();
      }
    }
    document.addEventListener("click", handleClick, true);
    return function() {
      return document.removeEventListener("click", handleClick, true);
    };
  }, [isOpen, onOutsideClick, shouldCloseWhenClickedOutside, possibleRegisterFn]);
  (0, import_react9.useEffect)(function() {
    if (!isOpen) {
      registrations.current.forEach(function(_ref4) {
        var closeChild = _ref4.closeChild;
        return closeChild();
      });
    }
  }, [isOpen]);
  return {
    closeOnOutsideClickRefs: {
      trigger,
      layer
    },
    registrations
  };
}
var PLACEMENT_TYPES = ["bottom-start", "bottom-end", "bottom-center", "top-start", "top-center", "top-end", "left-end", "left-center", "left-start", "right-end", "right-center", "right-start", "center"];
var OPPOSITES = {
  top: "bottom",
  left: "right",
  bottom: "top",
  right: "left",
  center: "center"
};
var SideBase = /* @__PURE__ */ function() {
  function SideBase2(prop, opposite, isHorizontal, sizeProp, oppositeSizeProp, cssProp, oppositeCssProp, isCenter, isPush) {
    this.prop = void 0;
    this.opposite = void 0;
    this.isHorizontal = void 0;
    this.sizeProp = void 0;
    this.oppositeSizeProp = void 0;
    this.cssProp = void 0;
    this.oppositeCssProp = void 0;
    this.isCenter = void 0;
    this.isPush = void 0;
    this.prop = prop;
    this.opposite = opposite;
    this.isHorizontal = isHorizontal;
    this.sizeProp = sizeProp;
    this.oppositeSizeProp = oppositeSizeProp;
    this.cssProp = cssProp;
    this.oppositeCssProp = oppositeCssProp;
    this.isCenter = isCenter;
    this.isPush = isPush;
  }
  var _proto = SideBase2.prototype;
  _proto.factor = function factor(value) {
    return value * (this.isPush ? 1 : -1);
  };
  _proto.isOppositeDirection = function isOppositeDirection(side) {
    return this.isHorizontal !== side.isHorizontal;
  };
  return SideBase2;
}();
function createSide(prop, recursive) {
  if (recursive === void 0) {
    recursive = true;
  }
  var isHorizontal = ["left", "right"].includes(prop);
  return new SideBase(prop, recursive ? createSide(OPPOSITES[prop], false) : null, isHorizontal, isHorizontal ? "width" : "height", isHorizontal ? "height" : "width", isHorizontal ? "left" : "top", isHorizontal ? "top" : "left", prop === "center", !["right", "bottom"].includes(prop));
}
var BoundSide = {
  top: /* @__PURE__ */ createSide("top"),
  bottom: /* @__PURE__ */ createSide("bottom"),
  left: /* @__PURE__ */ createSide("left"),
  right: /* @__PURE__ */ createSide("right")
};
var Side = /* @__PURE__ */ _extends({}, BoundSide, {
  center: /* @__PURE__ */ createSide("center")
});
var SIDES = ["top", "left", "bottom", "right"];
var BoundsOffsets = /* @__PURE__ */ function() {
  function BoundsOffsets2(offsets) {
    this.top = void 0;
    this.left = void 0;
    this.right = void 0;
    this.bottom = void 0;
    return Object.assign(this, offsets);
  }
  BoundsOffsets2.mergeSmallestSides = function mergeSmallestSides(boundsOffsets) {
    var first = boundsOffsets[0], rest = boundsOffsets.slice(1);
    if (!first) {
      throw new Error("Please provide at least 1 bounds objects in order to merge");
    }
    var result = Object.fromEntries(SIDES.map(function(side2) {
      return [side2, first[side2]];
    }));
    for (var _iterator = _createForOfIteratorHelperLoose(rest), _step; !(_step = _iterator()).done; ) {
      var boundsOffset = _step.value;
      for (var _iterator2 = _createForOfIteratorHelperLoose(SIDES), _step2; !(_step2 = _iterator2()).done; ) {
        var side = _step2.value;
        result[side] = Math.min(result[side], boundsOffset[side]);
      }
    }
    return new BoundsOffsets2(result);
  };
  _createClass(BoundsOffsets2, [{
    key: "allSidesArePositive",
    get: function get() {
      var _this = this;
      return SIDES.every(function(side) {
        return _this[side] >= 0;
      });
    }
  }, {
    key: "negativeSides",
    get: function get() {
      var _this2 = this;
      return Object.fromEntries(SIDES.filter(function(side) {
        return _this2[side] < 0;
      }).map(function(side) {
        return [side, _this2[side]];
      }));
    }
  }]);
  return BoundsOffsets2;
}();
function sumOfPropertyValues() {
  for (var _len = arguments.length, propertyValues = new Array(_len), _key = 0; _key < _len; _key++) {
    propertyValues[_key] = arguments[_key];
  }
  return propertyValues.reduce(function(sum, propertyValue) {
    return sum + (propertyValue ? getPixelValue(propertyValue) : 0);
  }, 0);
}
function boundsToObject(_ref) {
  var top = _ref.top, left = _ref.left, right = _ref.right, bottom = _ref.bottom, width = _ref.width, height = _ref.height;
  return {
    top,
    left,
    right,
    bottom,
    width,
    height
  };
}
var EMPTY = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: 0,
  height: 0
};
var Bounds = /* @__PURE__ */ function() {
  Bounds2.create = function create(bounds) {
    return new Bounds2(bounds);
  };
  Bounds2.fromElement = function fromElement(element, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options, _options$withTransfor = _options.withTransform, withTransform = _options$withTransfor === void 0 ? true : _options$withTransfor, _options$environment = _options.environment, environment = _options$environment === void 0 ? window : _options$environment, _options$withScrollba = _options.withScrollbars, withScrollbars = _options$withScrollba === void 0 ? true : _options$withScrollba;
    var plain = boundsToObject(element.getBoundingClientRect());
    var bounds = new Bounds2(plain);
    if (!withTransform) {
      var _environment$getCompu = environment.getComputedStyle(element), width = _environment$getCompu.width, height = _environment$getCompu.height, boxSizing = _environment$getCompu.boxSizing, borderLeft = _environment$getCompu.borderLeft, borderRight = _environment$getCompu.borderRight, borderTop = _environment$getCompu.borderTop, borderBottom = _environment$getCompu.borderBottom, paddingLeft = _environment$getCompu.paddingLeft, paddingRight = _environment$getCompu.paddingRight, paddingTop = _environment$getCompu.paddingTop, paddingBottom = _environment$getCompu.paddingBottom;
      var boxWidth = boxSizing === "border-box" ? getPixelValue(width) : sumOfPropertyValues(width, borderLeft, borderRight, paddingLeft, paddingRight);
      var boxHeight = boxSizing === "border-box" ? getPixelValue(height) : sumOfPropertyValues(height, borderTop, borderBottom, paddingTop, paddingBottom);
      bounds = new Bounds2(_extends({}, bounds, {
        width: boxWidth,
        height: boxHeight
      }));
    }
    if (!withScrollbars) {
      var scrollbarWidth = bounds.width - element.clientWidth;
      var scrollbarHeight = bounds.height - element.clientHeight;
      return bounds.substract({
        right: scrollbarWidth,
        bottom: scrollbarHeight
      });
    }
    return bounds;
  };
  Bounds2.empty = function empty() {
    return new Bounds2();
  };
  Bounds2.fromWindow = function fromWindow(environment) {
    var _ref2 = environment || {}, _ref2$innerWidth = _ref2.innerWidth, width = _ref2$innerWidth === void 0 ? 0 : _ref2$innerWidth, _ref2$innerHeight = _ref2.innerHeight, height = _ref2$innerHeight === void 0 ? 0 : _ref2$innerHeight;
    return new Bounds2({
      width,
      height,
      right: width,
      bottom: height
    });
  };
  function Bounds2(bounds) {
    if (bounds === void 0) {
      bounds = {};
    }
    this.top = void 0;
    this.left = void 0;
    this.right = void 0;
    this.bottom = void 0;
    this.width = void 0;
    this.height = void 0;
    return Object.assign(this, EMPTY, bounds);
  }
  var _proto = Bounds2.prototype;
  _proto.toObject = function toObject() {
    return boundsToObject(this);
  };
  _proto.merge = function merge(partialBoundsOrMergeFn) {
    var current = this.toObject();
    return new Bounds2(_extends({}, current, typeof partialBoundsOrMergeFn === "function" ? partialBoundsOrMergeFn(current) : partialBoundsOrMergeFn));
  };
  _proto.substract = function substract(bounds) {
    var result = this.toObject();
    var entries = Object.entries(bounds);
    for (var _i = 0, _entries = entries; _i < _entries.length; _i++) {
      var _entries$_i = _entries[_i], prop = _entries$_i[0], value = _entries$_i[1];
      if (prop in BoundSide) {
        var boundSide = BoundSide[prop];
        result[prop] += boundSide.factor(value);
        result[boundSide.isHorizontal ? "width" : "height"] -= value;
      } else {
        result[prop] -= value || 0;
      }
    }
    return new Bounds2(result);
  };
  _proto.offsetsTo = function offsetsTo(child) {
    return new BoundsOffsets({
      top: child.top - this.top,
      bottom: this.bottom - child.bottom,
      left: child.left - this.left,
      right: this.right - child.right
    });
  };
  _proto.mapSides = function mapSides(mapper) {
    var result = this.toObject();
    var boundSides = Object.values(BoundSide);
    for (var _i2 = 0, _boundSides = boundSides; _i2 < _boundSides.length; _i2++) {
      var boundSide = _boundSides[_i2];
      result[boundSide.prop] = mapper(boundSide, result[boundSide.prop]);
    }
    return new Bounds2(result);
  };
  _createClass(Bounds2, [{
    key: "surface",
    get: function get() {
      return this.width * this.height;
    }
  }]);
  return Bounds2;
}();
var Placement = /* @__PURE__ */ function() {
  function Placement2(primary, secondary, subjectBounds, layerDimensions, offsets) {
    this.primary = void 0;
    this.secondary = void 0;
    this.offsets = void 0;
    this.subjectsBounds = void 0;
    this._cachedLayerBounds = null;
    this._cachedContainerOffsets = null;
    this.primary = primary;
    this.secondary = secondary;
    this.offsets = offsets;
    this.setSubjectsBounds(subjectBounds, layerDimensions);
  }
  var _proto = Placement2.prototype;
  _proto.setSubjectsBounds = function setSubjectsBounds(subjectBounds, layerDimensions) {
    if (!layerDimensions) {
      this.subjectsBounds = subjectBounds;
      return;
    }
    var dimensions = typeof layerDimensions === "function" ? layerDimensions(this.primary.prop) : layerDimensions;
    this.subjectsBounds = subjectBounds.merge({
      layer: _extends({}, subjectBounds.layer, dimensions)
    });
  };
  _proto.getLayerBounds = function getLayerBounds(secondaryOffset) {
    if (secondaryOffset === void 0) {
      secondaryOffset = 0;
    }
    if (this._cachedLayerBounds && secondaryOffset === 0) {
      return this._cachedLayerBounds;
    }
    var primary = this.primary, secondary = this.secondary, subjectsBounds = this.subjectsBounds;
    var trigger = subjectsBounds.trigger, layer = subjectsBounds.layer, arrow = subjectsBounds.arrow;
    var isHorizontal = primary.isHorizontal, oppositeCssProp = primary.oppositeCssProp, oppositeSizeProp = primary.oppositeSizeProp, prop = primary.prop, opposite = primary.opposite;
    var result = Bounds.empty();
    result[opposite.prop] = trigger[prop] - primary.factor(this.offsets.trigger);
    result[prop] = result[opposite.prop] - primary.factor(layer[primary.sizeProp]);
    var arrowOffsetBase = this.offsets.arrow * 2;
    var limitMin = trigger[oppositeCssProp] - (layer[oppositeSizeProp] - arrow[oppositeSizeProp]) + arrowOffsetBase;
    var limitMax = trigger[oppositeCssProp] + (trigger[oppositeSizeProp] - arrow[oppositeSizeProp]) - arrowOffsetBase;
    if (!secondary.isPush) {
      limitMin += layer[oppositeSizeProp];
      limitMax += layer[oppositeSizeProp];
    }
    if (secondary.isCenter) {
      var propertyA = (isHorizontal ? BoundSide.top : BoundSide.left).prop;
      var propertyB = (isHorizontal ? BoundSide.bottom : BoundSide.right).prop;
      result[propertyA] = limit(trigger[propertyA] + trigger[oppositeSizeProp] / 2 - layer[oppositeSizeProp] / 2 + secondaryOffset, limitMin, limitMax);
      result[propertyB] = result[propertyA] + layer[oppositeSizeProp];
    } else {
      var sec = secondary;
      var triggerValue = trigger[sec.prop];
      var arrowCompensation = triggerValue < limitMin ? limitMin - triggerValue : triggerValue > limitMax ? limitMax - triggerValue : 0;
      result[sec.prop] = limit(triggerValue + secondaryOffset + arrowCompensation, limitMin, limitMax);
      result[sec.opposite.prop] = result[sec.prop] + secondary.factor(layer[oppositeSizeProp]);
    }
    result.width = result.right - result.left;
    result.height = result.bottom - result.top;
    var layerBounds = Bounds.create(result);
    if (secondaryOffset === 0) {
      this._cachedLayerBounds = layerBounds;
    }
    return layerBounds;
  };
  _proto.getLayerCollisionBounds = function getLayerCollisionBounds() {
    var container = this.offsets.container;
    return this.getLayerBounds().mapSides(function(side, value) {
      return value -= side.factor(container);
    }).merge(function(_ref) {
      var width = _ref.width, height = _ref.height;
      return {
        width: width + container * 2,
        height: height + container * 2
      };
    });
  };
  _proto.getContainerOffsets = function getContainerOffsets(layerBounds) {
    if (this._cachedContainerOffsets && !layerBounds) {
      return this._cachedContainerOffsets;
    }
    var subjectBounds = this.subjectsBounds.merge({
      layer: layerBounds || this.getLayerCollisionBounds()
    });
    var offsets = BoundsOffsets.mergeSmallestSides(subjectBounds.layerOffsetsToScrollContainers);
    if (!layerBounds) {
      this._cachedContainerOffsets = offsets;
    }
    return offsets;
  };
  _createClass(Placement2, [{
    key: "type",
    get: function get() {
      return this.primary.prop + "-" + (this.secondary.prop === "center" ? "center" : ["bottom", "right"].includes(this.secondary.prop) ? "end" : "start");
    }
  }, {
    key: "triggerIsBigger",
    get: function get() {
      var isHorizontal = this.secondary.isHorizontal;
      var _this$subjectsBounds = this.subjectsBounds, triggerHasBiggerWidth = _this$subjectsBounds.triggerHasBiggerWidth, triggerHasBiggerHeight = _this$subjectsBounds.triggerHasBiggerHeight;
      return isHorizontal && triggerHasBiggerWidth || !isHorizontal && triggerHasBiggerHeight;
    }
  }, {
    key: "fitsContainer",
    get: function get() {
      return this.getContainerOffsets().allSidesArePositive;
    }
  }, {
    key: "visibleSurface",
    get: function get() {
      var layerBounds = this.getLayerBounds();
      var containerOffsets = this.getContainerOffsets(layerBounds);
      var substract = containerOffsets.negativeSides;
      for (var side in substract) {
        substract[side] = -substract[side];
      }
      return layerBounds.substract(substract).surface;
    }
  }, {
    key: "secondaryOffsetSide",
    get: function get() {
      var _Object$entries$map$f, _Object$entries$map$f2, _this = this;
      var containerOffsets = this.getContainerOffsets();
      var _ref2 = (_Object$entries$map$f = (_Object$entries$map$f2 = Object.entries(containerOffsets.negativeSides).map(function(_ref3) {
        var side = _ref3[0], value = _ref3[1];
        return [BoundSide[side], value];
      }).filter(function(_ref4) {
        var side = _ref4[0];
        return _this.primary.isOppositeDirection(side);
      }).sort(function(_ref5, _ref6) {
        var a3 = _ref5[1];
        var b3 = _ref6[1];
        return b3 - a3;
      })) == null ? void 0 : _Object$entries$map$f2[0]) != null ? _Object$entries$map$f : [], mostNegativeSide = _ref2[0];
      return mostNegativeSide || null;
    }
  }]);
  return Placement2;
}();
var PlacementCenter = /* @__PURE__ */ function(_Placement) {
  _inheritsLoose(PlacementCenter2, _Placement);
  function PlacementCenter2() {
    return _Placement.apply(this, arguments) || this;
  }
  var _proto2 = PlacementCenter2.prototype;
  _proto2.getLayerBounds = function getLayerBounds() {
    var _this$subjectsBounds2 = this.subjectsBounds, trigger = _this$subjectsBounds2.trigger, layer = _this$subjectsBounds2.layer;
    var result = Bounds.empty();
    result.top = trigger.top + trigger.height / 2 - layer.height / 2;
    result.bottom = result.top + layer.height;
    result.left = trigger.left + trigger.width / 2 - layer.width / 2;
    result.right = result.left + layer.width;
    result.width = result.right - result.left;
    result.height = result.bottom - result.top;
    return result;
  };
  return PlacementCenter2;
}(Placement);
function getNegativeOffsetBetweenLayerCenterAndTrigger(subjectsBounds, placement, arrowOffset) {
  var layer = subjectsBounds.layer, trigger = subjectsBounds.trigger, arrow = subjectsBounds.arrow;
  var sizeProperty = placement.primary.oppositeSizeProp;
  var _ref = !placement.primary.isHorizontal ? ["left", "right"] : ["top", "bottom"], sideA = _ref[0], sideB = _ref[1];
  var offsetA = layer[sideA] + layer[sizeProperty] / 2 - trigger[sideA] - arrow[sizeProperty] / 2 - arrowOffset;
  var offsetB = layer[sideB] - layer[sizeProperty] / 2 - trigger[sideB] + arrow[sizeProperty] / 2 + arrowOffset;
  return (offsetA < 0 ? -offsetA : 0) + (offsetB > 0 ? -offsetB : 0);
}
var STYLE_BASE = {
  position: "absolute",
  willChange: "top, left",
  left: null,
  right: null,
  top: null,
  bottom: null
};
function getArrowStyle(subjectsBounds, placement, arrowOffset) {
  var _extends2;
  if (placement.primary.isCenter) {
    return STYLE_BASE;
  }
  var layer = subjectsBounds.layer, trigger = subjectsBounds.trigger, arrow = subjectsBounds.arrow;
  var sizeProperty = placement.primary.oppositeSizeProp;
  var triggerIsBigger = trigger[sizeProperty] > layer[sizeProperty];
  var min = arrowOffset + arrow[sizeProperty] / 2;
  var max = layer[sizeProperty] - arrow[sizeProperty] / 2 - arrowOffset;
  var negativeOffset = getNegativeOffsetBetweenLayerCenterAndTrigger(subjectsBounds, placement, arrowOffset);
  var primarySide = placement.primary.prop;
  var secondarySide = placement.primary.oppositeCssProp;
  var secondaryValue = triggerIsBigger ? layer[sizeProperty] / 2 + negativeOffset : trigger[secondarySide] + trigger[sizeProperty] / 2 - layer[secondarySide];
  return _extends({}, STYLE_BASE, (_extends2 = {}, _extends2[primarySide] = "100%", _extends2[secondarySide] = limit(secondaryValue, min, max), _extends2));
}
var Placements = /* @__PURE__ */ function() {
  function Placements2(placements, config, subjectsBounds) {
    this.placements = void 0;
    this.config = void 0;
    this.subjectsBounds = void 0;
    this.placements = placements;
    this.config = config;
    this.subjectsBounds = subjectsBounds;
  }
  Placements2.getSidesFromPlacementType = function getSidesFromPlacementType(type) {
    var _type$split = type.split("-"), a3 = _type$split[0], b3 = _type$split[1];
    var primary = BoundSide[a3];
    var secondary;
    if (b3 === "center") {
      secondary = Side.center;
    } else if (primary.isHorizontal) {
      secondary = b3 === "start" ? Side.top : Side.bottom;
    } else {
      secondary = b3 === "start" ? Side.left : Side.right;
    }
    return [primary, secondary];
  };
  Placements2.create = function create(subjectsBounds, config) {
    var offsets = {
      arrow: config.arrowOffset,
      container: config.containerOffset,
      trigger: config.triggerOffset
    };
    function getListOfPlacements(preferedPlacement) {
      if (preferedPlacement === void 0) {
        preferedPlacement = config.placement;
      }
      var _Placements$getSidesF = Placements2.getSidesFromPlacementType(preferedPlacement), primary = _Placements$getSidesF[0], secondary = _Placements$getSidesF[1];
      var preferredSide = BoundSide[primary.isHorizontal ? config.preferY : config.preferX];
      var triggerIsBigger = !primary.isHorizontal && subjectsBounds.triggerHasBiggerWidth || primary.isHorizontal && subjectsBounds.triggerHasBiggerHeight;
      function placementFrom(primary2, secondary2) {
        return new Placement(primary2, secondary2, subjectsBounds, config.layerDimensions, offsets);
      }
      var list = [];
      list[0] = placementFrom(primary, secondary);
      list[1] = placementFrom(primary, secondary.isCenter ? preferredSide : Side.center);
      list[2] = placementFrom(primary, Side[(secondary.opposite.isCenter ? preferredSide.opposite : secondary.opposite).prop]);
      list[3] = placementFrom(preferredSide, triggerIsBigger ? primary : Side[primary.opposite.prop]);
      list[4] = placementFrom(preferredSide, Side.center);
      list[5] = placementFrom(preferredSide, triggerIsBigger ? Side[primary.opposite.prop] : primary);
      list[6] = placementFrom(BoundSide[preferredSide.opposite.prop], triggerIsBigger ? primary : Side[primary.opposite.prop]);
      list[7] = placementFrom(BoundSide[preferredSide.opposite.prop], Side.center);
      list[8] = placementFrom(BoundSide[preferredSide.opposite.prop], triggerIsBigger ? Side[primary.opposite.prop] : primary);
      list[9] = placementFrom(BoundSide[primary.opposite.prop], secondary);
      list[10] = placementFrom(BoundSide[primary.opposite.prop], secondary.isCenter ? preferredSide : Side.center);
      list[11] = placementFrom(BoundSide[primary.opposite.prop], Side[(secondary.opposite.isCenter ? preferredSide.opposite : secondary.opposite).prop]);
      list = list.filter(function(placement) {
        return placement.type === config.placement || config.possiblePlacements.includes(placement.type);
      });
      return list;
    }
    if (config.placement === "center") {
      return new Placements2([new PlacementCenter(Side.center, Side.center, subjectsBounds, config.layerDimensions, offsets)].concat(getListOfPlacements(config.preferY + "-" + config.preferX)), config, subjectsBounds);
    }
    return new Placements2(getListOfPlacements(), config, subjectsBounds);
  };
  var _proto = Placements2.prototype;
  _proto.filterPlacementsBySide = function filterPlacementsBySide(side) {
    return this.placements.filter(function(placement) {
      return placement.primary === side;
    });
  };
  _proto.findFirstPlacementThatFits = function findFirstPlacementThatFits() {
    return this.placements.find(function(placement) {
      return placement.fitsContainer;
    });
  };
  _proto.placementWithBiggestVisibleSurface = function placementWithBiggestVisibleSurface() {
    var _this$placements$map$ = this.placements.map(function(placement) {
      return {
        placement,
        surface: placement.visibleSurface
      };
    }).sort(function(a3, b3) {
      return b3.surface - a3.surface;
    }), placementWithBiggestSurface = _this$placements$map$[0].placement;
    return placementWithBiggestSurface;
  };
  _proto.findSuitablePlacement = function findSuitablePlacement() {
    if (!this.config.auto) {
      return this.placements[0];
    }
    return this.findFirstPlacementThatFits() || this.placementWithBiggestVisibleSurface();
  };
  _proto.getSecondaryOffset = function getSecondaryOffset(placement) {
    var _this$config = this.config, auto2 = _this$config.auto, snap = _this$config.snap;
    if (!auto2 || snap || placement instanceof PlacementCenter) {
      return 0;
    }
    var placementsOnSameSide = this.filterPlacementsBySide(placement.primary);
    var currentPlacementHasHighestPriority = placementsOnSameSide.indexOf(placement) === 0;
    if (currentPlacementHasHighestPriority && placement.fitsContainer) {
      return 0;
    }
    var firstPlacementThatDoesNotFit = placementsOnSameSide.find(function(placement2) {
      return !placement2.fitsContainer;
    });
    if (!firstPlacementThatDoesNotFit) {
      return 0;
    }
    var secondaryOffsetSide = firstPlacementThatDoesNotFit.secondaryOffsetSide;
    if (!secondaryOffsetSide) {
      return 0;
    }
    var containerOffsets = placement.getContainerOffsets();
    var secondary = placement.secondary;
    var factor;
    if (placement.triggerIsBigger || firstPlacementThatDoesNotFit === placement) {
      factor = secondaryOffsetSide.isPush ? -1 : 1;
    } else {
      factor = secondary === Side.left || [Side.top, Side.center].includes(secondary) && secondaryOffsetSide.isPush ? -1 : 1;
    }
    var secondaryOffset = containerOffsets[secondaryOffsetSide.prop];
    return secondaryOffset * factor;
  };
  _proto.getStyles = function getStyles(layerBounds, placement, scrollOffsets, borderOffsets) {
    var layerStyleBase = {
      willChange: "top, left, width, height"
    };
    var arrow = getArrowStyle(this.subjectsBounds.merge({
      layer: layerBounds
    }), placement, this.config.arrowOffset);
    var layer = this.config.overflowContainer ? _extends({}, layerStyleBase, {
      position: "fixed",
      top: layerBounds.top,
      left: layerBounds.left
    }) : _extends({}, layerStyleBase, {
      position: "absolute",
      top: layerBounds.top - this.subjectsBounds.parent.top + scrollOffsets.top - borderOffsets.top,
      left: layerBounds.left - this.subjectsBounds.parent.left + scrollOffsets.left - borderOffsets.left
    });
    return {
      arrow,
      layer
    };
  };
  _proto.getHasDisappeared = function getHasDisappeared(layerBounds) {
    var subject = this.config.overflowContainer ? this.subjectsBounds.trigger : layerBounds;
    var containerOffsets = BoundsOffsets.mergeSmallestSides(this.subjectsBounds.offsetsToScrollContainers(subject, true));
    var entries = Object.entries(containerOffsets.negativeSides);
    var hasFullyDisappeared = entries.some(function(_ref) {
      var prop = _ref[0], value = _ref[1];
      var side = BoundSide[prop];
      return value <= -subject[side.sizeProp];
    });
    if (hasFullyDisappeared) {
      return "full";
    }
    if (!containerOffsets.allSidesArePositive) {
      return "partial";
    }
    return null;
  };
  _proto.result = function result(scrollOffsets, borderOffsets) {
    var suitablePlacement = this.findSuitablePlacement();
    var secondaryOffset = this.getSecondaryOffset(suitablePlacement);
    var layerBounds = suitablePlacement.getLayerBounds(secondaryOffset);
    var styles = this.getStyles(layerBounds, suitablePlacement, scrollOffsets, borderOffsets);
    var layerSide = suitablePlacement.primary.prop;
    return {
      styles,
      layerSide,
      placement: suitablePlacement,
      layerBounds,
      hasDisappeared: this.getHasDisappeared(layerBounds)
    };
  };
  return Placements2;
}();
var SubjectsBounds = /* @__PURE__ */ function() {
  function SubjectsBounds2(subjectsBounds, overflowContainer) {
    this.overflowContainer = void 0;
    this.trigger = void 0;
    this.layer = void 0;
    this.arrow = void 0;
    this.parent = void 0;
    this.window = void 0;
    this.scrollContainers = void 0;
    this.overflowContainer = overflowContainer;
    Object.assign(this, subjectsBounds);
  }
  SubjectsBounds2.create = function create(environment, layer, trigger, parent, arrow, scrollContainers, overflowContainer, getTriggerBounds) {
    var window2 = Bounds.fromWindow(environment);
    return new SubjectsBounds2({
      layer: Bounds.fromElement(layer, {
        environment,
        withTransform: false
      }),
      trigger: getTriggerBounds ? Bounds.create(boundsToObject(getTriggerBounds())) : Bounds.fromElement(trigger),
      arrow: arrow ? Bounds.fromElement(arrow) : Bounds.empty(),
      parent: parent ? Bounds.fromElement(parent) : window2,
      window: window2,
      scrollContainers: [window2].concat(scrollContainers.map(function(container) {
        return Bounds.fromElement(container, {
          withScrollbars: false
        });
      }))
    }, overflowContainer);
  };
  var _proto = SubjectsBounds2.prototype;
  _proto.merge = function merge(subjectsBounds) {
    return new SubjectsBounds2(_extends({}, this, subjectsBounds), this.overflowContainer);
  };
  _proto.offsetsToScrollContainers = function offsetsToScrollContainers(subject, allContainers) {
    if (allContainers === void 0) {
      allContainers = false;
    }
    var scrollContainers = this.overflowContainer && !allContainers ? [this.window] : this.scrollContainers;
    return scrollContainers.map(function(scrollContainer) {
      return scrollContainer.offsetsTo(subject);
    });
  };
  _createClass(SubjectsBounds2, [{
    key: "layerOffsetsToScrollContainers",
    get: function get() {
      return this.offsetsToScrollContainers(this.layer);
    }
  }, {
    key: "triggerHasBiggerWidth",
    get: function get() {
      return this.trigger.width > this.layer.width;
    }
  }, {
    key: "triggerHasBiggerHeight",
    get: function get() {
      return this.trigger.height > this.layer.height;
    }
  }]);
  return SubjectsBounds2;
}();
var GLOBAL_CONTAINER = null;
var DEFAULT_OPTIONS = {
  auto: false,
  arrowOffset: 0,
  containerOffset: 10,
  triggerOffset: 0,
  overflowContainer: true,
  placement: "top-center",
  possiblePlacements: PLACEMENT_TYPES,
  preferX: "right",
  preferY: "bottom",
  snap: false,
  container: void 0,
  trigger: void 0
};
function useLayer(_ref) {
  var _triggerBoundsRef$cur;
  var _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen, _ref$overflowContaine = _ref.overflowContainer, overflowContainer = _ref$overflowContaine === void 0 ? DEFAULT_OPTIONS.overflowContainer : _ref$overflowContaine, _ref$environment = _ref.environment, environment = _ref$environment === void 0 ? typeof window !== "undefined" ? window : void 0 : _ref$environment, ResizeObserverPolyfill = _ref.ResizeObserver, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? DEFAULT_OPTIONS.placement : _ref$placement, _ref$possiblePlacemen = _ref.possiblePlacements, possiblePlacements = _ref$possiblePlacemen === void 0 ? DEFAULT_OPTIONS.possiblePlacements : _ref$possiblePlacemen, _ref$preferX = _ref.preferX, preferX = _ref$preferX === void 0 ? DEFAULT_OPTIONS.preferX : _ref$preferX, _ref$preferY = _ref.preferY, preferY = _ref$preferY === void 0 ? DEFAULT_OPTIONS.preferY : _ref$preferY, _ref$auto = _ref.auto, auto2 = _ref$auto === void 0 ? DEFAULT_OPTIONS.auto : _ref$auto, _ref$snap = _ref.snap, snap = _ref$snap === void 0 ? DEFAULT_OPTIONS.snap : _ref$snap, _ref$triggerOffset = _ref.triggerOffset, triggerOffset = _ref$triggerOffset === void 0 ? DEFAULT_OPTIONS.triggerOffset : _ref$triggerOffset, _ref$containerOffset = _ref.containerOffset, containerOffset = _ref$containerOffset === void 0 ? DEFAULT_OPTIONS.containerOffset : _ref$containerOffset, _ref$arrowOffset = _ref.arrowOffset, arrowOffset = _ref$arrowOffset === void 0 ? DEFAULT_OPTIONS.arrowOffset : _ref$arrowOffset, _ref$container = _ref.container, container = _ref$container === void 0 ? DEFAULT_OPTIONS.container : _ref$container, _ref$layerDimensions = _ref.layerDimensions, layerDimensions = _ref$layerDimensions === void 0 ? null : _ref$layerDimensions, onDisappear = _ref.onDisappear, onOutsideClick = _ref.onOutsideClick, onParentClose = _ref.onParentClose, triggerOption = _ref.trigger;
  var _useState = (0, import_react9.useState)(function() {
    return {
      layerSide: placement === "center" ? "center" : Placements.getSidesFromPlacementType(placement)[0].prop,
      styles: {
        layer: {
          position: overflowContainer ? "fixed" : "absolute",
          top: 0,
          left: 0
        },
        arrow: {
          position: "absolute",
          top: 0,
          left: 0
        }
      }
    };
  }), state = _useState[0], setState = _useState[1];
  var triggerBoundsRef = (0, import_react9.useRef)(null);
  var lastState = useLastState(state, isOpen);
  var raf = (0, import_react9.useRef)(null);
  (0, import_react9.useEffect)(function() {
    return function() {
      if (raf.current) {
        cancelAnimationFrame(raf.current);
        raf.current = null;
      }
    };
  }, []);
  var handlePositioning = (0, import_react9.useCallback)(function handlePositioning2(_ref2, scrollOffsets, borderOffsets) {
    var arrow = _ref2.arrow, layer = _ref2.layer, scrollContainers = _ref2.scrollContainers, trigger = _ref2.trigger;
    var parent = scrollContainers[0];
    var subjectsBounds = SubjectsBounds.create(environment, layer, trigger, parent, arrow, scrollContainers, overflowContainer, triggerOption == null ? void 0 : triggerOption.getBounds);
    var config = {
      placement,
      possiblePlacements,
      auto: auto2,
      layerDimensions,
      arrowOffset,
      containerOffset,
      triggerOffset,
      preferX,
      preferY,
      snap,
      overflowContainer
    };
    var _Placements$create$re = Placements.create(subjectsBounds, config).result(scrollOffsets, borderOffsets), hasDisappeared = _Placements$create$re.hasDisappeared, layerSide = _Placements$create$re.layerSide, styles = _Placements$create$re.styles;
    var newState = {
      layerSide,
      styles
    };
    if (!lastState.current || didStateChange(lastState.current, newState)) {
      lastState.current = newState;
      if (raf.current) {
        cancelAnimationFrame(raf.current);
      }
      raf.current = requestAnimationFrame(function() {
        setState(newState);
        raf.current = null;
      });
    }
    if (isSet(hasDisappeared) && isSet(onDisappear)) {
      onDisappear(hasDisappeared);
    }
  }, [arrowOffset, auto2, containerOffset, environment, layerDimensions, onDisappear, overflowContainer, placement, possiblePlacements, preferX, preferY, snap, triggerOffset, lastState, triggerOption]);
  var _useTrackElements = useTrackElements({
    ResizeObserverPolyfill,
    environment,
    enabled: isOpen,
    overflowContainer,
    onChange: handlePositioning,
    triggerOption
  }), triggerRef = _useTrackElements.triggerRef, layerRef = _useTrackElements.layerRef, arrowRef = _useTrackElements.arrowRef, closestScrollContainer = _useTrackElements.closestScrollContainer;
  var _useGroup = useGroup({
    isOpen,
    onOutsideClick,
    onParentClose
  }), closeOnOutsideClickRefs = _useGroup.closeOnOutsideClickRefs, registrations = _useGroup.registrations;
  var props = {
    triggerProps: Boolean(triggerOption) ? {} : {
      ref: mergeRefs(triggerRef, closeOnOutsideClickRefs.trigger, triggerBoundsRef)
    },
    layerProps: {
      ref: mergeRefs(layerRef, closeOnOutsideClickRefs.layer),
      style: state.styles.layer
    },
    arrowProps: {
      ref: arrowRef,
      style: state.styles.arrow,
      layerSide: state.layerSide
    },
    layerSide: state.layerSide,
    triggerBounds: isOpen ? triggerOption ? triggerOption.getBounds() : (_triggerBoundsRef$cur = triggerBoundsRef.current) == null ? void 0 : _triggerBoundsRef$cur.getBoundingClientRect() : null,
    renderLayer: function renderLayer(children) {
      return typeof document !== "undefined" ? (0, import_react_dom.createPortal)((0, import_react9.createElement)(GroupProvider, {
        registrations,
        children
      }), overflowContainer || !closestScrollContainer ? getContainerElement(container) : closestScrollContainer) : null;
    }
  };
  return props;
}
function didStateChange(previous, next) {
  if (previous.layerSide !== next.layerSide) {
    return true;
  }
  var styleProps = ["position", "top", "left", "right", "bottom"];
  for (var _i = 0, _styleProps = styleProps; _i < _styleProps.length; _i++) {
    var prop = _styleProps[_i];
    if (previous.styles.layer[prop] !== next.styles.layer[prop] || previous.styles.arrow[prop] !== next.styles.arrow[prop]) {
      return true;
    }
  }
  return false;
}
var DEFAULT_CONTAINER_ID = "layers";
function getContainerElement(container) {
  var element;
  if (typeof container === "function") {
    element = container();
    if (!element || !(element instanceof HTMLElement)) {
      throw new Error("react-laag: You've passed a function to the 'container' prop, but it returned no valid HTMLElement");
    }
  } else if (container instanceof HTMLElement) {
    element = container;
  } else if (typeof container === "string") {
    element = document.getElementById(container);
    if (!element) {
      throw new Error("react-laag: You've passed element with id '" + container + "' to the 'container' prop, but it returned no valid HTMLElement");
    }
  } else if (GLOBAL_CONTAINER instanceof HTMLElement) {
    return GLOBAL_CONTAINER;
  } else {
    element = document.getElementById(DEFAULT_CONTAINER_ID);
    if (!element) {
      element = document.createElement("div");
      element.id = DEFAULT_CONTAINER_ID;
      element.style.cssText = "\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        right: 0px;\n      ";
      document.body.appendChild(element);
    }
  }
  return element;
}
var _excluded = ["size", "angle", "borderWidth", "borderColor", "roundness", "backgroundColor", "layerSide", "style"];
var LEFT = "left";
var TOP = "top";
var BOTTOM = "bottom";
var RIGHT = "right";
function getWidthBasedOnAngle(angle, size) {
  return Math.tan(angle * (Math.PI / 180)) * size;
}
function getViewBox(sizeA, sizeB, side, borderWidth) {
  var _map;
  var map = (_map = {}, _map[BOTTOM] = "0 " + -borderWidth + " " + sizeB + " " + sizeA, _map[TOP] = "0 0 " + sizeB + " " + (sizeA + borderWidth), _map[RIGHT] = -borderWidth + " 0 " + sizeA + " " + sizeB, _map[LEFT] = "0 0 " + (sizeA + borderWidth) + " " + sizeB, _map);
  return map[side.prop];
}
function getTrianglePath(sizeA, sizeB, side, roundness, angle) {
  var _BOTTOM$TOP$RIGHT$LEF, _BOTTOM$TOP$RIGHT$LEF2, _BOTTOM$TOP$RIGHT$LEF3;
  var relativeRoundness = roundness / 10 * sizeA * 2;
  var A = (_BOTTOM$TOP$RIGHT$LEF = {}, _BOTTOM$TOP$RIGHT$LEF[BOTTOM] = [0, sizeA], _BOTTOM$TOP$RIGHT$LEF[TOP] = [0, 0], _BOTTOM$TOP$RIGHT$LEF[RIGHT] = [sizeA, sizeB], _BOTTOM$TOP$RIGHT$LEF[LEFT] = [0, sizeB], _BOTTOM$TOP$RIGHT$LEF)[side.prop].join(" ");
  var B = side.isHorizontal ? "V 0" : "H " + sizeB;
  var cPoint = sizeB / 2;
  var c1A = sizeB / 2 + getWidthBasedOnAngle(angle, sizeA / 8);
  var c1B = sizeA / 8;
  var C = (_BOTTOM$TOP$RIGHT$LEF2 = {}, _BOTTOM$TOP$RIGHT$LEF2[BOTTOM] = ["C", c1A, c1B, cPoint + relativeRoundness, 0, cPoint, 0], _BOTTOM$TOP$RIGHT$LEF2[TOP] = ["C", c1A, sizeA - c1B, cPoint + relativeRoundness, sizeA, cPoint, sizeA], _BOTTOM$TOP$RIGHT$LEF2[RIGHT] = ["C", c1B, sizeB - c1A, 0, cPoint - relativeRoundness, 0, cPoint], _BOTTOM$TOP$RIGHT$LEF2[LEFT] = ["C", sizeA - c1B, sizeB - c1A, sizeA, cPoint - relativeRoundness, sizeA, cPoint], _BOTTOM$TOP$RIGHT$LEF2)[side.prop].join(" ");
  var d1A = sizeB / 2 - getWidthBasedOnAngle(angle, sizeA / 8);
  var d1B = sizeA / 8;
  var D = (_BOTTOM$TOP$RIGHT$LEF3 = {}, _BOTTOM$TOP$RIGHT$LEF3[BOTTOM] = ["C", cPoint - relativeRoundness, 0, d1A, d1B, A], _BOTTOM$TOP$RIGHT$LEF3[TOP] = ["C", cPoint - relativeRoundness, sizeA, d1A, sizeA - d1B, A], _BOTTOM$TOP$RIGHT$LEF3[RIGHT] = ["C", 0, cPoint + relativeRoundness, d1B, sizeB - d1A, A], _BOTTOM$TOP$RIGHT$LEF3[LEFT] = ["C", sizeA, cPoint + relativeRoundness, sizeA - d1B, sizeB - d1A, A], _BOTTOM$TOP$RIGHT$LEF3)[side.prop].join(" ");
  return ["M", A, B, C, D].join(" ");
}
function getBorderMaskPath(sizeA, sizeB, borderWidth, side, angle) {
  var borderOffset = getWidthBasedOnAngle(angle, borderWidth);
  var _ref = !side.isPush ? [sizeA, sizeA - borderWidth] : [0, borderWidth], A = _ref[0], B = _ref[1];
  if (side.isHorizontal) {
    return ["M", A, borderWidth, "V", sizeB - borderWidth, "L", B, sizeB - borderWidth - borderOffset, "V", borderOffset + borderWidth, "Z"].join(" ");
  }
  return ["M", borderWidth, A, "H", sizeB - borderWidth, "L", sizeB - borderWidth - borderOffset, B, "H", borderOffset + borderWidth, "Z"].join(" ");
}
var Arrow = /* @__PURE__ */ (0, import_react9.forwardRef)(function Arrow2(_ref2, ref) {
  var _ref2$size = _ref2.size, size = _ref2$size === void 0 ? 8 : _ref2$size, _ref2$angle = _ref2.angle, angle = _ref2$angle === void 0 ? 45 : _ref2$angle, _ref2$borderWidth = _ref2.borderWidth, borderWidth = _ref2$borderWidth === void 0 ? 0 : _ref2$borderWidth, _ref2$borderColor = _ref2.borderColor, borderColor = _ref2$borderColor === void 0 ? "black" : _ref2$borderColor, _ref2$roundness = _ref2.roundness, roundness = _ref2$roundness === void 0 ? 0 : _ref2$roundness, _ref2$backgroundColor = _ref2.backgroundColor, backgroundColor = _ref2$backgroundColor === void 0 ? "white" : _ref2$backgroundColor, _ref2$layerSide = _ref2.layerSide, layerSide = _ref2$layerSide === void 0 ? "top" : _ref2$layerSide, _ref2$style = _ref2.style, style = _ref2$style === void 0 ? {} : _ref2$style, rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  if (layerSide === "center") {
    return null;
  }
  var side = BoundSide[layerSide];
  var sizeA = size;
  var sizeB = getWidthBasedOnAngle(angle, size) * 2;
  var maxSize = Math.max(sizeA, sizeB);
  return (0, import_react9.createElement)("svg", _extends({
    ref
  }, rest, {
    style: _extends({}, style, {
      transform: "translate" + (side.isHorizontal ? "Y" : "X") + "(-50%)"
    }),
    width: maxSize,
    height: maxSize,
    preserveAspectRatio: side.isPush ? "xMinYMin" : "xMaxYMax",
    viewBox: getViewBox(sizeA, sizeB, side, borderWidth)
  }), (0, import_react9.createElement)("path", {
    fill: backgroundColor,
    strokeWidth: borderWidth,
    stroke: borderColor,
    d: getTrianglePath(sizeA, sizeB, side, roundness, angle)
  }), (0, import_react9.createElement)("path", {
    fill: backgroundColor,
    d: getBorderMaskPath(sizeA, sizeB, borderWidth, side, angle)
  }));
});
var Status;
(function(Status4) {
  Status4[Status4["ENTERING"] = 0] = "ENTERING";
  Status4[Status4["LEAVING"] = 1] = "LEAVING";
  Status4[Status4["IDLE"] = 2] = "IDLE";
})(Status || (Status = {}));
function useHover(_temp) {
  var _ref = _temp === void 0 ? {} : _temp, _ref$delayEnter = _ref.delayEnter, delayEnter = _ref$delayEnter === void 0 ? 0 : _ref$delayEnter, _ref$delayLeave = _ref.delayLeave, delayLeave = _ref$delayLeave === void 0 ? 0 : _ref$delayLeave, _ref$hideOnScroll = _ref.hideOnScroll, hideOnScroll = _ref$hideOnScroll === void 0 ? true : _ref$hideOnScroll;
  var _useState = (0, import_react9.useState)(false), show = _useState[0], setShow = _useState[1];
  var timeout = (0, import_react9.useRef)(null);
  var status = (0, import_react9.useRef)(Status.IDLE);
  var hasTouchMoved = (0, import_react9.useRef)(false);
  var removeTimeout = (0, import_react9.useCallback)(function removeTimeout2() {
    clearTimeout(timeout.current);
    timeout.current = null;
    status.current = Status.IDLE;
  }, []);
  function onMouseEnter() {
    if (status.current === Status.LEAVING && timeout.current) {
      removeTimeout();
    }
    if (show) {
      return;
    }
    status.current = Status.ENTERING;
    timeout.current = window.setTimeout(function() {
      setShow(true);
      timeout.current = null;
      status.current = Status.IDLE;
    }, delayEnter);
  }
  function onMouseLeave(_, immediate) {
    if (status.current === Status.ENTERING && timeout.current) {
      removeTimeout();
    }
    if (!show) {
      return;
    }
    if (immediate) {
      setShow(false);
      timeout.current = null;
      status.current = Status.IDLE;
      return;
    }
    status.current = Status.LEAVING;
    timeout.current = window.setTimeout(function() {
      setShow(false);
      timeout.current = null;
      status.current = Status.IDLE;
    }, delayLeave);
  }
  (0, import_react9.useEffect)(function() {
    function onScroll() {
      if (show && hideOnScroll) {
        removeTimeout();
        setShow(false);
      }
    }
    function onTouchEnd() {
      if (show) {
        removeTimeout();
        setShow(false);
      }
    }
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("touchend", onTouchEnd, true);
    return function() {
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("touchend", onTouchEnd, true);
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, [show, hideOnScroll, removeTimeout]);
  var hoverProps = {
    onMouseEnter,
    onMouseLeave,
    onTouchStart: function onTouchStart() {
      hasTouchMoved.current = false;
    },
    onTouchMove: function onTouchMove() {
      hasTouchMoved.current = true;
    },
    onTouchEnd: function onTouchEnd() {
      if (!hasTouchMoved.current && !show) {
        setShow(true);
      }
      hasTouchMoved.current = false;
    }
  };
  return [show, hoverProps, function() {
    return onMouseLeave(null, true);
  }];
}

// ../../node_modules/tslib/modules/index.js
var import_tslib = __toESM(require_tslib(), 1);
var {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __exportStar,
  __createBinding,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet
} = import_tslib.default;

// ../../node_modules/framer-motion/dist/es/motion/index.js
var React9 = __toESM(require("react"));
var import_react22 = require("react");

// ../../node_modules/framer-motion/dist/es/motion/features/use-features.js
var React8 = __toESM(require("react"));
var import_react11 = require("react");

// ../../node_modules/framer-motion/dist/es/motion/features/definitions.js
var createDefinition = function(propNames) {
  return {
    isEnabled: function(props) {
      return propNames.some(function(name) {
        return !!props[name];
      });
    }
  };
};
var featureDefinitions = {
  measureLayout: createDefinition([
    "layout",
    "layoutId",
    "drag",
    "_layoutResetTransform"
  ]),
  animation: createDefinition([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag"
  ]),
  exit: createDefinition(["exit"]),
  drag: createDefinition(["drag", "dragControls"]),
  focus: createDefinition(["whileFocus"]),
  hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: createDefinition([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  layoutAnimation: createDefinition(["layout", "layoutId"])
};
function loadFeatures(features) {
  for (var key in features) {
    var Component2 = features[key];
    if (Component2 !== null)
      featureDefinitions[key].Component = Component2;
  }
}

// ../../node_modules/hey-listen/dist/hey-listen.es.js
var warning2 = function() {
};
var invariant = function() {
};
if (true) {
  warning2 = function(check, message) {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = function(check, message) {
    if (!check) {
      throw new Error(message);
    }
  };
}

// ../../node_modules/framer-motion/dist/es/context/LazyContext.js
var import_react10 = require("react");
var LazyContext = (0, import_react10.createContext)({ strict: false });

// ../../node_modules/framer-motion/dist/es/motion/features/use-features.js
var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
function useFeatures(props, visualElement2, preloadedFeatures) {
  var features = [];
  var lazyContext = (0, import_react11.useContext)(LazyContext);
  if (!visualElement2)
    return null;
  if (preloadedFeatures && lazyContext.strict) {
    invariant(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  }
  for (var i2 = 0; i2 < numFeatures; i2++) {
    var name_1 = featureNames[i2];
    var _a = featureDefinitions[name_1], isEnabled = _a.isEnabled, Component2 = _a.Component;
    if (isEnabled(props) && Component2) {
      features.push(React8.createElement(Component2, __assign({ key: name_1 }, props, { visualElement: visualElement2 })));
    }
  }
  return features;
}

// ../../node_modules/framer-motion/dist/es/context/MotionConfigContext.js
var import_react12 = require("react");
var MotionConfigContext = (0, import_react12.createContext)({
  transformPagePoint: function(p2) {
    return p2;
  },
  isStatic: false
});

// ../../node_modules/framer-motion/dist/es/context/MotionContext/index.js
var import_react13 = require("react");
var MotionContext = (0, import_react13.createContext)({});
function useVisualElementContext() {
  return (0, import_react13.useContext)(MotionContext).visualElement;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-element.js
var import_react19 = require("react");

// ../../node_modules/framer-motion/dist/es/context/PresenceContext.js
var import_react14 = require("react");
var PresenceContext = (0, import_react14.createContext)(null);

// ../../node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.js
var import_react16 = require("react");

// ../../node_modules/framer-motion/dist/es/utils/use-constant.js
var import_react15 = require("react");
function useConstant(init) {
  var ref = (0, import_react15.useRef)(null);
  if (ref.current === null) {
    ref.current = init();
  }
  return ref.current;
}

// ../../node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.js
function usePresence() {
  var context = (0, import_react16.useContext)(PresenceContext);
  if (context === null)
    return [true, null];
  var isPresent2 = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
  var id = useUniqueId();
  (0, import_react16.useEffect)(function() {
    return register(id);
  }, []);
  var safeToRemove = function() {
    return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
  };
  return !isPresent2 && onExitComplete ? [false, safeToRemove] : [true];
}
function isPresent(context) {
  return context === null ? true : context.isPresent;
}
var counter = 0;
var incrementId = function() {
  return counter++;
};
var useUniqueId = function() {
  return useConstant(incrementId);
};

// ../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.js
var import_react17 = require("react");
var LayoutGroupContext = (0, import_react17.createContext)(null);

// ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.js
var import_react18 = require("react");

// ../../node_modules/framer-motion/dist/es/utils/is-browser.js
var isBrowser = typeof window !== "undefined";

// ../../node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.js
var useIsomorphicLayoutEffect2 = isBrowser ? import_react18.useLayoutEffect : import_react18.useEffect;

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-element.js
function useLayoutId(_a) {
  var layoutId = _a.layoutId;
  var layoutGroupId = (0, import_react19.useContext)(LayoutGroupContext);
  return layoutGroupId && layoutId !== void 0 ? layoutGroupId + "-" + layoutId : layoutId;
}
function useVisualElement(Component2, visualState, props, createVisualElement) {
  var config = (0, import_react19.useContext)(MotionConfigContext);
  var lazyContext = (0, import_react19.useContext)(LazyContext);
  var parent = useVisualElementContext();
  var presenceContext = (0, import_react19.useContext)(PresenceContext);
  var layoutId = useLayoutId(props);
  var visualElementRef = (0, import_react19.useRef)(void 0);
  if (!createVisualElement)
    createVisualElement = lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component2, {
      visualState,
      parent,
      props: __assign(__assign({}, props), { layoutId }),
      presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
      blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false
    });
  }
  var visualElement2 = visualElementRef.current;
  useIsomorphicLayoutEffect2(function() {
    if (!visualElement2)
      return;
    visualElement2.setProps(__assign(__assign(__assign({}, config), props), { layoutId }));
    visualElement2.isPresent = isPresent(presenceContext);
    visualElement2.isPresenceRoot = !parent || parent.presenceId !== (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id);
    visualElement2.syncRender();
  });
  (0, import_react19.useEffect)(function() {
    var _a;
    if (!visualElement2)
      return;
    (_a = visualElement2.animationState) === null || _a === void 0 ? void 0 : _a.animateChanges();
  });
  useIsomorphicLayoutEffect2(function() {
    return function() {
      return visualElement2 === null || visualElement2 === void 0 ? void 0 : visualElement2.notifyUnmount();
    };
  }, []);
  return visualElement2;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.js
var import_react20 = require("react");

// ../../node_modules/framer-motion/dist/es/utils/is-ref-object.js
function isRefObject(ref) {
  return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.js
function useMotionRef(visualState, visualElement2, externalRef) {
  return (0, import_react20.useCallback)(function(instance) {
    var _a;
    instance && ((_a = visualState.mount) === null || _a === void 0 ? void 0 : _a.call(visualState, instance));
    if (visualElement2) {
      instance ? visualElement2.mount(instance) : visualElement2.unmount();
    }
    if (externalRef) {
      if (typeof externalRef === "function") {
        externalRef(instance);
      } else if (isRefObject(externalRef)) {
        externalRef.current = instance;
      }
    }
  }, [visualElement2]);
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/create.js
var import_react21 = require("react");

// ../../node_modules/framer-motion/dist/es/render/utils/variants.js
function isVariantLabels(v2) {
  return Array.isArray(v2);
}
function isVariantLabel(v2) {
  return typeof v2 === "string" || isVariantLabels(v2);
}
function getCurrent(visualElement2) {
  var current = {};
  visualElement2.forEachValue(function(value, key) {
    return current[key] = value.get();
  });
  return current;
}
function getVelocity(visualElement2) {
  var velocity = {};
  visualElement2.forEachValue(function(value, key) {
    return velocity[key] = value.getVelocity();
  });
  return velocity;
}
function resolveVariantFromProps(props, definition, custom, currentValues, currentVelocity) {
  var _a;
  if (currentValues === void 0) {
    currentValues = {};
  }
  if (currentVelocity === void 0) {
    currentVelocity = {};
  }
  if (typeof definition === "string") {
    definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
  }
  return typeof definition === "function" ? definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity) : definition;
}
function resolveVariant(visualElement2, definition, custom) {
  var props = visualElement2.getProps();
  return resolveVariantFromProps(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, getCurrent(visualElement2), getVelocity(visualElement2));
}
function checkIfControllingVariants(props) {
  var _a;
  return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || isVariantLabel(props.initial) || isVariantLabel(props.animate) || isVariantLabel(props.whileHover) || isVariantLabel(props.whileDrag) || isVariantLabel(props.whileTap) || isVariantLabel(props.whileFocus) || isVariantLabel(props.exit);
}
function checkIfVariantNode(props) {
  return Boolean(checkIfControllingVariants(props) || props.variants);
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/utils.js
function getCurrentTreeVariants(props, context) {
  if (checkIfControllingVariants(props)) {
    var initial = props.initial, animate2 = props.animate;
    return {
      initial: initial === false || isVariantLabel(initial) ? initial : void 0,
      animate: isVariantLabel(animate2) ? animate2 : void 0
    };
  }
  return props.inherit !== false ? context : {};
}

// ../../node_modules/framer-motion/dist/es/context/MotionContext/create.js
function useCreateMotionContext(props, isStatic) {
  var _a = getCurrentTreeVariants(props, (0, import_react21.useContext)(MotionContext)), initial = _a.initial, animate2 = _a.animate;
  return (0, import_react21.useMemo)(function() {
    return { initial, animate: animate2 };
  }, isStatic ? [
    variantLabelsAsDependency(initial),
    variantLabelsAsDependency(animate2)
  ] : []);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}

// ../../node_modules/framer-motion/dist/es/motion/index.js
function createMotionComponent(_a) {
  var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, useRender = _a.useRender, useVisualState = _a.useVisualState, Component2 = _a.Component;
  preloadedFeatures && loadFeatures(preloadedFeatures);
  function MotionComponent(props, externalRef) {
    var isStatic = (0, import_react22.useContext)(MotionConfigContext).isStatic;
    var features = null;
    var context = useCreateMotionContext(props, isStatic);
    var visualState = useVisualState(props, isStatic);
    if (!isStatic && isBrowser) {
      context.visualElement = useVisualElement(Component2, visualState, props, createVisualElement);
      features = useFeatures(props, context.visualElement, preloadedFeatures);
    }
    return React9.createElement(React9.Fragment, null, React9.createElement(MotionContext.Provider, { value: context }, useRender(Component2, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic)), features);
  }
  return (0, import_react22.forwardRef)(MotionComponent);
}

// ../../node_modules/framer-motion/dist/es/render/dom/motion-proxy.js
function createMotionProxy(createConfig) {
  function custom(Component2, customMotionComponentConfig) {
    if (customMotionComponentConfig === void 0) {
      customMotionComponentConfig = {};
    }
    return createMotionComponent(createConfig(Component2, customMotionComponentConfig));
  }
  var componentCache = /* @__PURE__ */ new Map();
  return new Proxy(custom, {
    get: function(_target, key) {
      if (!componentCache.has(key)) {
        componentCache.set(key, custom(key));
      }
      return componentCache.get(key);
    }
  });
}

// ../../node_modules/framer-motion/dist/es/render/svg/lowercase-elements.js
var lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-svg-component.js
function isSVGComponent(Component2) {
  if (typeof Component2 !== "string" || Component2.includes("-")) {
    return false;
  } else if (lowercaseSVGElements.indexOf(Component2) > -1 || /[A-Z]/.test(Component2)) {
    return true;
  }
  return false;
}

// ../../node_modules/framer-motion/dist/es/render/dom/use-render.js
var import_react25 = require("react");

// ../../node_modules/framer-motion/dist/es/render/html/use-props.js
var import_react23 = require("react");

// ../../node_modules/framer-motion/dist/es/render/dom/projection/scale-correction.js
var valueScaleCorrection = {};
function addScaleCorrection(correctors) {
  for (var key in correctors) {
    valueScaleCorrection[key] = correctors[key];
  }
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/transform.js
var transformAxes = ["", "X", "Y", "Z"];
var order = ["translate", "scale", "rotate", "skew"];
var transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function(operationKey) {
  return transformAxes.forEach(function(axesKey) {
    return transformProps.push(operationKey + axesKey);
  });
});
function sortTransformProps(a3, b3) {
  return transformProps.indexOf(a3) - transformProps.indexOf(b3);
}
var transformPropSet = new Set(transformProps);
function isTransformProp(key) {
  return transformPropSet.has(key);
}
var transformOriginProps = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(key) {
  return transformOriginProps.has(key);
}

// ../../node_modules/framer-motion/dist/es/motion/utils/is-forced-motion-value.js
function isForcedMotionValue(key, _a) {
  var layout = _a.layout, layoutId = _a.layoutId;
  return isTransformProp(key) || isTransformOriginProp(key) || (layout || layoutId !== void 0) && (!!valueScaleCorrection[key] || key === "opacity");
}

// ../../node_modules/framer-motion/dist/es/value/utils/is-motion-value.js
var isMotionValue = function(value) {
  return value !== null && typeof value === "object" && value.getVelocity;
};

// ../../node_modules/framer-motion/dist/es/render/html/utils/build-transform.js
var translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function buildTransform(_a, _b, transformIsDefault, transformTemplate) {
  var transform = _a.transform, transformKeys2 = _a.transformKeys;
  var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
  var transformString = "";
  transformKeys2.sort(sortTransformProps);
  var transformHasZ = false;
  var numTransformKeys = transformKeys2.length;
  for (var i2 = 0; i2 < numTransformKeys; i2++) {
    var key = transformKeys2[i2];
    transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
    if (key === "z")
      transformHasZ = true;
  }
  if (!transformHasZ && enableHardwareAcceleration) {
    transformString += "translateZ(0)";
  } else {
    transformString = transformString.trim();
  }
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}
function buildTransformOrigin(_a) {
  var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
  return originX + " " + originY + " " + originZ;
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/is-css-variable.js
function isCSSVariable(key) {
  return key.startsWith("--");
}

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/get-as-type.js
var getValueAsType = function(value, type) {
  return type && typeof value === "number" ? type.transform(value) : value;
};

// ../../node_modules/style-value-types/dist/es/utils.js
var clamp = function(min, max) {
  return function(v2) {
    return Math.max(Math.min(v2, max), min);
  };
};
var sanitize = function(v2) {
  return v2 % 1 ? Number(v2.toFixed(5)) : v2;
};
var floatRegex = /(-)?([\d]*\.?[\d])+/g;
var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString(v2) {
  return typeof v2 === "string";
}

// ../../node_modules/style-value-types/dist/es/numbers/index.js
var number = {
  test: function(v2) {
    return typeof v2 === "number";
  },
  parse: parseFloat,
  transform: function(v2) {
    return v2;
  }
};
var alpha = __assign(__assign({}, number), { transform: clamp(0, 1) });
var scale = __assign(__assign({}, number), { default: 1 });

// ../../node_modules/style-value-types/dist/es/numbers/units.js
var createUnitType = function(unit) {
  return {
    test: function(v2) {
      return isString(v2) && v2.endsWith(unit) && v2.split(" ").length === 1;
    },
    parse: parseFloat,
    transform: function(v2) {
      return "" + v2 + unit;
    }
  };
};
var degrees = createUnitType("deg");
var percent = createUnitType("%");
var px = createUnitType("px");
var vh = createUnitType("vh");
var vw = createUnitType("vw");
var progressPercentage = __assign(__assign({}, percent), { parse: function(v2) {
  return percent.parse(v2) / 100;
}, transform: function(v2) {
  return percent.transform(v2 * 100);
} });

// ../../node_modules/style-value-types/dist/es/color/utils.js
var isColorString = function(type, testProp) {
  return function(v2) {
    return Boolean(isString(v2) && singleColorRegex.test(v2) && v2.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v2, testProp));
  };
};
var splitColor = function(aName, bName, cName) {
  return function(v2) {
    var _a;
    if (!isString(v2))
      return v2;
    var _b = v2.match(floatRegex), a3 = _b[0], b3 = _b[1], c3 = _b[2], alpha2 = _b[3];
    return _a = {}, _a[aName] = parseFloat(a3), _a[bName] = parseFloat(b3), _a[cName] = parseFloat(c3), _a.alpha = alpha2 !== void 0 ? parseFloat(alpha2) : 1, _a;
  };
};

// ../../node_modules/style-value-types/dist/es/color/hsla.js
var hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: function(_a) {
    var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};

// ../../node_modules/style-value-types/dist/es/color/rgba.js
var clampRgbUnit = clamp(0, 255);
var rgbUnit = __assign(__assign({}, number), { transform: function(v2) {
  return Math.round(clampRgbUnit(v2));
} });
var rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: function(_a) {
    var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
    return "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};

// ../../node_modules/style-value-types/dist/es/color/hex.js
function parseHex(v2) {
  var r2 = "";
  var g2 = "";
  var b3 = "";
  var a3 = "";
  if (v2.length > 5) {
    r2 = v2.substr(1, 2);
    g2 = v2.substr(3, 2);
    b3 = v2.substr(5, 2);
    a3 = v2.substr(7, 2);
  } else {
    r2 = v2.substr(1, 1);
    g2 = v2.substr(2, 1);
    b3 = v2.substr(3, 1);
    a3 = v2.substr(4, 1);
    r2 += r2;
    g2 += g2;
    b3 += b3;
    a3 += a3;
  }
  return {
    red: parseInt(r2, 16),
    green: parseInt(g2, 16),
    blue: parseInt(b3, 16),
    alpha: a3 ? parseInt(a3, 16) / 255 : 1
  };
}
var hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
};

// ../../node_modules/style-value-types/dist/es/color/index.js
var color = {
  test: function(v2) {
    return rgba.test(v2) || hex.test(v2) || hsla.test(v2);
  },
  parse: function(v2) {
    if (rgba.test(v2)) {
      return rgba.parse(v2);
    } else if (hsla.test(v2)) {
      return hsla.parse(v2);
    } else {
      return hex.parse(v2);
    }
  },
  transform: function(v2) {
    return isString(v2) ? v2 : v2.hasOwnProperty("red") ? rgba.transform(v2) : hsla.transform(v2);
  }
};

// ../../node_modules/style-value-types/dist/es/complex/index.js
var colorToken = "${c}";
var numberToken = "${n}";
function test(v2) {
  var _a, _b, _c, _d;
  return isNaN(v2) && isString(v2) && ((_b = (_a = v2.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v2.match(colorRegex)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function analyse(v2) {
  var values = [];
  var numColors = 0;
  var colors2 = v2.match(colorRegex);
  if (colors2) {
    numColors = colors2.length;
    v2 = v2.replace(colorRegex, colorToken);
    values.push.apply(values, colors2.map(color.parse));
  }
  var numbers = v2.match(floatRegex);
  if (numbers) {
    v2 = v2.replace(floatRegex, numberToken);
    values.push.apply(values, numbers.map(number.parse));
  }
  return { values, numColors, tokenised: v2 };
}
function parse(v2) {
  return analyse(v2).values;
}
function createTransformer(v2) {
  var _a = analyse(v2), values = _a.values, numColors = _a.numColors, tokenised = _a.tokenised;
  var numValues = values.length;
  return function(v3) {
    var output = tokenised;
    for (var i2 = 0; i2 < numValues; i2++) {
      output = output.replace(i2 < numColors ? colorToken : numberToken, i2 < numColors ? color.transform(v3[i2]) : sanitize(v3[i2]));
    }
    return output;
  };
}
var convertNumbersToZero = function(v2) {
  return typeof v2 === "number" ? 0 : v2;
};
function getAnimatableNone(v2) {
  var parsed = parse(v2);
  var transformer = createTransformer(v2);
  return transformer(parsed.map(convertNumbersToZero));
}
var complex = { test, parse, createTransformer, getAnimatableNone };

// ../../node_modules/style-value-types/dist/es/complex/filter.js
var maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v2) {
  var _a = v2.slice(0, -1).split("("), name = _a[0], value = _a[1];
  if (name === "drop-shadow")
    return v2;
  var number2 = (value.match(floatRegex) || [])[0];
  if (!number2)
    return v2;
  var unit = value.replace(number2, "");
  var defaultValue = maxDefaults.has(name) ? 1 : 0;
  if (number2 !== value)
    defaultValue *= 100;
  return name + "(" + defaultValue + unit + ")";
}
var functionRegex = /([a-z-]*)\(.*?\)/g;
var filter = __assign(__assign({}, complex), { getAnimatableNone: function(v2) {
  var functions = v2.match(functionRegex);
  return functions ? functions.map(applyDefaultFilter).join(" ") : v2;
} });

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/type-int.js
var int = __assign(__assign({}, number), { transform: Math.round });

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/number.js
var numberValueTypes = {
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  zIndex: int,
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};

// ../../node_modules/framer-motion/dist/es/render/html/utils/build-styles.js
function buildHTMLStyles(state, latestValues, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
  var _a;
  var style = state.style, vars = state.vars, transform = state.transform, transformKeys2 = state.transformKeys, transformOrigin = state.transformOrigin;
  transformKeys2.length = 0;
  var hasTransform = false;
  var hasTransformOrigin = false;
  var transformIsNone = true;
  for (var key in latestValues) {
    var value = latestValues[key];
    if (isCSSVariable(key)) {
      vars[key] = value;
      continue;
    }
    var valueType = numberValueTypes[key];
    var valueAsType = getValueAsType(value, valueType);
    if (isTransformProp(key)) {
      hasTransform = true;
      transform[key] = valueAsType;
      transformKeys2.push(key);
      if (!transformIsNone)
        continue;
      if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0))
        transformIsNone = false;
    } else if (isTransformOriginProp(key)) {
      transformOrigin[key] = valueAsType;
      hasTransformOrigin = true;
    } else {
      if ((projection === null || projection === void 0 ? void 0 : projection.isHydrated) && (layoutState === null || layoutState === void 0 ? void 0 : layoutState.isHydrated) && valueScaleCorrection[key]) {
        var correctedValue = valueScaleCorrection[key].process(value, layoutState, projection);
        var applyTo = valueScaleCorrection[key].applyTo;
        if (applyTo) {
          var num = applyTo.length;
          for (var i2 = 0; i2 < num; i2++) {
            style[applyTo[i2]] = correctedValue;
          }
        } else {
          style[key] = correctedValue;
        }
      } else {
        style[key] = valueAsType;
      }
    }
  }
  if (layoutState && projection && buildProjectionTransform && buildProjectionTransformOrigin) {
    style.transform = buildProjectionTransform(layoutState.deltaFinal, layoutState.treeScale, hasTransform ? transform : void 0);
    if (transformTemplate) {
      style.transform = transformTemplate(transform, style.transform);
    }
    style.transformOrigin = buildProjectionTransformOrigin(layoutState);
  } else {
    if (hasTransform) {
      style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
    }
    if (hasTransformOrigin) {
      style.transformOrigin = buildTransformOrigin(transformOrigin);
    }
  }
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/create-render-state.js
var createHtmlRenderState = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};

// ../../node_modules/framer-motion/dist/es/render/html/use-props.js
function copyRawValuesOnly(target, source, props) {
  for (var key in source) {
    if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
      target[key] = source[key];
    }
  }
}
function useInitialMotionValues(_a, visualState, isStatic) {
  var transformTemplate = _a.transformTemplate;
  return (0, import_react23.useMemo)(function() {
    var state = createHtmlRenderState();
    buildHTMLStyles(state, visualState, void 0, void 0, { enableHardwareAcceleration: !isStatic }, transformTemplate);
    var vars = state.vars, style = state.style;
    return __assign(__assign({}, vars), style);
  }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
  var styleProp = props.style || {};
  var style = {};
  copyRawValuesOnly(style, styleProp, props);
  Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
  if (props.transformValues) {
    style = props.transformValues(style);
  }
  return style;
}
function useHTMLProps(props, visualState, isStatic) {
  var htmlProps = {};
  var style = useStyle(props, visualState, isStatic);
  if (Boolean(props.drag)) {
    htmlProps.draggable = false;
    style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
    style.touchAction = props.drag === true ? "none" : "pan-" + (props.drag === "x" ? "y" : "x");
  }
  htmlProps.style = style;
  return htmlProps;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/valid-prop.js
var validMotionProps = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "_layoutResetTransform",
  "onLayoutAnimationComplete",
  "onViewportBoxUpdate",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover"
]);
function isValidMotionProp(key) {
  return validMotionProps.has(key);
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/filter-props.js
var shouldForward = function(key) {
  return !isValidMotionProp(key);
};
try {
  emotionIsPropValid_1 = require_is_prop_valid_browser_cjs().default;
  shouldForward = function(key) {
    if (key.startsWith("on")) {
      return !isValidMotionProp(key);
    } else {
      return emotionIsPropValid_1(key);
    }
  };
} catch (_a) {
}
var emotionIsPropValid_1;
function filterProps(props, isDom, forwardMotionProps) {
  var filteredProps = {};
  for (var key in props) {
    if (shouldForward(key) || forwardMotionProps === true && isValidMotionProp(key) || !isDom && !isValidMotionProp(key)) {
      filteredProps[key] = props[key];
    }
  }
  return filteredProps;
}

// ../../node_modules/framer-motion/dist/es/render/svg/use-props.js
var import_react24 = require("react");

// ../../node_modules/framer-motion/dist/es/render/svg/utils/transform-origin.js
function calcOrigin(origin, offset, size) {
  return typeof origin === "string" ? origin : px.transform(offset + size * origin);
}
function calcSVGTransformOrigin(dimensions, originX, originY) {
  var pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
  var pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
  return pxOriginX + " " + pxOriginY;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/path.js
var progressToPixels = function(progress2, length) {
  return px.transform(progress2 * length);
};
var dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(attrs, totalLength, length, spacing, offset, useDashCase) {
  if (spacing === void 0) {
    spacing = 1;
  }
  if (offset === void 0) {
    offset = 0;
  }
  if (useDashCase === void 0) {
    useDashCase = true;
  }
  var keys = useDashCase ? dashKeys : camelKeys;
  attrs[keys.offset] = progressToPixels(-offset, totalLength);
  var pathLength = progressToPixels(length, totalLength);
  var pathSpacing = progressToPixels(spacing, totalLength);
  attrs[keys.array] = pathLength + " " + pathSpacing;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/build-attrs.js
function buildSVGAttrs(state, _a, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
  var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, latest = __rest(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  buildHTMLStyles(state, latest, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin);
  state.attrs = state.style;
  state.style = {};
  var attrs = state.attrs, style = state.style, dimensions = state.dimensions, totalPathLength = state.totalPathLength;
  if (attrs.transform) {
    if (dimensions)
      style.transform = attrs.transform;
    delete attrs.transform;
  }
  if (dimensions && (originX !== void 0 || originY !== void 0 || style.transform)) {
    style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== void 0 ? originX : 0.5, originY !== void 0 ? originY : 0.5);
  }
  if (attrX !== void 0)
    attrs.x = attrX;
  if (attrY !== void 0)
    attrs.y = attrY;
  if (totalPathLength !== void 0 && pathLength !== void 0) {
    buildSVGPath(attrs, totalPathLength, pathLength, pathSpacing, pathOffset, false);
  }
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/create-render-state.js
var createSvgRenderState = function() {
  return __assign(__assign({}, createHtmlRenderState()), { attrs: {} });
};

// ../../node_modules/framer-motion/dist/es/render/svg/use-props.js
function useSVGProps(props, visualState) {
  var visualProps = (0, import_react24.useMemo)(function() {
    var state = createSvgRenderState();
    buildSVGAttrs(state, visualState, void 0, void 0, { enableHardwareAcceleration: false }, props.transformTemplate);
    return __assign(__assign({}, state.attrs), { style: __assign({}, state.style) });
  }, [visualState]);
  if (props.style) {
    var rawStyles = {};
    copyRawValuesOnly(rawStyles, props.style, props);
    visualProps.style = __assign(__assign({}, rawStyles), visualProps.style);
  }
  return visualProps;
}

// ../../node_modules/framer-motion/dist/es/render/dom/use-render.js
function createUseRender(forwardMotionProps) {
  if (forwardMotionProps === void 0) {
    forwardMotionProps = false;
  }
  var useRender = function(Component2, props, ref, _a, isStatic) {
    var latestValues = _a.latestValues;
    var useVisualProps = isSVGComponent(Component2) ? useSVGProps : useHTMLProps;
    var visualProps = useVisualProps(props, latestValues, isStatic);
    var filteredProps = filterProps(props, typeof Component2 === "string", forwardMotionProps);
    var elementProps = __assign(__assign(__assign({}, filteredProps), visualProps), { ref });
    return (0, import_react25.createElement)(Component2, elementProps);
  };
  return useRender;
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/camel-to-dash.js
var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = "$1-$2";
var camelToDash = function(str) {
  return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};

// ../../node_modules/framer-motion/dist/es/render/html/utils/render.js
function renderHTML(element, _a) {
  var style = _a.style, vars = _a.vars;
  Object.assign(element.style, style);
  for (var key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/camel-case-attrs.js
var camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform"
]);

// ../../node_modules/framer-motion/dist/es/render/svg/utils/render.js
function renderSVG(element, renderState) {
  renderHTML(element, renderState);
  for (var key in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
  }
}

// ../../node_modules/framer-motion/dist/es/render/html/utils/scrape-motion-values.js
function scrapeMotionValuesFromProps(props) {
  var style = props.style;
  var newValues = {};
  for (var key in style) {
    if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
      newValues[key] = style[key];
    }
  }
  return newValues;
}

// ../../node_modules/framer-motion/dist/es/render/svg/utils/scrape-motion-values.js
function scrapeMotionValuesFromProps2(props) {
  var newValues = scrapeMotionValuesFromProps(props);
  for (var key in props) {
    if (isMotionValue(props[key])) {
      var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-state.js
var import_react26 = require("react");

// ../../node_modules/framer-motion/dist/es/animation/utils/is-animation-controls.js
function isAnimationControls(v2) {
  return typeof v2 === "object" && typeof v2.start === "function";
}

// ../../node_modules/framer-motion/dist/es/animation/utils/is-keyframes-target.js
var isKeyframesTarget = function(v2) {
  return Array.isArray(v2);
};

// ../../node_modules/framer-motion/dist/es/utils/resolve-value.js
var isCustomValue = function(v2) {
  return Boolean(v2 && typeof v2 === "object" && v2.mix && v2.toValue);
};
var resolveFinalValueInKeyframes = function(v2) {
  return isKeyframesTarget(v2) ? v2[v2.length - 1] || 0 : v2;
};

// ../../node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.js
function resolveMotionValue(value) {
  var unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

// ../../node_modules/framer-motion/dist/es/motion/utils/use-visual-state.js
function makeState(_a, props, context, presenceContext) {
  var scrapeMotionValuesFromProps3 = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
  var state = {
    latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps3),
    renderState: createRenderState()
  };
  if (onMount) {
    state.mount = function(instance) {
      return onMount(props, instance, state);
    };
  }
  return state;
}
var makeUseVisualState = function(config) {
  return function(props, isStatic) {
    var context = (0, import_react26.useContext)(MotionContext);
    var presenceContext = (0, import_react26.useContext)(PresenceContext);
    return isStatic ? makeState(config, props, context, presenceContext) : useConstant(function() {
      return makeState(config, props, context, presenceContext);
    });
  };
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
  var values = {};
  var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
  var motionValues = scrapeMotionValues(props);
  for (var key in motionValues) {
    values[key] = resolveMotionValue(motionValues[key]);
  }
  var initial = props.initial, animate2 = props.animate;
  var isControllingVariants = checkIfControllingVariants(props);
  var isVariantNode = checkIfVariantNode(props);
  if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
    initial !== null && initial !== void 0 ? initial : initial = context.initial;
    animate2 !== null && animate2 !== void 0 ? animate2 : animate2 = context.animate;
  }
  var variantToSet = blockInitialAnimation || initial === false ? animate2 : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
    list.forEach(function(definition) {
      var resolved = resolveVariantFromProps(props, definition);
      if (!resolved)
        return;
      var transitionEnd = resolved.transitionEnd;
      resolved.transition;
      var target = __rest(resolved, ["transitionEnd", "transition"]);
      for (var key2 in target)
        values[key2] = target[key2];
      for (var key2 in transitionEnd)
        values[key2] = transitionEnd[key2];
    });
  }
  return values;
}

// ../../node_modules/framer-motion/dist/es/render/svg/config-motion.js
var svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps2,
    createRenderState: createSvgRenderState,
    onMount: function(props, instance, _a) {
      var renderState = _a.renderState, latestValues = _a.latestValues;
      try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
      } catch (e2) {
        renderState.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      if (isPath(instance)) {
        renderState.totalPathLength = instance.getTotalLength();
      }
      buildSVGAttrs(renderState, latestValues, void 0, void 0, { enableHardwareAcceleration: false }, props.transformTemplate);
      renderSVG(instance, renderState);
    }
  })
};
function isPath(element) {
  return element.tagName === "path";
}

// ../../node_modules/framer-motion/dist/es/render/html/config-motion.js
var htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps,
    createRenderState: createHtmlRenderState
  })
};

// ../../node_modules/framer-motion/dist/es/render/dom/utils/create-config.js
function createDomMotionConfig(Component2, _a, preloadedFeatures, createVisualElement) {
  var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
  var baseConfig = isSVGComponent(Component2) ? svgMotionConfig : htmlMotionConfig;
  return __assign(__assign({}, baseConfig), {
    preloadedFeatures,
    useRender: createUseRender(forwardMotionProps),
    createVisualElement,
    Component: Component2
  });
}

// ../../node_modules/framer-motion/dist/es/render/utils/types.js
var AnimationType;
(function(AnimationType2) {
  AnimationType2["Animate"] = "animate";
  AnimationType2["Hover"] = "whileHover";
  AnimationType2["Tap"] = "whileTap";
  AnimationType2["Drag"] = "whileDrag";
  AnimationType2["Focus"] = "whileFocus";
  AnimationType2["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));

// ../../node_modules/framer-motion/dist/es/events/use-dom-event.js
var import_react27 = require("react");
function addDomEvent(target, eventName, handler, options) {
  target.addEventListener(eventName, handler, options);
  return function() {
    return target.removeEventListener(eventName, handler, options);
  };
}
function useDomEvent(ref, eventName, handler, options) {
  (0, import_react27.useEffect)(function() {
    var element = ref.current;
    if (handler && element) {
      return addDomEvent(element, eventName, handler, options);
    }
  }, [ref, eventName, handler, options]);
}

// ../../node_modules/framer-motion/dist/es/gestures/use-focus-gesture.js
function useFocusGesture(_a) {
  var whileFocus = _a.whileFocus, visualElement2 = _a.visualElement;
  var onFocus = function() {
    var _a2;
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Focus, true);
  };
  var onBlur = function() {
    var _a2;
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Focus, false);
  };
  useDomEvent(visualElement2, "focus", whileFocus ? onFocus : void 0);
  useDomEvent(visualElement2, "blur", whileFocus ? onBlur : void 0);
}

// ../../node_modules/framer-motion/dist/es/gestures/utils/event-type.js
function isMouseEvent(event) {
  if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
    return !!(event.pointerType === "mouse");
  }
  return event instanceof MouseEvent;
}
function isTouchEvent(event) {
  var hasTouches = !!event.touches;
  return hasTouches;
}

// ../../node_modules/framer-motion/dist/es/events/event-info.js
function filterPrimaryPointer(eventHandler) {
  return function(event) {
    var isMouseEvent2 = event instanceof MouseEvent;
    var isPrimaryPointer = !isMouseEvent2 || isMouseEvent2 && event.button === 0;
    if (isPrimaryPointer) {
      eventHandler(event);
    }
  };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e2, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }
  var primaryTouch = e2.touches[0] || e2.changedTouches[0];
  var point = primaryTouch || defaultPagePoint;
  return {
    x: point[pointType + "X"],
    y: point[pointType + "Y"]
  };
}
function pointFromMouse(point, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }
  return {
    x: point[pointType + "X"],
    y: point[pointType + "Y"]
  };
}
function extractEventInfo(event, pointType) {
  if (pointType === void 0) {
    pointType = "page";
  }
  return {
    point: isTouchEvent(event) ? pointFromTouch(event, pointType) : pointFromMouse(event, pointType)
  };
}
function getViewportPointFromEvent(event) {
  return extractEventInfo(event, "client");
}
var wrapHandler = function(handler, shouldFilterPrimaryPointer) {
  if (shouldFilterPrimaryPointer === void 0) {
    shouldFilterPrimaryPointer = false;
  }
  var listener = function(event) {
    return handler(event, extractEventInfo(event));
  };
  return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
};

// ../../node_modules/framer-motion/dist/es/events/utils.js
var supportsPointerEvents = function() {
  return isBrowser && window.onpointerdown === null;
};
var supportsTouchEvents = function() {
  return isBrowser && window.ontouchstart === null;
};
var supportsMouseEvents = function() {
  return isBrowser && window.onmousedown === null;
};

// ../../node_modules/framer-motion/dist/es/events/use-pointer-event.js
var mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
};
var touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(name) {
  if (supportsPointerEvents()) {
    return name;
  } else if (supportsTouchEvents()) {
    return touchEventNames[name];
  } else if (supportsMouseEvents()) {
    return mouseEventNames[name];
  }
  return name;
}
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
  return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}

// ../../node_modules/framer-motion/dist/es/gestures/drag/utils/lock.js
function createLock(name) {
  var lock = null;
  return function() {
    var openLock = function() {
      lock = null;
    };
    if (lock === null) {
      lock = name;
      return openLock;
    }
    return false;
  };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag2) {
  var lock = false;
  if (drag2 === "y") {
    lock = globalVerticalLock();
  } else if (drag2 === "x") {
    lock = globalHorizontalLock();
  } else {
    var openHorizontal_1 = globalHorizontalLock();
    var openVertical_1 = globalVerticalLock();
    if (openHorizontal_1 && openVertical_1) {
      lock = function() {
        openHorizontal_1();
        openVertical_1();
      };
    } else {
      if (openHorizontal_1)
        openHorizontal_1();
      if (openVertical_1)
        openVertical_1();
    }
  }
  return lock;
}
function isDragActive() {
  var openGestureLock = getGlobalLock(true);
  if (!openGestureLock)
    return true;
  openGestureLock();
  return false;
}

// ../../node_modules/framer-motion/dist/es/gestures/use-hover-gesture.js
function createHoverEvent(visualElement2, isActive, callback) {
  return function(event, info) {
    var _a;
    if (!isMouseEvent(event) || isDragActive())
      return;
    callback === null || callback === void 0 ? void 0 : callback(event, info);
    (_a = visualElement2.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Hover, isActive);
  };
}
function useHoverGesture(_a) {
  var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement2 = _a.visualElement;
  usePointerEvent(visualElement2, "pointerenter", onHoverStart || whileHover ? createHoverEvent(visualElement2, true, onHoverStart) : void 0);
  usePointerEvent(visualElement2, "pointerleave", onHoverEnd || whileHover ? createHoverEvent(visualElement2, false, onHoverEnd) : void 0);
}

// ../../node_modules/framer-motion/dist/es/gestures/use-tap-gesture.js
var import_react29 = require("react");

// ../../node_modules/framer-motion/dist/es/gestures/utils/is-node-or-child.js
var isNodeOrChild = function(parent, child) {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild(parent, child.parentElement);
  }
};

// ../../node_modules/framer-motion/dist/es/utils/use-unmount-effect.js
var import_react28 = require("react");
function useUnmountEffect(callback) {
  return (0, import_react28.useEffect)(function() {
    return function() {
      return callback();
    };
  }, []);
}

// ../../node_modules/popmotion/dist/es/utils/clamp.js
var clamp2 = function(min, max, v2) {
  return Math.min(Math.max(v2, min), max);
};

// ../../node_modules/popmotion/dist/es/animations/utils/find-spring.js
var safeMin = 1e-3;
var minDuration = 0.01;
var maxDuration = 10;
var minDamping = 0.05;
var maxDamping = 1;
function findSpring(_a) {
  var _b = _a.duration, duration = _b === void 0 ? 800 : _b, _c = _a.bounce, bounce = _c === void 0 ? 0.25 : _c, _d = _a.velocity, velocity = _d === void 0 ? 0 : _d, _e = _a.mass, mass = _e === void 0 ? 1 : _e;
  var envelope;
  var derivative;
  warning2(duration <= maxDuration * 1e3, "Spring duration must be 10 seconds or less");
  var dampingRatio = 1 - bounce;
  dampingRatio = clamp2(minDamping, maxDamping, dampingRatio);
  duration = clamp2(minDuration, maxDuration, duration / 1e3);
  if (dampingRatio < 1) {
    envelope = function(undampedFreq2) {
      var exponentialDecay = undampedFreq2 * dampingRatio;
      var delta2 = exponentialDecay * duration;
      var a3 = exponentialDecay - velocity;
      var b3 = calcAngularFreq(undampedFreq2, dampingRatio);
      var c3 = Math.exp(-delta2);
      return safeMin - a3 / b3 * c3;
    };
    derivative = function(undampedFreq2) {
      var exponentialDecay = undampedFreq2 * dampingRatio;
      var delta2 = exponentialDecay * duration;
      var d2 = delta2 * velocity + velocity;
      var e2 = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq2, 2) * duration;
      var f2 = Math.exp(-delta2);
      var g2 = calcAngularFreq(Math.pow(undampedFreq2, 2), dampingRatio);
      var factor = -envelope(undampedFreq2) + safeMin > 0 ? -1 : 1;
      return factor * ((d2 - e2) * f2) / g2;
    };
  } else {
    envelope = function(undampedFreq2) {
      var a3 = Math.exp(-undampedFreq2 * duration);
      var b3 = (undampedFreq2 - velocity) * duration + 1;
      return -safeMin + a3 * b3;
    };
    derivative = function(undampedFreq2) {
      var a3 = Math.exp(-undampedFreq2 * duration);
      var b3 = (velocity - undampedFreq2) * (duration * duration);
      return a3 * b3;
    };
  }
  var initialGuess = 5 / duration;
  var undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration = duration * 1e3;
  if (isNaN(undampedFreq)) {
    return {
      stiffness: 100,
      damping: 10,
      duration
    };
  } else {
    var stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration
    };
  }
}
var rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  var result = initialGuess;
  for (var i2 = 1; i2 < rootIterations; i2++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

// ../../node_modules/popmotion/dist/es/animations/generators/spring.js
var durationKeys = ["duration", "bounce"];
var physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
  return keys.some(function(key) {
    return options[key] !== void 0;
  });
}
function getSpringOptions(options) {
  var springOptions = __assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: false }, options);
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    var derived = findSpring(options);
    springOptions = __assign(__assign(__assign({}, springOptions), derived), { velocity: 0, mass: 1 });
    springOptions.isResolvedFromDuration = true;
  }
  return springOptions;
}
function spring(_a) {
  var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, _d = _a.restSpeed, restSpeed = _d === void 0 ? 2 : _d, restDelta = _a.restDelta, options = __rest(_a, ["from", "to", "restSpeed", "restDelta"]);
  var state = { done: false, value: from };
  var _e = getSpringOptions(options), stiffness = _e.stiffness, damping = _e.damping, mass = _e.mass, velocity = _e.velocity, duration = _e.duration, isResolvedFromDuration = _e.isResolvedFromDuration;
  var resolveSpring = zero;
  var resolveVelocity = zero;
  function createSpring() {
    var initialVelocity = velocity ? -(velocity / 1e3) : 0;
    var initialDelta = to - from;
    var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1e3;
    restDelta !== null && restDelta !== void 0 ? restDelta : restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4;
    if (dampingRatio < 1) {
      var angularFreq_1 = calcAngularFreq(undampedAngularFreq, dampingRatio);
      resolveSpring = function(t2) {
        var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t2);
        return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 * Math.sin(angularFreq_1 * t2) + initialDelta * Math.cos(angularFreq_1 * t2));
      };
      resolveVelocity = function(t2) {
        var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t2);
        return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq_1 * t2) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 + initialDelta * Math.cos(angularFreq_1 * t2)) - envelope * (Math.cos(angularFreq_1 * t2) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq_1 * initialDelta * Math.sin(angularFreq_1 * t2));
      };
    } else if (dampingRatio === 1) {
      resolveSpring = function(t2) {
        return to - Math.exp(-undampedAngularFreq * t2) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t2);
      };
    } else {
      var dampedAngularFreq_1 = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
      resolveSpring = function(t2) {
        var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t2);
        var freqForT = Math.min(dampedAngularFreq_1 * t2, 300);
        return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq_1 * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq_1;
      };
    }
  }
  createSpring();
  return {
    next: function(t2) {
      var current = resolveSpring(t2);
      if (!isResolvedFromDuration) {
        var currentVelocity = resolveVelocity(t2) * 1e3;
        var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        var isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t2 >= duration;
      }
      state.value = state.done ? to : current;
      return state;
    },
    flipTarget: function() {
      var _a2;
      velocity = -velocity;
      _a2 = [to, from], from = _a2[0], to = _a2[1];
      createSpring();
    }
  };
}
spring.needsInterpolation = function(a3, b3) {
  return typeof a3 === "string" || typeof b3 === "string";
};
var zero = function(_t) {
  return 0;
};

// ../../node_modules/popmotion/dist/es/utils/progress.js
var progress = function(from, to, value) {
  var toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

// ../../node_modules/popmotion/dist/es/utils/mix.js
var mix = function(from, to, progress2) {
  return -progress2 * from + progress2 * to + from;
};

// ../../node_modules/popmotion/dist/es/utils/mix-color.js
var mixLinearColor = function(from, to, v2) {
  var fromExpo = from * from;
  var toExpo = to * to;
  return Math.sqrt(Math.max(0, v2 * (toExpo - fromExpo) + fromExpo));
};
var colorTypes = [hex, rgba, hsla];
var getColorType = function(v2) {
  return colorTypes.find(function(type) {
    return type.test(v2);
  });
};
var notAnimatable = function(color2) {
  return "'" + color2 + "' is not an animatable color. Use the equivalent color code instead.";
};
var mixColor = function(from, to) {
  var fromColorType = getColorType(from);
  var toColorType = getColorType(to);
  invariant(!!fromColorType, notAnimatable(from));
  invariant(!!toColorType, notAnimatable(to));
  invariant(fromColorType.transform === toColorType.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
  var fromColor = fromColorType.parse(from);
  var toColor = toColorType.parse(to);
  var blended = __assign({}, fromColor);
  var mixFunc = fromColorType === hsla ? mix : mixLinearColor;
  return function(v2) {
    for (var key in blended) {
      if (key !== "alpha") {
        blended[key] = mixFunc(fromColor[key], toColor[key], v2);
      }
    }
    blended.alpha = mix(fromColor.alpha, toColor.alpha, v2);
    return fromColorType.transform(blended);
  };
};

// ../../node_modules/popmotion/dist/es/utils/inc.js
var isNum = function(v2) {
  return typeof v2 === "number";
};

// ../../node_modules/popmotion/dist/es/utils/pipe.js
var combineFunctions = function(a3, b3) {
  return function(v2) {
    return b3(a3(v2));
  };
};
var pipe = function() {
  var transformers = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    transformers[_i] = arguments[_i];
  }
  return transformers.reduce(combineFunctions);
};

// ../../node_modules/popmotion/dist/es/utils/mix-complex.js
function getMixer(origin, target) {
  if (isNum(origin)) {
    return function(v2) {
      return mix(origin, target, v2);
    };
  } else if (color.test(origin)) {
    return mixColor(origin, target);
  } else {
    return mixComplex(origin, target);
  }
}
var mixArray = function(from, to) {
  var output = __spreadArray([], from);
  var numValues = output.length;
  var blendValue = from.map(function(fromThis, i2) {
    return getMixer(fromThis, to[i2]);
  });
  return function(v2) {
    for (var i2 = 0; i2 < numValues; i2++) {
      output[i2] = blendValue[i2](v2);
    }
    return output;
  };
};
var mixObject = function(origin, target) {
  var output = __assign(__assign({}, origin), target);
  var blendValue = {};
  for (var key in output) {
    if (origin[key] !== void 0 && target[key] !== void 0) {
      blendValue[key] = getMixer(origin[key], target[key]);
    }
  }
  return function(v2) {
    for (var key2 in blendValue) {
      output[key2] = blendValue[key2](v2);
    }
    return output;
  };
};
function analyse2(value) {
  var parsed = complex.parse(value);
  var numValues = parsed.length;
  var numNumbers = 0;
  var numRGB = 0;
  var numHSL = 0;
  for (var i2 = 0; i2 < numValues; i2++) {
    if (numNumbers || typeof parsed[i2] === "number") {
      numNumbers++;
    } else {
      if (parsed[i2].hue !== void 0) {
        numHSL++;
      } else {
        numRGB++;
      }
    }
  }
  return { parsed, numNumbers, numRGB, numHSL };
}
var mixComplex = function(origin, target) {
  var template = complex.createTransformer(target);
  var originStats = analyse2(origin);
  var targetStats = analyse2(target);
  invariant(originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
  return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
};

// ../../node_modules/popmotion/dist/es/utils/interpolate.js
var mixNumber = function(from, to) {
  return function(p2) {
    return mix(from, to, p2);
  };
};
function detectMixerFactory(v2) {
  if (typeof v2 === "number") {
    return mixNumber;
  } else if (typeof v2 === "string") {
    if (color.test(v2)) {
      return mixColor;
    } else {
      return mixComplex;
    }
  } else if (Array.isArray(v2)) {
    return mixArray;
  } else if (typeof v2 === "object") {
    return mixObject;
  }
}
function createMixers(output, ease, customMixer) {
  var mixers = [];
  var mixerFactory = customMixer || detectMixerFactory(output[0]);
  var numMixers = output.length - 1;
  for (var i2 = 0; i2 < numMixers; i2++) {
    var mixer = mixerFactory(output[i2], output[i2 + 1]);
    if (ease) {
      var easingFunction = Array.isArray(ease) ? ease[i2] : ease;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
function fastInterpolate(_a, _b) {
  var from = _a[0], to = _a[1];
  var mixer = _b[0];
  return function(v2) {
    return mixer(progress(from, to, v2));
  };
}
function slowInterpolate(input, mixers) {
  var inputLength = input.length;
  var lastInputIndex = inputLength - 1;
  return function(v2) {
    var mixerIndex = 0;
    var foundMixerIndex = false;
    if (v2 <= input[0]) {
      foundMixerIndex = true;
    } else if (v2 >= input[lastInputIndex]) {
      mixerIndex = lastInputIndex - 1;
      foundMixerIndex = true;
    }
    if (!foundMixerIndex) {
      var i2 = 1;
      for (; i2 < inputLength; i2++) {
        if (input[i2] > v2 || i2 === lastInputIndex) {
          break;
        }
      }
      mixerIndex = i2 - 1;
    }
    var progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v2);
    return mixers[mixerIndex](progressInRange);
  };
}
function interpolate(input, output, _a) {
  var _b = _a === void 0 ? {} : _a, _c = _b.clamp, isClamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
  var inputLength = input.length;
  invariant(inputLength === output.length, "Both input and output ranges must be the same length");
  invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
  if (input[0] > input[inputLength - 1]) {
    input = [].concat(input);
    output = [].concat(output);
    input.reverse();
    output.reverse();
  }
  var mixers = createMixers(output, ease, mixer);
  var interpolator = inputLength === 2 ? fastInterpolate(input, mixers) : slowInterpolate(input, mixers);
  return isClamp ? function(v2) {
    return interpolator(clamp2(input[0], input[inputLength - 1], v2));
  } : interpolator;
}

// ../../node_modules/popmotion/dist/es/easing/utils.js
var reverseEasing = function(easing) {
  return function(p2) {
    return 1 - easing(1 - p2);
  };
};
var mirrorEasing = function(easing) {
  return function(p2) {
    return p2 <= 0.5 ? easing(2 * p2) / 2 : (2 - easing(2 * (1 - p2))) / 2;
  };
};
var createExpoIn = function(power) {
  return function(p2) {
    return Math.pow(p2, power);
  };
};
var createBackIn = function(power) {
  return function(p2) {
    return p2 * p2 * ((power + 1) * p2 - power);
  };
};
var createAnticipate = function(power) {
  var backEasing = createBackIn(power);
  return function(p2) {
    return (p2 *= 2) < 1 ? 0.5 * backEasing(p2) : 0.5 * (2 - Math.pow(2, -10 * (p2 - 1)));
  };
};

// ../../node_modules/popmotion/dist/es/easing/index.js
var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var BOUNCE_FIRST_THRESHOLD = 4 / 11;
var BOUNCE_SECOND_THRESHOLD = 8 / 11;
var BOUNCE_THIRD_THRESHOLD = 9 / 10;
var linear = function(p2) {
  return p2;
};
var easeIn = createExpoIn(2);
var easeOut = reverseEasing(easeIn);
var easeInOut = mirrorEasing(easeIn);
var circIn = function(p2) {
  return 1 - Math.sin(Math.acos(p2));
};
var circOut = reverseEasing(circIn);
var circInOut = mirrorEasing(circOut);
var backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
var backOut = reverseEasing(backIn);
var backInOut = mirrorEasing(backIn);
var anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
var ca = 4356 / 361;
var cb = 35442 / 1805;
var cc = 16061 / 1805;
var bounceOut = function(p2) {
  if (p2 === 1 || p2 === 0)
    return p2;
  var p22 = p2 * p2;
  return p2 < BOUNCE_FIRST_THRESHOLD ? 7.5625 * p22 : p2 < BOUNCE_SECOND_THRESHOLD ? 9.075 * p22 - 9.9 * p2 + 3.4 : p2 < BOUNCE_THIRD_THRESHOLD ? ca * p22 - cb * p2 + cc : 10.8 * p2 * p2 - 20.52 * p2 + 10.72;
};
var bounceIn = reverseEasing(bounceOut);
var bounceInOut = function(p2) {
  return p2 < 0.5 ? 0.5 * (1 - bounceOut(1 - p2 * 2)) : 0.5 * bounceOut(p2 * 2 - 1) + 0.5;
};

// ../../node_modules/popmotion/dist/es/animations/generators/keyframes.js
function defaultEasing(values, easing) {
  return values.map(function() {
    return easing || easeInOut;
  }).splice(0, values.length - 1);
}
function defaultOffset(values) {
  var numValues = values.length;
  return values.map(function(_value, i2) {
    return i2 !== 0 ? i2 / (numValues - 1) : 0;
  });
}
function convertOffsetToTimes(offset, duration) {
  return offset.map(function(o2) {
    return o2 * duration;
  });
}
function keyframes3(_a) {
  var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, ease = _a.ease, offset = _a.offset, _d = _a.duration, duration = _d === void 0 ? 300 : _d;
  var state = { done: false, value: from };
  var values = Array.isArray(to) ? to : [from, to];
  var times = convertOffsetToTimes(offset && offset.length === values.length ? offset : defaultOffset(values), duration);
  function createInterpolator() {
    return interpolate(times, values, {
      ease: Array.isArray(ease) ? ease : defaultEasing(values, ease)
    });
  }
  var interpolator = createInterpolator();
  return {
    next: function(t2) {
      state.value = interpolator(t2);
      state.done = t2 >= duration;
      return state;
    },
    flipTarget: function() {
      values.reverse();
      interpolator = createInterpolator();
    }
  };
}

// ../../node_modules/popmotion/dist/es/animations/generators/decay.js
function decay(_a) {
  var _b = _a.velocity, velocity = _b === void 0 ? 0 : _b, _c = _a.from, from = _c === void 0 ? 0 : _c, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = _a.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = _a.modifyTarget;
  var state = { done: false, value: from };
  var amplitude = power * velocity;
  var ideal = from + amplitude;
  var target = modifyTarget === void 0 ? ideal : modifyTarget(ideal);
  if (target !== ideal)
    amplitude = target - from;
  return {
    next: function(t2) {
      var delta2 = -amplitude * Math.exp(-t2 / timeConstant);
      state.done = !(delta2 > restDelta || delta2 < -restDelta);
      state.value = state.done ? target : target + delta2;
      return state;
    },
    flipTarget: function() {
    }
  };
}

// ../../node_modules/popmotion/dist/es/animations/utils/detect-animation-from-options.js
var types = { keyframes: keyframes3, spring, decay };
function detectAnimationFromOptions(config) {
  if (Array.isArray(config.to)) {
    return keyframes3;
  } else if (types[config.type]) {
    return types[config.type];
  }
  var keys = new Set(Object.keys(config));
  if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) {
    return keyframes3;
  } else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) {
    return spring;
  }
  return keyframes3;
}

// ../../node_modules/framesync/dist/es/on-next-frame.js
var defaultTimestep = 1 / 60 * 1e3;
var getCurrentTime = typeof performance !== "undefined" ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
var onNextFrame = typeof window !== "undefined" ? function(callback) {
  return window.requestAnimationFrame(callback);
} : function(callback) {
  return setTimeout(function() {
    return callback(getCurrentTime());
  }, defaultTimestep);
};

// ../../node_modules/framesync/dist/es/create-render-step.js
function createRenderStep(runNextFrame2) {
  var toRun = [];
  var toRunNextFrame = [];
  var numToRun = 0;
  var isProcessing2 = false;
  var toKeepAlive = /* @__PURE__ */ new WeakSet();
  var step = {
    schedule: function(callback, keepAlive, immediate) {
      if (keepAlive === void 0) {
        keepAlive = false;
      }
      if (immediate === void 0) {
        immediate = false;
      }
      var addToCurrentFrame = immediate && isProcessing2;
      var buffer = addToCurrentFrame ? toRun : toRunNextFrame;
      if (keepAlive)
        toKeepAlive.add(callback);
      if (buffer.indexOf(callback) === -1) {
        buffer.push(callback);
        if (addToCurrentFrame && isProcessing2)
          numToRun = toRun.length;
      }
      return callback;
    },
    cancel: function(callback) {
      var index = toRunNextFrame.indexOf(callback);
      if (index !== -1)
        toRunNextFrame.splice(index, 1);
      toKeepAlive.delete(callback);
    },
    process: function(frameData) {
      var _a;
      isProcessing2 = true;
      _a = [toRunNextFrame, toRun], toRun = _a[0], toRunNextFrame = _a[1];
      toRunNextFrame.length = 0;
      numToRun = toRun.length;
      if (numToRun) {
        for (var i2 = 0; i2 < numToRun; i2++) {
          var callback = toRun[i2];
          callback(frameData);
          if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame2();
          }
        }
      }
      isProcessing2 = false;
    }
  };
  return step;
}

// ../../node_modules/framesync/dist/es/index.js
var maxElapsed = 40;
var useDefaultElapsed = true;
var runNextFrame = false;
var isProcessing = false;
var frame = {
  delta: 0,
  timestamp: 0
};
var stepsOrder = ["read", "update", "preRender", "render", "postRender"];
var steps = /* @__PURE__ */ stepsOrder.reduce(function(acc, key) {
  acc[key] = createRenderStep(function() {
    return runNextFrame = true;
  });
  return acc;
}, {});
var sync = /* @__PURE__ */ stepsOrder.reduce(function(acc, key) {
  var step = steps[key];
  acc[key] = function(process2, keepAlive, immediate) {
    if (keepAlive === void 0) {
      keepAlive = false;
    }
    if (immediate === void 0) {
      immediate = false;
    }
    if (!runNextFrame)
      startLoop();
    return step.schedule(process2, keepAlive, immediate);
  };
  return acc;
}, {});
var cancelSync = /* @__PURE__ */ stepsOrder.reduce(function(acc, key) {
  acc[key] = steps[key].cancel;
  return acc;
}, {});
var flushSync = /* @__PURE__ */ stepsOrder.reduce(function(acc, key) {
  acc[key] = function() {
    return steps[key].process(frame);
  };
  return acc;
}, {});
var processStep = function(stepId) {
  return steps[stepId].process(frame);
};
var processFrame = function(timestamp) {
  runNextFrame = false;
  frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
  frame.timestamp = timestamp;
  isProcessing = true;
  stepsOrder.forEach(processStep);
  isProcessing = false;
  if (runNextFrame) {
    useDefaultElapsed = false;
    onNextFrame(processFrame);
  }
};
var startLoop = function() {
  runNextFrame = true;
  useDefaultElapsed = true;
  if (!isProcessing)
    onNextFrame(processFrame);
};
var getFrameData = function() {
  return frame;
};
var es_default = sync;

// ../../node_modules/popmotion/dist/es/animations/utils/elapsed.js
function loopElapsed(elapsed, duration, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration, delay, isForwardPlayback) {
  if (delay === void 0) {
    delay = 0;
  }
  if (isForwardPlayback === void 0) {
    isForwardPlayback = true;
  }
  return isForwardPlayback ? loopElapsed(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
  return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}

// ../../node_modules/popmotion/dist/es/animations/index.js
var framesync = function(update) {
  var passTimestamp = function(_a) {
    var delta2 = _a.delta;
    return update(delta2);
  };
  return {
    start: function() {
      return es_default.update(passTimestamp, true);
    },
    stop: function() {
      return cancelSync.update(passTimestamp);
    }
  };
};
function animate(_a) {
  var _b, _c;
  var from = _a.from, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, _e = _a.driver, driver = _e === void 0 ? framesync : _e, _f = _a.elapsed, elapsed = _f === void 0 ? 0 : _f, _g = _a.repeat, repeatMax = _g === void 0 ? 0 : _g, _h = _a.repeatType, repeatType = _h === void 0 ? "loop" : _h, _j = _a.repeatDelay, repeatDelay = _j === void 0 ? 0 : _j, onPlay = _a.onPlay, onStop = _a.onStop, onComplete = _a.onComplete, onRepeat = _a.onRepeat, onUpdate = _a.onUpdate, options = __rest(_a, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  var to = options.to;
  var driverControls;
  var repeatCount = 0;
  var computedDuration = options.duration;
  var latest;
  var isComplete = false;
  var isForwardPlayback = true;
  var interpolateFromNumber;
  var animator = detectAnimationFromOptions(options);
  if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
    interpolateFromNumber = interpolate([0, 100], [from, to], {
      clamp: false
    });
    from = 0;
    to = 100;
  }
  var animation = animator(__assign(__assign({}, options), { from, to }));
  function repeat() {
    repeatCount++;
    if (repeatType === "reverse") {
      isForwardPlayback = repeatCount % 2 === 0;
      elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
    } else {
      elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
      if (repeatType === "mirror")
        animation.flipTarget();
    }
    isComplete = false;
    onRepeat && onRepeat();
  }
  function complete() {
    driverControls.stop();
    onComplete && onComplete();
  }
  function update(delta2) {
    if (!isForwardPlayback)
      delta2 = -delta2;
    elapsed += delta2;
    if (!isComplete) {
      var state = animation.next(Math.max(0, elapsed));
      latest = state.value;
      if (interpolateFromNumber)
        latest = interpolateFromNumber(latest);
      isComplete = isForwardPlayback ? state.done : elapsed <= 0;
    }
    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(latest);
    if (isComplete) {
      if (repeatCount === 0)
        computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
      if (repeatCount < repeatMax) {
        hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
      } else {
        complete();
      }
    }
  }
  function play() {
    onPlay === null || onPlay === void 0 ? void 0 : onPlay();
    driverControls = driver(update);
    driverControls.start();
  }
  autoplay && play();
  return {
    stop: function() {
      onStop === null || onStop === void 0 ? void 0 : onStop();
      driverControls.stop();
    }
  };
}

// ../../node_modules/popmotion/dist/es/utils/velocity-per-second.js
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1e3 / frameDuration) : 0;
}

// ../../node_modules/popmotion/dist/es/animations/inertia.js
function inertia(_a) {
  var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.velocity, velocity = _c === void 0 ? 0 : _c, min = _a.min, max = _a.max, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 750 : _e, _f = _a.bounceStiffness, bounceStiffness = _f === void 0 ? 500 : _f, _g = _a.bounceDamping, bounceDamping = _g === void 0 ? 10 : _g, _h = _a.restDelta, restDelta = _h === void 0 ? 1 : _h, modifyTarget = _a.modifyTarget, driver = _a.driver, onUpdate = _a.onUpdate, onComplete = _a.onComplete;
  var currentAnimation;
  function isOutOfBounds(v2) {
    return min !== void 0 && v2 < min || max !== void 0 && v2 > max;
  }
  function boundaryNearest(v2) {
    if (min === void 0)
      return max;
    if (max === void 0)
      return min;
    return Math.abs(min - v2) < Math.abs(max - v2) ? min : max;
  }
  function startAnimation2(options) {
    currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
    currentAnimation = animate(__assign(__assign({}, options), { driver, onUpdate: function(v2) {
      var _a2;
      onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v2);
      (_a2 = options.onUpdate) === null || _a2 === void 0 ? void 0 : _a2.call(options, v2);
    }, onComplete }));
  }
  function startSpring(options) {
    startAnimation2(__assign({ type: "spring", stiffness: bounceStiffness, damping: bounceDamping, restDelta }, options));
  }
  if (isOutOfBounds(from)) {
    startSpring({ from, velocity, to: boundaryNearest(from) });
  } else {
    var target = power * velocity + from;
    if (typeof modifyTarget !== "undefined")
      target = modifyTarget(target);
    var boundary_1 = boundaryNearest(target);
    var heading_1 = boundary_1 === min ? -1 : 1;
    var prev_1;
    var current_1;
    var checkBoundary = function(v2) {
      prev_1 = current_1;
      current_1 = v2;
      velocity = velocityPerSecond(v2 - prev_1, getFrameData().delta);
      if (heading_1 === 1 && v2 > boundary_1 || heading_1 === -1 && v2 < boundary_1) {
        startSpring({ from: v2, to: boundary_1, velocity });
      }
    };
    startAnimation2({
      type: "decay",
      from,
      velocity,
      timeConstant,
      power,
      restDelta,
      modifyTarget,
      onUpdate: isOutOfBounds(target) ? checkBoundary : void 0
    });
  }
  return {
    stop: function() {
      return currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
    }
  };
}

// ../../node_modules/popmotion/dist/es/utils/is-point.js
var isPoint = function(point) {
  return point.hasOwnProperty("x") && point.hasOwnProperty("y");
};

// ../../node_modules/popmotion/dist/es/utils/is-point-3d.js
var isPoint3D = function(point) {
  return isPoint(point) && point.hasOwnProperty("z");
};

// ../../node_modules/popmotion/dist/es/utils/distance.js
var distance1D = function(a3, b3) {
  return Math.abs(a3 - b3);
};
function distance(a3, b3) {
  if (isNum(a3) && isNum(b3)) {
    return distance1D(a3, b3);
  } else if (isPoint(a3) && isPoint(b3)) {
    var xDelta = distance1D(a3.x, b3.x);
    var yDelta = distance1D(a3.y, b3.y);
    var zDelta = isPoint3D(a3) && isPoint3D(b3) ? distance1D(a3.z, b3.z) : 0;
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
  }
}

// ../../node_modules/popmotion/dist/es/easing/cubic-bezier.js
var a2 = function(a1, a22) {
  return 1 - 3 * a22 + 3 * a1;
};
var b2 = function(a1, a22) {
  return 3 * a22 - 6 * a1;
};
var c2 = function(a1) {
  return 3 * a1;
};
var calcBezier = function(t2, a1, a22) {
  return ((a2(a1, a22) * t2 + b2(a1, a22)) * t2 + c2(a1)) * t2;
};
var getSlope = function(t2, a1, a22) {
  return 3 * a2(a1, a22) * t2 * t2 + 2 * b2(a1, a22) * t2 + c2(a1);
};
var subdivisionPrecision = 1e-7;
var subdivisionMaxIterations = 10;
function binarySubdivide(aX, aA, aB, mX1, mX2) {
  var currentX;
  var currentT;
  var i2 = 0;
  do {
    currentT = aA + (aB - aA) / 2;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i2 < subdivisionMaxIterations);
  return currentT;
}
var newtonIterations = 8;
var newtonMinSlope = 1e-3;
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
  for (var i2 = 0; i2 < newtonIterations; ++i2) {
    var currentSlope = getSlope(aGuessT, mX1, mX2);
    if (currentSlope === 0) {
      return aGuessT;
    }
    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
    aGuessT -= currentX / currentSlope;
  }
  return aGuessT;
}
var kSplineTableSize = 11;
var kSampleStepSize = 1 / (kSplineTableSize - 1);
function cubicBezier(mX1, mY1, mX2, mY2) {
  if (mX1 === mY1 && mX2 === mY2)
    return linear;
  var sampleValues = new Float32Array(kSplineTableSize);
  for (var i2 = 0; i2 < kSplineTableSize; ++i2) {
    sampleValues[i2] = calcBezier(i2 * kSampleStepSize, mX1, mX2);
  }
  function getTForX(aX) {
    var intervalStart = 0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;
    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;
    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= newtonMinSlope) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }
  return function(t2) {
    return t2 === 0 || t2 === 1 ? t2 : calcBezier(getTForX(t2), mY1, mY2);
  };
}

// ../../node_modules/framer-motion/dist/es/gestures/use-tap-gesture.js
function useTapGesture(_a) {
  var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement2 = _a.visualElement;
  var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
  var isPressing = (0, import_react29.useRef)(false);
  var cancelPointerEndListeners = (0, import_react29.useRef)(null);
  function removePointerEndListener() {
    var _a2;
    (_a2 = cancelPointerEndListeners.current) === null || _a2 === void 0 ? void 0 : _a2.call(cancelPointerEndListeners);
    cancelPointerEndListeners.current = null;
  }
  function checkPointerEnd() {
    var _a2;
    removePointerEndListener();
    isPressing.current = false;
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Tap, false);
    return !isDragActive();
  }
  function onPointerUp(event, info) {
    if (!checkPointerEnd())
      return;
    !isNodeOrChild(visualElement2.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info) : onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
  }
  function onPointerCancel(event, info) {
    if (!checkPointerEnd())
      return;
    onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
  }
  function onPointerDown(event, info) {
    var _a2;
    removePointerEndListener();
    if (isPressing.current)
      return;
    isPressing.current = true;
    cancelPointerEndListeners.current = pipe(addPointerEvent(window, "pointerup", onPointerUp), addPointerEvent(window, "pointercancel", onPointerCancel));
    onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
    (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Tap, true);
  }
  usePointerEvent(visualElement2, "pointerdown", hasPressListeners ? onPointerDown : void 0);
  useUnmountEffect(removePointerEndListener);
}

// ../../node_modules/framer-motion/dist/es/motion/utils/make-renderless-component.js
var makeRenderlessComponent = function(hook) {
  return function(props) {
    hook(props);
    return null;
  };
};

// ../../node_modules/framer-motion/dist/es/motion/features/gestures.js
var gestureAnimations = {
  tap: makeRenderlessComponent(useTapGesture),
  focus: makeRenderlessComponent(useFocusGesture),
  hover: makeRenderlessComponent(useHoverGesture)
};

// ../../node_modules/framer-motion/dist/es/motion/features/animations.js
var import_react30 = require("react");

// ../../node_modules/framer-motion/dist/es/utils/shallow-compare.js
function shallowCompare(next, prev) {
  if (!Array.isArray(prev))
    return false;
  var prevLength = prev.length;
  if (prevLength !== next.length)
    return false;
  for (var i2 = 0; i2 < prevLength; i2++) {
    if (prev[i2] !== next[i2])
      return false;
  }
  return true;
}

// ../../node_modules/framer-motion/dist/es/utils/time-conversion.js
var secondsToMilliseconds = function(seconds) {
  return seconds * 1e3;
};

// ../../node_modules/framer-motion/dist/es/animation/utils/easing.js
var easingLookup = {
  linear,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate,
  bounceIn,
  bounceInOut,
  bounceOut
};
var easingDefinitionToFunction = function(definition) {
  if (Array.isArray(definition)) {
    invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var _a = __read(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
    return cubicBezier(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    invariant(easingLookup[definition] !== void 0, "Invalid easing type '" + definition + "'");
    return easingLookup[definition];
  }
  return definition;
};
var isEasingArray = function(ease) {
  return Array.isArray(ease) && typeof ease[0] !== "number";
};

// ../../node_modules/framer-motion/dist/es/animation/utils/is-animatable.js
var isAnimatable = function(key, value) {
  if (key === "zIndex")
    return false;
  if (typeof value === "number" || Array.isArray(value))
    return true;
  if (typeof value === "string" && complex.test(value) && !value.startsWith("url(")) {
    return true;
  }
  return false;
};

// ../../node_modules/framer-motion/dist/es/animation/utils/default-transitions.js
var underDampedSpring = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restDelta: 0.5,
    restSpeed: 10
  };
};
var criticallyDampedSpring = function(to) {
  return {
    type: "spring",
    stiffness: 550,
    damping: to === 0 ? 2 * Math.sqrt(550) : 30,
    restDelta: 0.01,
    restSpeed: 10
  };
};
var linearTween = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
};
var keyframes4 = function(values) {
  return {
    type: "keyframes",
    duration: 0.8,
    values
  };
};
var defaultTransitions = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: criticallyDampedSpring,
  scaleY: criticallyDampedSpring,
  scale: criticallyDampedSpring,
  opacity: linearTween,
  backgroundColor: linearTween,
  color: linearTween,
  default: criticallyDampedSpring
};
var getDefaultTransition = function(valueKey, to) {
  var transitionFactory;
  if (isKeyframesTarget(to)) {
    transitionFactory = keyframes4;
  } else {
    transitionFactory = defaultTransitions[valueKey] || defaultTransitions.default;
  }
  return __assign({ to }, transitionFactory(to));
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/defaults.js
var defaultValueTypes = __assign(__assign({}, numberValueTypes), {
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
});
var getDefaultValueType = function(key) {
  return defaultValueTypes[key];
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/animatable-none.js
function getAnimatableNone2(key, value) {
  var _a;
  var defaultValueType = getDefaultValueType(key);
  if (defaultValueType !== filter)
    defaultValueType = complex;
  return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

// ../../node_modules/framer-motion/dist/es/animation/utils/transitions.js
function isTransitionDefined(_a) {
  _a.when;
  _a.delay;
  _a.delayChildren;
  _a.staggerChildren;
  _a.staggerDirection;
  _a.repeat;
  _a.repeatType;
  _a.repeatDelay;
  _a.from;
  var transition = __rest(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(transition).length;
}
var legacyRepeatWarning = false;
function convertTransitionToAnimationOptions(_a) {
  var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = __rest(_a, ["ease", "times", "yoyo", "flip", "loop"]);
  var options = __assign({}, transition);
  if (times)
    options["offset"] = times;
  if (transition.duration)
    options["duration"] = secondsToMilliseconds(transition.duration);
  if (transition.repeatDelay)
    options.repeatDelay = secondsToMilliseconds(transition.repeatDelay);
  if (ease) {
    options["ease"] = isEasingArray(ease) ? ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease);
  }
  if (transition.type === "tween")
    options.type = "keyframes";
  if (yoyo || loop || flip) {
    warning2(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
    legacyRepeatWarning = true;
    if (yoyo) {
      options.repeatType = "reverse";
    } else if (loop) {
      options.repeatType = "loop";
    } else if (flip) {
      options.repeatType = "mirror";
    }
    options.repeat = loop || yoyo || flip || transition.repeat;
  }
  if (transition.type !== "spring")
    options.type = "keyframes";
  return options;
}
function getDelayFromTransition(transition, key) {
  var _a;
  var valueTransition = getValueTransition(transition, key) || {};
  return (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : 0;
}
function hydrateKeyframes(options) {
  if (Array.isArray(options.to) && options.to[0] === null) {
    options.to = __spreadArray([], __read(options.to));
    options.to[0] = options.from;
  }
  return options;
}
function getPopmotionAnimationOptions(transition, options, key) {
  var _a;
  if (Array.isArray(options.to)) {
    (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
  }
  hydrateKeyframes(options);
  if (!isTransitionDefined(transition)) {
    transition = __assign(__assign({}, transition), getDefaultTransition(key, options.to));
  }
  return __assign(__assign({}, options), convertTransitionToAnimationOptions(transition));
}
function getAnimation(key, value, target, transition, onComplete) {
  var _a;
  var valueTransition = getValueTransition(transition, key);
  var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
  var isTargetAnimatable = isAnimatable(key, target);
  if (origin === "none" && isTargetAnimatable && typeof target === "string") {
    origin = getAnimatableNone2(key, target);
  } else if (isZero(origin) && typeof target === "string") {
    origin = getZeroUnit(target);
  } else if (!Array.isArray(target) && isZero(target) && typeof origin === "string") {
    target = getZeroUnit(origin);
  }
  var isOriginAnimatable = isAnimatable(key, origin);
  warning2(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + ' from "' + origin + '" to "' + target + '". ' + origin + " is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property.");
  function start() {
    var options = {
      from: origin,
      to: target,
      velocity: value.getVelocity(),
      onComplete,
      onUpdate: function(v2) {
        return value.set(v2);
      }
    };
    return valueTransition.type === "inertia" || valueTransition.type === "decay" ? inertia(__assign(__assign({}, options), valueTransition)) : animate(__assign(__assign({}, getPopmotionAnimationOptions(valueTransition, options, key)), { onUpdate: function(v2) {
      var _a2;
      options.onUpdate(v2);
      (_a2 = valueTransition.onUpdate) === null || _a2 === void 0 ? void 0 : _a2.call(valueTransition, v2);
    }, onComplete: function() {
      var _a2;
      options.onComplete();
      (_a2 = valueTransition.onComplete) === null || _a2 === void 0 ? void 0 : _a2.call(valueTransition);
    } }));
  }
  function set() {
    var _a2;
    value.set(target);
    onComplete();
    (_a2 = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _a2 === void 0 ? void 0 : _a2.call(valueTransition);
    return { stop: function() {
    } };
  }
  return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function isZero(value) {
  return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function getZeroUnit(potentialUnitType) {
  return typeof potentialUnitType === "number" ? 0 : getAnimatableNone2("", potentialUnitType);
}
function getValueTransition(transition, key) {
  return transition[key] || transition["default"] || transition;
}
function startAnimation(key, value, target, transition) {
  if (transition === void 0) {
    transition = {};
  }
  return value.start(function(onComplete) {
    var delayTimer;
    var controls;
    var animation = getAnimation(key, value, target, transition, onComplete);
    var delay = getDelayFromTransition(transition, key);
    var start = function() {
      return controls = animation();
    };
    if (delay) {
      delayTimer = setTimeout(start, secondsToMilliseconds(delay));
    } else {
      start();
    }
    return function() {
      clearTimeout(delayTimer);
      controls === null || controls === void 0 ? void 0 : controls.stop();
    };
  });
}

// ../../node_modules/framer-motion/dist/es/utils/is-numerical-string.js
var isNumericalString = function(v2) {
  return /^\-?\d*\.?\d+$/.test(v2);
};

// ../../node_modules/framer-motion/dist/es/utils/array.js
function addUniqueItem(arr, item) {
  arr.indexOf(item) === -1 && arr.push(item);
}
function removeItem(arr, item) {
  var index = arr.indexOf(item);
  index > -1 && arr.splice(index, 1);
}

// ../../node_modules/framer-motion/dist/es/utils/subscription-manager.js
var SubscriptionManager = function() {
  function SubscriptionManager2() {
    this.subscriptions = [];
  }
  SubscriptionManager2.prototype.add = function(handler) {
    var _this = this;
    addUniqueItem(this.subscriptions, handler);
    return function() {
      return removeItem(_this.subscriptions, handler);
    };
  };
  SubscriptionManager2.prototype.notify = function(a3, b3, c3) {
    var numSubscriptions = this.subscriptions.length;
    if (!numSubscriptions)
      return;
    if (numSubscriptions === 1) {
      this.subscriptions[0](a3, b3, c3);
    } else {
      for (var i2 = 0; i2 < numSubscriptions; i2++) {
        var handler = this.subscriptions[i2];
        handler && handler(a3, b3, c3);
      }
    }
  };
  SubscriptionManager2.prototype.getSize = function() {
    return this.subscriptions.length;
  };
  SubscriptionManager2.prototype.clear = function() {
    this.subscriptions.length = 0;
  };
  return SubscriptionManager2;
}();

// ../../node_modules/framer-motion/dist/es/value/index.js
var isFloat = function(value) {
  return !isNaN(parseFloat(value));
};
var MotionValue = function() {
  function MotionValue2(init) {
    var _this = this;
    this.timeDelta = 0;
    this.lastUpdated = 0;
    this.updateSubscribers = new SubscriptionManager();
    this.velocityUpdateSubscribers = new SubscriptionManager();
    this.renderSubscribers = new SubscriptionManager();
    this.canTrackVelocity = false;
    this.updateAndNotify = function(v2, render) {
      if (render === void 0) {
        render = true;
      }
      _this.prev = _this.current;
      _this.current = v2;
      var _a = getFrameData(), delta2 = _a.delta, timestamp = _a.timestamp;
      if (_this.lastUpdated !== timestamp) {
        _this.timeDelta = delta2;
        _this.lastUpdated = timestamp;
        es_default.postRender(_this.scheduleVelocityCheck);
      }
      if (_this.prev !== _this.current) {
        _this.updateSubscribers.notify(_this.current);
      }
      if (_this.velocityUpdateSubscribers.getSize()) {
        _this.velocityUpdateSubscribers.notify(_this.getVelocity());
      }
      if (render) {
        _this.renderSubscribers.notify(_this.current);
      }
    };
    this.scheduleVelocityCheck = function() {
      return es_default.postRender(_this.velocityCheck);
    };
    this.velocityCheck = function(_a) {
      var timestamp = _a.timestamp;
      if (timestamp !== _this.lastUpdated) {
        _this.prev = _this.current;
        _this.velocityUpdateSubscribers.notify(_this.getVelocity());
      }
    };
    this.hasAnimated = false;
    this.prev = this.current = init;
    this.canTrackVelocity = isFloat(this.current);
  }
  MotionValue2.prototype.onChange = function(subscription) {
    return this.updateSubscribers.add(subscription);
  };
  MotionValue2.prototype.clearListeners = function() {
    this.updateSubscribers.clear();
  };
  MotionValue2.prototype.onRenderRequest = function(subscription) {
    subscription(this.get());
    return this.renderSubscribers.add(subscription);
  };
  MotionValue2.prototype.attach = function(passiveEffect) {
    this.passiveEffect = passiveEffect;
  };
  MotionValue2.prototype.set = function(v2, render) {
    if (render === void 0) {
      render = true;
    }
    if (!render || !this.passiveEffect) {
      this.updateAndNotify(v2, render);
    } else {
      this.passiveEffect(v2, this.updateAndNotify);
    }
  };
  MotionValue2.prototype.get = function() {
    return this.current;
  };
  MotionValue2.prototype.getPrevious = function() {
    return this.prev;
  };
  MotionValue2.prototype.getVelocity = function() {
    return this.canTrackVelocity ? velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
  };
  MotionValue2.prototype.start = function(animation) {
    var _this = this;
    this.stop();
    return new Promise(function(resolve) {
      _this.hasAnimated = true;
      _this.stopAnimation = animation(resolve);
    }).then(function() {
      return _this.clearAnimation();
    });
  };
  MotionValue2.prototype.stop = function() {
    if (this.stopAnimation)
      this.stopAnimation();
    this.clearAnimation();
  };
  MotionValue2.prototype.isAnimating = function() {
    return !!this.stopAnimation;
  };
  MotionValue2.prototype.clearAnimation = function() {
    this.stopAnimation = null;
  };
  MotionValue2.prototype.destroy = function() {
    this.updateSubscribers.clear();
    this.renderSubscribers.clear();
    this.stop();
  };
  return MotionValue2;
}();
function motionValue(init) {
  return new MotionValue(init);
}

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/test.js
var testValueType = function(v2) {
  return function(type) {
    return type.test(v2);
  };
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/type-auto.js
var auto = {
  test: function(v2) {
    return v2 === "auto";
  },
  parse: function(v2) {
    return v2;
  }
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/dimensions.js
var dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
var findDimensionValueType = function(v2) {
  return dimensionValueTypes.find(testValueType(v2));
};

// ../../node_modules/framer-motion/dist/es/render/dom/value-types/find.js
var valueTypes = __spreadArray(__spreadArray([], __read(dimensionValueTypes)), [color, complex]);
var findValueType = function(v2) {
  return valueTypes.find(testValueType(v2));
};

// ../../node_modules/framer-motion/dist/es/render/utils/setters.js
function setMotionValue(visualElement2, key, value) {
  if (visualElement2.hasValue(key)) {
    visualElement2.getValue(key).set(value);
  } else {
    visualElement2.addValue(key, motionValue(value));
  }
}
function setTarget(visualElement2, definition) {
  var resolved = resolveVariant(visualElement2, definition);
  var _a = resolved ? visualElement2.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
  _a.transition;
  var target = __rest(_a, ["transitionEnd", "transition"]);
  target = __assign(__assign({}, target), transitionEnd);
  for (var key in target) {
    var value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement2, key, value);
  }
}
function checkTargetForNewValues(visualElement2, target, origin) {
  var _a, _b, _c;
  var _d;
  var newValueKeys = Object.keys(target).filter(function(key2) {
    return !visualElement2.hasValue(key2);
  });
  var numNewValues = newValueKeys.length;
  if (!numNewValues)
    return;
  for (var i2 = 0; i2 < numNewValues; i2++) {
    var key = newValueKeys[i2];
    var targetValue = target[key];
    var value = null;
    if (Array.isArray(targetValue)) {
      value = targetValue[0];
    }
    if (value === null) {
      value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement2.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
    }
    if (value === void 0 || value === null)
      continue;
    if (typeof value === "string" && isNumericalString(value)) {
      value = parseFloat(value);
    } else if (!findValueType(value) && complex.test(targetValue)) {
      value = getAnimatableNone2(key, targetValue);
    }
    visualElement2.addValue(key, motionValue(value));
    (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
    visualElement2.setBaseTarget(key, value);
  }
}
function getOriginFromTransition(key, transition) {
  if (!transition)
    return;
  var valueTransition = transition[key] || transition["default"] || transition;
  return valueTransition.from;
}
function getOrigin(target, transition, visualElement2) {
  var _a, _b;
  var origin = {};
  for (var key in target) {
    origin[key] = (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement2.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
  }
  return origin;
}

// ../../node_modules/framer-motion/dist/es/render/utils/animation.js
function animateVisualElement(visualElement2, definition, options) {
  if (options === void 0) {
    options = {};
  }
  visualElement2.notifyAnimationStart();
  var animation;
  if (Array.isArray(definition)) {
    var animations2 = definition.map(function(variant) {
      return animateVariant(visualElement2, variant, options);
    });
    animation = Promise.all(animations2);
  } else if (typeof definition === "string") {
    animation = animateVariant(visualElement2, definition, options);
  } else {
    var resolvedDefinition = typeof definition === "function" ? resolveVariant(visualElement2, definition, options.custom) : definition;
    animation = animateTarget(visualElement2, resolvedDefinition, options);
  }
  return animation.then(function() {
    return visualElement2.notifyAnimationComplete(definition);
  });
}
function animateVariant(visualElement2, variant, options) {
  var _a;
  if (options === void 0) {
    options = {};
  }
  var resolved = resolveVariant(visualElement2, variant, options.custom);
  var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement2.getDefaultTransition() || {} : _b;
  if (options.transitionOverride) {
    transition = options.transitionOverride;
  }
  var getAnimation2 = resolved ? function() {
    return animateTarget(visualElement2, resolved, options);
  } : function() {
    return Promise.resolve();
  };
  var getChildAnimations = ((_a = visualElement2.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
    if (forwardDelay === void 0) {
      forwardDelay = 0;
    }
    var _a2 = transition.delayChildren, delayChildren = _a2 === void 0 ? 0 : _a2, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
    return animateChildren(visualElement2, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : function() {
    return Promise.resolve();
  };
  var when = transition.when;
  if (when) {
    var _c = __read(when === "beforeChildren" ? [getAnimation2, getChildAnimations] : [getChildAnimations, getAnimation2], 2), first = _c[0], last = _c[1];
    return first().then(last);
  } else {
    return Promise.all([getAnimation2(), getChildAnimations(options.delay)]);
  }
}
function animateTarget(visualElement2, definition, _a) {
  var _b;
  var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
  var _e = visualElement2.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement2.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = __rest(_e, ["transition", "transitionEnd"]);
  if (transitionOverride)
    transition = transitionOverride;
  var animations2 = [];
  var animationTypeState = type && ((_b = visualElement2.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
  for (var key in target) {
    var value = visualElement2.getValue(key);
    var valueTarget = target[key];
    if (!value || valueTarget === void 0 || animationTypeState && shouldBlockAnimation(animationTypeState, key)) {
      continue;
    }
    var animation = startAnimation(key, value, valueTarget, __assign({ delay }, transition));
    animations2.push(animation);
  }
  return Promise.all(animations2).then(function() {
    transitionEnd && setTarget(visualElement2, transitionEnd);
  });
}
function animateChildren(visualElement2, variant, delayChildren, staggerChildren, staggerDirection, options) {
  if (delayChildren === void 0) {
    delayChildren = 0;
  }
  if (staggerChildren === void 0) {
    staggerChildren = 0;
  }
  if (staggerDirection === void 0) {
    staggerDirection = 1;
  }
  var animations2 = [];
  var maxStaggerDuration = (visualElement2.variantChildren.size - 1) * staggerChildren;
  var generateStaggerDuration = staggerDirection === 1 ? function(i2) {
    if (i2 === void 0) {
      i2 = 0;
    }
    return i2 * staggerChildren;
  } : function(i2) {
    if (i2 === void 0) {
      i2 = 0;
    }
    return maxStaggerDuration - i2 * staggerChildren;
  };
  Array.from(visualElement2.variantChildren).sort(sortByTreeOrder).forEach(function(child, i2) {
    animations2.push(animateVariant(child, variant, __assign(__assign({}, options), { delay: delayChildren + generateStaggerDuration(i2) })).then(function() {
      return child.notifyAnimationComplete(variant);
    }));
  });
  return Promise.all(animations2);
}
function sortByTreeOrder(a3, b3) {
  return a3.sortNodePosition(b3);
}
function shouldBlockAnimation(_a, key) {
  var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
  var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}

// ../../node_modules/framer-motion/dist/es/render/utils/animation-state.js
var variantPriorityOrder = [
  AnimationType.Animate,
  AnimationType.Hover,
  AnimationType.Tap,
  AnimationType.Drag,
  AnimationType.Focus,
  AnimationType.Exit
];
var reversePriorityOrder = __spreadArray([], __read(variantPriorityOrder)).reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement2) {
  return function(animations2) {
    return Promise.all(animations2.map(function(_a) {
      var animation = _a.animation, options = _a.options;
      return animateVisualElement(visualElement2, animation, options);
    }));
  };
}
function createAnimationState(visualElement2) {
  var animate2 = animateList(visualElement2);
  var state = createState();
  var allAnimatedKeys = {};
  var isInitialRender = true;
  var buildResolvedTypeValues = function(acc, definition) {
    var resolved = resolveVariant(visualElement2, definition);
    if (resolved) {
      resolved.transition;
      var transitionEnd = resolved.transitionEnd, target = __rest(resolved, ["transition", "transitionEnd"]);
      acc = __assign(__assign(__assign({}, acc), target), transitionEnd);
    }
    return acc;
  };
  function isAnimated(key) {
    return allAnimatedKeys[key] !== void 0;
  }
  function setAnimateFunction(makeAnimator) {
    animate2 = makeAnimator(visualElement2);
  }
  function animateChanges(options, changedActiveType) {
    var _a;
    var props = visualElement2.getProps();
    var context = visualElement2.getVariantContext(true) || {};
    var animations2 = [];
    var removedKeys = /* @__PURE__ */ new Set();
    var encounteredKeys = {};
    var removedVariantIndex = Infinity;
    var _loop_1 = function(i3) {
      var type = reversePriorityOrder[i3];
      var typeState = state[type];
      var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
      var propIsVariant = isVariantLabel(prop);
      var activeDelta = type === changedActiveType ? typeState.isActive : null;
      if (activeDelta === false)
        removedVariantIndex = i3;
      var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
      if (isInherited && isInitialRender && visualElement2.manuallyAnimateOnMount) {
        isInherited = false;
      }
      typeState.protectedKeys = __assign({}, encounteredKeys);
      if (!typeState.isActive && activeDelta === null || !prop && !typeState.prevProp || isAnimationControls(prop) || typeof prop === "boolean") {
        return "continue";
      }
      var shouldAnimateType = variantsHaveChanged(typeState.prevProp, prop) || type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || i3 > removedVariantIndex && propIsVariant;
      var definitionList = Array.isArray(prop) ? prop : [prop];
      var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
      if (activeDelta === false)
        resolvedValues = {};
      var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
      var allKeys = __assign(__assign({}, prevResolvedValues), resolvedValues);
      var markToAnimate = function(key2) {
        shouldAnimateType = true;
        removedKeys.delete(key2);
        typeState.needsAnimating[key2] = true;
      };
      for (var key in allKeys) {
        var next = resolvedValues[key];
        var prev = prevResolvedValues[key];
        if (encounteredKeys.hasOwnProperty(key))
          continue;
        if (next !== prev) {
          if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
            if (!shallowCompare(next, prev)) {
              markToAnimate(key);
            } else {
              typeState.protectedKeys[key] = true;
            }
          } else if (next !== void 0) {
            markToAnimate(key);
          } else {
            removedKeys.add(key);
          }
        } else if (next !== void 0 && removedKeys.has(key)) {
          markToAnimate(key);
        } else {
          typeState.protectedKeys[key] = true;
        }
      }
      typeState.prevProp = prop;
      typeState.prevResolvedValues = resolvedValues;
      if (typeState.isActive) {
        encounteredKeys = __assign(__assign({}, encounteredKeys), resolvedValues);
      }
      if (isInitialRender && visualElement2.blockInitialAnimation) {
        shouldAnimateType = false;
      }
      if (shouldAnimateType && !isInherited) {
        animations2.push.apply(animations2, __spreadArray([], __read(definitionList.map(function(animation) {
          return {
            animation,
            options: __assign({ type }, options)
          };
        }))));
      }
    };
    for (var i2 = 0; i2 < numAnimationTypes; i2++) {
      _loop_1(i2);
    }
    allAnimatedKeys = __assign({}, encounteredKeys);
    if (removedKeys.size) {
      var fallbackAnimation_1 = {};
      removedKeys.forEach(function(key) {
        var fallbackTarget = visualElement2.getBaseTarget(key);
        if (fallbackTarget !== void 0) {
          fallbackAnimation_1[key] = fallbackTarget;
        }
      });
      animations2.push({ animation: fallbackAnimation_1 });
    }
    var shouldAnimate = Boolean(animations2.length);
    if (isInitialRender && props.initial === false && !visualElement2.manuallyAnimateOnMount) {
      shouldAnimate = false;
    }
    isInitialRender = false;
    return shouldAnimate ? animate2(animations2) : Promise.resolve();
  }
  function setActive(type, isActive, options) {
    var _a;
    if (state[type].isActive === isActive)
      return Promise.resolve();
    (_a = visualElement2.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function(child) {
      var _a2;
      return (_a2 = child.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(type, isActive);
    });
    state[type].isActive = isActive;
    return animateChanges(options, type);
  }
  return {
    isAnimated,
    animateChanges,
    setActive,
    setAnimateFunction,
    getState: function() {
      return state;
    }
  };
}
function variantsHaveChanged(prev, next) {
  if (typeof next === "string") {
    return next !== prev;
  } else if (isVariantLabels(next)) {
    return !shallowCompare(next, prev);
  }
  return false;
}
function createTypeState(isActive) {
  if (isActive === void 0) {
    isActive = false;
  }
  return {
    isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  var _a;
  return _a = {}, _a[AnimationType.Animate] = createTypeState(true), _a[AnimationType.Hover] = createTypeState(), _a[AnimationType.Tap] = createTypeState(), _a[AnimationType.Drag] = createTypeState(), _a[AnimationType.Focus] = createTypeState(), _a[AnimationType.Exit] = createTypeState(), _a;
}

// ../../node_modules/framer-motion/dist/es/motion/features/animations.js
var animations = {
  animation: makeRenderlessComponent(function(_a) {
    var visualElement2 = _a.visualElement, animate2 = _a.animate;
    visualElement2.animationState || (visualElement2.animationState = createAnimationState(visualElement2));
    if (isAnimationControls(animate2)) {
      (0, import_react30.useEffect)(function() {
        return animate2.subscribe(visualElement2);
      }, [animate2]);
    }
  }),
  exit: makeRenderlessComponent(function(props) {
    var custom = props.custom, visualElement2 = props.visualElement;
    var _a = __read(usePresence(), 2), isPresent2 = _a[0], onExitComplete = _a[1];
    var presenceContext = (0, import_react30.useContext)(PresenceContext);
    (0, import_react30.useEffect)(function() {
      var _a2, _b;
      var animation = (_a2 = visualElement2.animationState) === null || _a2 === void 0 ? void 0 : _a2.setActive(AnimationType.Exit, !isPresent2, { custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom });
      !isPresent2 && (animation === null || animation === void 0 ? void 0 : animation.then(onExitComplete));
    }, [isPresent2]);
  })
};

// ../../node_modules/framer-motion/dist/es/gestures/drag/use-drag.js
var import_react31 = require("react");

// ../../node_modules/framer-motion/dist/es/gestures/PanSession.js
var PanSession = function() {
  function PanSession2(event, handlers, _a) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
    this.startEvent = null;
    this.lastMoveEvent = null;
    this.lastMoveEventInfo = null;
    this.handlers = {};
    this.updatePoint = function() {
      if (!(_this.lastMoveEvent && _this.lastMoveEventInfo))
        return;
      var info2 = getPanInfo(_this.lastMoveEventInfo, _this.history);
      var isPanStarted = _this.startEvent !== null;
      var isDistancePastThreshold = distance(info2.offset, { x: 0, y: 0 }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      var point2 = info2.point;
      var timestamp2 = getFrameData().timestamp;
      _this.history.push(__assign(__assign({}, point2), { timestamp: timestamp2 }));
      var _a2 = _this.handlers, onStart = _a2.onStart, onMove = _a2.onMove;
      if (!isPanStarted) {
        onStart && onStart(_this.lastMoveEvent, info2);
        _this.startEvent = _this.lastMoveEvent;
      }
      onMove && onMove(_this.lastMoveEvent, info2);
    };
    this.handlePointerMove = function(event2, info2) {
      _this.lastMoveEvent = event2;
      _this.lastMoveEventInfo = transformPoint(info2, _this.transformPagePoint);
      if (isMouseEvent(event2) && event2.buttons === 0) {
        _this.handlePointerUp(event2, info2);
        return;
      }
      es_default.update(_this.updatePoint, true);
    };
    this.handlePointerUp = function(event2, info2) {
      _this.end();
      var _a2 = _this.handlers, onEnd = _a2.onEnd, onSessionEnd = _a2.onSessionEnd;
      var panInfo = getPanInfo(transformPoint(info2, _this.transformPagePoint), _this.history);
      if (_this.startEvent && onEnd) {
        onEnd(event2, panInfo);
      }
      onSessionEnd && onSessionEnd(event2, panInfo);
    };
    if (isTouchEvent(event) && event.touches.length > 1)
      return;
    this.handlers = handlers;
    this.transformPagePoint = transformPagePoint;
    var info = extractEventInfo(event);
    var initialInfo = transformPoint(info, this.transformPagePoint);
    var point = initialInfo.point;
    var timestamp = getFrameData().timestamp;
    this.history = [__assign(__assign({}, point), { timestamp })];
    var onSessionStart = handlers.onSessionStart;
    onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
    this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
  }
  PanSession2.prototype.updateHandlers = function(handlers) {
    this.handlers = handlers;
  };
  PanSession2.prototype.end = function() {
    this.removeListeners && this.removeListeners();
    cancelSync.update(this.updatePoint);
  };
  return PanSession2;
}();
function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a3, b3) {
  return { x: a3.x - b3.x, y: a3.y - b3.y };
}
function getPanInfo(_a, history) {
  var point = _a.point;
  return {
    point,
    delta: subtractPoint(point, lastDevicePoint(history)),
    offset: subtractPoint(point, startDevicePoint(history)),
    velocity: getVelocity2(history, 0.1)
  };
}
function startDevicePoint(history) {
  return history[0];
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
function getVelocity2(history, timeDelta) {
  if (history.length < 2) {
    return { x: 0, y: 0 };
  }
  var i2 = history.length - 1;
  var timestampedPoint = null;
  var lastPoint = lastDevicePoint(history);
  while (i2 >= 0) {
    timestampedPoint = history[i2];
    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
      break;
    }
    i2--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1e3;
  if (time === 0) {
    return { x: 0, y: 0 };
  }
  var currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time,
    y: (lastPoint.y - timestampedPoint.y) / time
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}

// ../../node_modules/framer-motion/dist/es/utils/noop.js
function noop(any) {
  return any;
}

// ../../node_modules/framer-motion/dist/es/utils/geometry/index.js
function convertBoundingBoxToAxisBox(_a) {
  var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
  return {
    x: { min: left, max: right },
    y: { min: top, max: bottom }
  };
}
function convertAxisBoxToBoundingBox(_a) {
  var x2 = _a.x, y2 = _a.y;
  return {
    top: y2.min,
    bottom: y2.max,
    left: x2.min,
    right: x2.max
  };
}
function transformBoundingBox(_a, transformPoint2) {
  var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
  if (transformPoint2 === void 0) {
    transformPoint2 = noop;
  }
  var topLeft = transformPoint2({ x: left, y: top });
  var bottomRight = transformPoint2({ x: right, y: bottom });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}
function axisBox() {
  return { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } };
}
function copyAxisBox(box) {
  return {
    x: __assign({}, box.x),
    y: __assign({}, box.y)
  };
}
var zeroDelta = {
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
};
function delta() {
  return {
    x: __assign({}, zeroDelta),
    y: __assign({}, zeroDelta)
  };
}

// ../../node_modules/framer-motion/dist/es/utils/each-axis.js
function eachAxis(handler) {
  return [handler("x"), handler("y")];
}

// ../../node_modules/framer-motion/dist/es/gestures/drag/utils/constraints.js
function applyConstraints(point, _a, elastic) {
  var min = _a.min, max = _a.max;
  if (min !== void 0 && point < min) {
    point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
  } else if (max !== void 0 && point > max) {
    point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
  }
  return point;
}
function calcConstrainedMinPoint(point, length, progress2, constraints, elastic) {
  var min = point - length * progress2;
  return constraints ? applyConstraints(min, constraints, elastic) : min;
}
function calcRelativeAxisConstraints(axis, min, max) {
  return {
    min: min !== void 0 ? axis.min + min : void 0,
    max: max !== void 0 ? axis.max + max - (axis.max - axis.min) : void 0
  };
}
function calcRelativeConstraints(layoutBox, _a) {
  var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
  return {
    x: calcRelativeAxisConstraints(layoutBox.x, left, right),
    y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
  };
}
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
  var _a;
  var min = constraintsAxis.min - layoutAxis.min;
  var max = constraintsAxis.max - layoutAxis.max;
  if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) {
    _a = __read([max, min], 2), min = _a[0], max = _a[1];
  }
  return {
    min: layoutAxis.min + min,
    max: layoutAxis.min + max
  };
}
function calcViewportConstraints(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
  };
}
function calcPositionFromProgress(axis, constraints, progress2) {
  var axisLength = axis.max - axis.min;
  var min = mix(constraints.min, constraints.max - axisLength, progress2);
  return { min, max: min + axisLength };
}
function rebaseAxisConstraints(layout, constraints) {
  var relativeConstraints = {};
  if (constraints.min !== void 0) {
    relativeConstraints.min = constraints.min - layout.min;
  }
  if (constraints.max !== void 0) {
    relativeConstraints.max = constraints.max - layout.min;
  }
  return relativeConstraints;
}
var defaultElastic = 0.35;
function resolveDragElastic(dragElastic) {
  if (dragElastic === false) {
    dragElastic = 0;
  } else if (dragElastic === true) {
    dragElastic = defaultElastic;
  }
  return {
    x: resolveAxisElastic(dragElastic, "left", "right"),
    y: resolveAxisElastic(dragElastic, "top", "bottom")
  };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic(dragElastic, minLabel),
    max: resolvePointElastic(dragElastic, maxLabel)
  };
}
function resolvePointElastic(dragElastic, label) {
  var _a;
  return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}

// ../../node_modules/framer-motion/dist/es/render/dom/projection/measure.js
function getBoundingBox(element, transformPagePoint) {
  var box = element.getBoundingClientRect();
  return convertBoundingBoxToAxisBox(transformBoundingBox(box, transformPagePoint));
}

// ../../node_modules/framer-motion/dist/es/utils/geometry/delta-calc.js
var clampProgress = function(v2) {
  return clamp2(0, 1, v2);
};
function isNear(value, target, maxDistance) {
  if (target === void 0) {
    target = 0;
  }
  if (maxDistance === void 0) {
    maxDistance = 0.01;
  }
  return distance(value, target) < maxDistance;
}
function calcLength(axis) {
  return axis.max - axis.min;
}
function calcOrigin2(source, target) {
  var origin = 0.5;
  var sourceLength = calcLength(source);
  var targetLength = calcLength(target);
  if (targetLength > sourceLength) {
    origin = progress(target.min, target.max - sourceLength, source.min);
  } else if (sourceLength > targetLength) {
    origin = progress(source.min, source.max - targetLength, target.min);
  }
  return clampProgress(origin);
}
function updateAxisDelta(delta2, source, target, origin) {
  if (origin === void 0) {
    origin = 0.5;
  }
  delta2.origin = origin;
  delta2.originPoint = mix(source.min, source.max, delta2.origin);
  delta2.scale = calcLength(target) / calcLength(source);
  if (isNear(delta2.scale, 1, 1e-4))
    delta2.scale = 1;
  delta2.translate = mix(target.min, target.max, delta2.origin) - delta2.originPoint;
  if (isNear(delta2.translate))
    delta2.translate = 0;
}
function updateBoxDelta(delta2, source, target, origin) {
  updateAxisDelta(delta2.x, source.x, target.x, defaultOrigin(origin.originX));
  updateAxisDelta(delta2.y, source.y, target.y, defaultOrigin(origin.originY));
}
function defaultOrigin(origin) {
  return typeof origin === "number" ? origin : 0.5;
}
function calcRelativeAxis(target, relative, parent) {
  target.min = parent.min + relative.min;
  target.max = target.min + calcLength(relative);
}
function calcRelativeBox(projection, parentProjection) {
  calcRelativeAxis(projection.target.x, projection.relativeTarget.x, parentProjection.target.x);
  calcRelativeAxis(projection.target.y, projection.relativeTarget.y, parentProjection.target.y);
}

// ../../node_modules/framer-motion/dist/es/render/utils/compare-by-depth.js
var compareByDepth = function(a3, b3) {
  return a3.depth - b3.depth;
};

// ../../node_modules/framer-motion/dist/es/render/dom/projection/utils.js
function isProjecting(visualElement2) {
  var isEnabled = visualElement2.projection.isEnabled;
  return isEnabled || visualElement2.shouldResetTransform();
}
function collectProjectingAncestors(visualElement2, ancestors) {
  if (ancestors === void 0) {
    ancestors = [];
  }
  var parent = visualElement2.parent;
  if (parent)
    collectProjectingAncestors(parent, ancestors);
  if (isProjecting(visualElement2))
    ancestors.push(visualElement2);
  return ancestors;
}
function collectProjectingChildren(visualElement2) {
  var children = [];
  var addChild = function(child) {
    if (isProjecting(child))
      children.push(child);
    child.children.forEach(addChild);
  };
  visualElement2.children.forEach(addChild);
  return children.sort(compareByDepth);
}
function updateLayoutMeasurement(visualElement2) {
  if (visualElement2.shouldResetTransform())
    return;
  var layoutState = visualElement2.getLayoutState();
  visualElement2.notifyBeforeLayoutMeasure(layoutState.layout);
  layoutState.isHydrated = true;
  layoutState.layout = visualElement2.measureViewportBox();
  layoutState.layoutCorrected = copyAxisBox(layoutState.layout);
  visualElement2.notifyLayoutMeasure(layoutState.layout, visualElement2.prevViewportBox || layoutState.layout);
  es_default.update(function() {
    return visualElement2.rebaseProjectionTarget();
  });
}
function snapshotViewportBox(visualElement2) {
  if (visualElement2.shouldResetTransform())
    return;
  visualElement2.prevViewportBox = visualElement2.measureViewportBox(false);
  visualElement2.rebaseProjectionTarget(false, visualElement2.prevViewportBox);
}

// ../../node_modules/framer-motion/dist/es/motion/features/layout/utils.js
function tweenAxis(target, prev, next, p2) {
  target.min = mix(prev.min, next.min, p2);
  target.max = mix(prev.max, next.max, p2);
}
function calcRelativeOffsetAxis(parent, child) {
  return {
    min: child.min - parent.min,
    max: child.max - parent.min
  };
}
function calcRelativeOffset(parent, child) {
  return {
    x: calcRelativeOffsetAxis(parent.x, child.x),
    y: calcRelativeOffsetAxis(parent.y, child.y)
  };
}
function checkIfParentHasChanged(prev, next) {
  var prevId = prev.getLayoutId();
  var nextId = next.getLayoutId();
  return prevId !== nextId || nextId === void 0 && prev !== next;
}

// ../../node_modules/framer-motion/dist/es/render/utils/is-draggable.js
function isDraggable(visualElement2) {
  var _a = visualElement2.getProps(), drag2 = _a.drag, _dragX = _a._dragX;
  return drag2 && !_dragX;
}

// ../../node_modules/framer-motion/dist/es/utils/geometry/delta-apply.js
function resetAxis(axis, originAxis) {
  axis.min = originAxis.min;
  axis.max = originAxis.max;
}
function resetBox(box, originBox) {
  resetAxis(box.x, originBox.x);
  resetAxis(box.y, originBox.y);
}
function scalePoint(point, scale2, originPoint) {
  var distanceFromOrigin = point - originPoint;
  var scaled = scale2 * distanceFromOrigin;
  return originPoint + scaled;
}
function applyPointDelta(point, translate, scale2, originPoint, boxScale) {
  if (boxScale !== void 0) {
    point = scalePoint(point, boxScale, originPoint);
  }
  return scalePoint(point, scale2, originPoint) + translate;
}
function applyAxisDelta(axis, translate, scale2, originPoint, boxScale) {
  if (translate === void 0) {
    translate = 0;
  }
  if (scale2 === void 0) {
    scale2 = 1;
  }
  axis.min = applyPointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = applyPointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function applyBoxDelta(box, _a) {
  var x2 = _a.x, y2 = _a.y;
  applyAxisDelta(box.x, x2.translate, x2.scale, x2.originPoint);
  applyAxisDelta(box.y, y2.translate, y2.scale, y2.originPoint);
}
function applyAxisTransforms(final, axis, transforms, _a) {
  var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
  final.min = axis.min;
  final.max = axis.max;
  var axisOrigin = transforms[originKey] !== void 0 ? transforms[originKey] : 0.5;
  var originPoint = mix(axis.min, axis.max, axisOrigin);
  applyAxisDelta(final, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
function applyBoxTransforms(finalBox, box, transforms) {
  applyAxisTransforms(finalBox.x, box.x, transforms, xKeys);
  applyAxisTransforms(finalBox.y, box.y, transforms, yKeys);
}
function removePointDelta(point, translate, scale2, originPoint, boxScale) {
  point -= translate;
  point = scalePoint(point, 1 / scale2, originPoint);
  if (boxScale !== void 0) {
    point = scalePoint(point, 1 / boxScale, originPoint);
  }
  return point;
}
function removeAxisDelta(axis, translate, scale2, origin, boxScale) {
  if (translate === void 0) {
    translate = 0;
  }
  if (scale2 === void 0) {
    scale2 = 1;
  }
  if (origin === void 0) {
    origin = 0.5;
  }
  var originPoint = mix(axis.min, axis.max, origin) - translate;
  axis.min = removePointDelta(axis.min, translate, scale2, originPoint, boxScale);
  axis.max = removePointDelta(axis.max, translate, scale2, originPoint, boxScale);
}
function removeAxisTransforms(axis, transforms, _a) {
  var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
  removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale);
}
function removeBoxTransforms(box, transforms) {
  removeAxisTransforms(box.x, transforms, xKeys);
  removeAxisTransforms(box.y, transforms, yKeys);
}
function applyTreeDeltas(box, treeScale, treePath) {
  var treeLength = treePath.length;
  if (!treeLength)
    return;
  treeScale.x = treeScale.y = 1;
  var node;
  var delta2;
  for (var i2 = 0; i2 < treeLength; i2++) {
    node = treePath[i2];
    delta2 = node.getLayoutState().delta;
    treeScale.x *= delta2.x.scale;
    treeScale.y *= delta2.y.scale;
    applyBoxDelta(box, delta2);
    if (isDraggable(node)) {
      applyBoxTransforms(box, box, node.getLatestValues());
    }
  }
}

// ../../node_modules/framer-motion/dist/es/render/dom/projection/convert-to-relative.js
function convertToRelativeProjection(visualElement2, isLayoutDrag) {
  if (isLayoutDrag === void 0) {
    isLayoutDrag = true;
  }
  var projectionParent = visualElement2.getProjectionParent();
  if (!projectionParent)
    return false;
  var offset;
  if (isLayoutDrag) {
    offset = calcRelativeOffset(projectionParent.projection.target, visualElement2.projection.target);
    removeBoxTransforms(offset, projectionParent.getLatestValues());
  } else {
    offset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement2.getLayoutState().layout);
  }
  eachAxis(function(axis) {
    return visualElement2.setProjectionTargetAxis(axis, offset[axis].min, offset[axis].max, true);
  });
  return true;
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/batch-layout.js
var unresolvedJobs = /* @__PURE__ */ new Set();
function pushJob(stack, job, pointer) {
  if (!stack[pointer])
    stack[pointer] = [];
  stack[pointer].push(job);
}
function batchLayout(callback) {
  unresolvedJobs.add(callback);
  return function() {
    return unresolvedJobs.delete(callback);
  };
}
function flushLayout() {
  if (!unresolvedJobs.size)
    return;
  var pointer = 0;
  var reads = [[]];
  var writes = [];
  var setRead = function(job) {
    return pushJob(reads, job, pointer);
  };
  var setWrite = function(job) {
    pushJob(writes, job, pointer);
    pointer++;
  };
  unresolvedJobs.forEach(function(callback) {
    callback(setRead, setWrite);
    pointer = 0;
  });
  unresolvedJobs.clear();
  var numStacks = writes.length;
  for (var i2 = 0; i2 <= numStacks; i2++) {
    reads[i2] && reads[i2].forEach(executeJob);
    writes[i2] && writes[i2].forEach(executeJob);
  }
}
var executeJob = function(job) {
  return job();
};

// ../../node_modules/framer-motion/dist/es/gestures/drag/VisualElementDragControls.js
var elementDragControls = /* @__PURE__ */ new WeakMap();
var lastPointerEvent;
var VisualElementDragControls = function() {
  function VisualElementDragControls2(_a) {
    var visualElement2 = _a.visualElement;
    this.isDragging = false;
    this.currentDirection = null;
    this.constraints = false;
    this.elastic = axisBox();
    this.props = {};
    this.hasMutatedConstraints = false;
    this.cursorProgress = {
      x: 0.5,
      y: 0.5
    };
    this.originPoint = {};
    this.openGlobalLock = null;
    this.panSession = null;
    this.visualElement = visualElement2;
    this.visualElement.enableLayoutProjection();
    elementDragControls.set(visualElement2, this);
  }
  VisualElementDragControls2.prototype.start = function(originEvent, _a) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c, cursorProgress = _b.cursorProgress;
    var onSessionStart = function(event) {
      var _a2;
      _this.stopMotion();
      var initialPoint = getViewportPointFromEvent(event).point;
      (_a2 = _this.cancelLayout) === null || _a2 === void 0 ? void 0 : _a2.call(_this);
      _this.cancelLayout = batchLayout(function(read, write) {
        var ancestors = collectProjectingAncestors(_this.visualElement);
        var children = collectProjectingChildren(_this.visualElement);
        var tree = __spreadArray(__spreadArray([], __read(ancestors)), __read(children));
        var hasManuallySetCursorOrigin = false;
        _this.isLayoutDrag() && _this.visualElement.lockProjectionTarget();
        write(function() {
          tree.forEach(function(element) {
            return element.resetTransform();
          });
        });
        read(function() {
          updateLayoutMeasurement(_this.visualElement);
          children.forEach(updateLayoutMeasurement);
        });
        write(function() {
          tree.forEach(function(element) {
            return element.restoreTransform();
          });
          if (snapToCursor) {
            hasManuallySetCursorOrigin = _this.snapToCursor(initialPoint);
          }
        });
        read(function() {
          var isRelativeDrag = Boolean(_this.getAxisMotionValue("x") && !_this.isExternalDrag());
          if (!isRelativeDrag) {
            _this.visualElement.rebaseProjectionTarget(true, _this.visualElement.measureViewportBox(false));
          }
          _this.visualElement.scheduleUpdateLayoutProjection();
          var projection = _this.visualElement.projection;
          eachAxis(function(axis) {
            if (!hasManuallySetCursorOrigin) {
              var _a3 = projection.target[axis], min = _a3.min, max = _a3.max;
              _this.cursorProgress[axis] = cursorProgress ? cursorProgress[axis] : progress(min, max, initialPoint[axis]);
            }
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
              _this.originPoint[axis] = axisValue.get();
            }
          });
        });
        write(function() {
          flushSync.update();
          flushSync.preRender();
          flushSync.render();
          flushSync.postRender();
        });
        read(function() {
          return _this.resolveDragConstraints();
        });
      });
    };
    var onStart = function(event, info) {
      var _a2, _b2, _c2;
      var _d = _this.props, drag2 = _d.drag, dragPropagation = _d.dragPropagation;
      if (drag2 && !dragPropagation) {
        if (_this.openGlobalLock)
          _this.openGlobalLock();
        _this.openGlobalLock = getGlobalLock(drag2);
        if (!_this.openGlobalLock)
          return;
      }
      flushLayout();
      _this.isDragging = true;
      _this.currentDirection = null;
      (_b2 = (_a2 = _this.props).onDragStart) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, event, info);
      (_c2 = _this.visualElement.animationState) === null || _c2 === void 0 ? void 0 : _c2.setActive(AnimationType.Drag, true);
    };
    var onMove = function(event, info) {
      var _a2, _b2, _c2, _d;
      var _e = _this.props, dragPropagation = _e.dragPropagation, dragDirectionLock = _e.dragDirectionLock;
      if (!dragPropagation && !_this.openGlobalLock)
        return;
      var offset = info.offset;
      if (dragDirectionLock && _this.currentDirection === null) {
        _this.currentDirection = getCurrentDirection(offset);
        if (_this.currentDirection !== null) {
          (_b2 = (_a2 = _this.props).onDirectionLock) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, _this.currentDirection);
        }
        return;
      }
      _this.updateAxis("x", info.point, offset);
      _this.updateAxis("y", info.point, offset);
      (_d = (_c2 = _this.props).onDrag) === null || _d === void 0 ? void 0 : _d.call(_c2, event, info);
      lastPointerEvent = event;
    };
    var onSessionEnd = function(event, info) {
      return _this.stop(event, info);
    };
    var transformPagePoint = this.props.transformPagePoint;
    this.panSession = new PanSession(originEvent, {
      onSessionStart,
      onStart,
      onMove,
      onSessionEnd
    }, { transformPagePoint });
  };
  VisualElementDragControls2.prototype.resolveDragConstraints = function() {
    var _this = this;
    var _a = this.props, dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
    var layout = this.visualElement.getLayoutState().layoutCorrected;
    if (dragConstraints) {
      this.constraints = isRefObject(dragConstraints) ? this.resolveRefConstraints(layout, dragConstraints) : calcRelativeConstraints(layout, dragConstraints);
    } else {
      this.constraints = false;
    }
    this.elastic = resolveDragElastic(dragElastic);
    if (this.constraints && !this.hasMutatedConstraints) {
      eachAxis(function(axis) {
        if (_this.getAxisMotionValue(axis)) {
          _this.constraints[axis] = rebaseAxisConstraints(layout[axis], _this.constraints[axis]);
        }
      });
    }
  };
  VisualElementDragControls2.prototype.resolveRefConstraints = function(layoutBox, constraints) {
    var _a = this.props, onMeasureDragConstraints = _a.onMeasureDragConstraints, transformPagePoint = _a.transformPagePoint;
    var constraintsElement = constraints.current;
    invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    this.constraintsBox = getBoundingBox(constraintsElement, transformPagePoint);
    var measuredConstraints = calcViewportConstraints(layoutBox, this.constraintsBox);
    if (onMeasureDragConstraints) {
      var userConstraints = onMeasureDragConstraints(convertAxisBoxToBoundingBox(measuredConstraints));
      this.hasMutatedConstraints = !!userConstraints;
      if (userConstraints) {
        measuredConstraints = convertBoundingBoxToAxisBox(userConstraints);
      }
    }
    return measuredConstraints;
  };
  VisualElementDragControls2.prototype.cancelDrag = function() {
    var _a, _b;
    this.visualElement.unlockProjectionTarget();
    (_a = this.cancelLayout) === null || _a === void 0 ? void 0 : _a.call(this);
    this.isDragging = false;
    this.panSession && this.panSession.end();
    this.panSession = null;
    if (!this.props.dragPropagation && this.openGlobalLock) {
      this.openGlobalLock();
      this.openGlobalLock = null;
    }
    (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
  };
  VisualElementDragControls2.prototype.stop = function(event, info) {
    var _a, _b, _c;
    (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
    this.panSession = null;
    var isDragging = this.isDragging;
    this.cancelDrag();
    if (!isDragging)
      return;
    var velocity = info.velocity;
    this.animateDragEnd(velocity);
    (_c = (_b = this.props).onDragEnd) === null || _c === void 0 ? void 0 : _c.call(_b, event, info);
  };
  VisualElementDragControls2.prototype.snapToCursor = function(point) {
    var _this = this;
    return eachAxis(function(axis) {
      var drag2 = _this.props.drag;
      if (!shouldDrag(axis, drag2, _this.currentDirection))
        return;
      var axisValue = _this.getAxisMotionValue(axis);
      if (axisValue) {
        var box = _this.visualElement.getLayoutState().layout;
        var length_1 = box[axis].max - box[axis].min;
        var center = box[axis].min + length_1 / 2;
        var offset = point[axis] - center;
        _this.originPoint[axis] = point[axis];
        axisValue.set(offset);
      } else {
        _this.cursorProgress[axis] = 0.5;
        return true;
      }
    }).includes(true);
  };
  VisualElementDragControls2.prototype.updateAxis = function(axis, point, offset) {
    var drag2 = this.props.drag;
    if (!shouldDrag(axis, drag2, this.currentDirection))
      return;
    return this.getAxisMotionValue(axis) ? this.updateAxisMotionValue(axis, offset) : this.updateVisualElementAxis(axis, point);
  };
  VisualElementDragControls2.prototype.updateAxisMotionValue = function(axis, offset) {
    var axisValue = this.getAxisMotionValue(axis);
    if (!offset || !axisValue)
      return;
    var nextValue = this.originPoint[axis] + offset[axis];
    var update = this.constraints ? applyConstraints(nextValue, this.constraints[axis], this.elastic[axis]) : nextValue;
    axisValue.set(update);
  };
  VisualElementDragControls2.prototype.updateVisualElementAxis = function(axis, point) {
    var _a;
    var axisLayout = this.visualElement.getLayoutState().layout[axis];
    var axisLength = axisLayout.max - axisLayout.min;
    var axisProgress = this.cursorProgress[axis];
    var min = calcConstrainedMinPoint(point[axis], axisLength, axisProgress, (_a = this.constraints) === null || _a === void 0 ? void 0 : _a[axis], this.elastic[axis]);
    this.visualElement.setProjectionTargetAxis(axis, min, min + axisLength);
  };
  VisualElementDragControls2.prototype.setProps = function(_a) {
    var _b = _a.drag, drag2 = _b === void 0 ? false : _b, _c = _a.dragDirectionLock, dragDirectionLock = _c === void 0 ? false : _c, _d = _a.dragPropagation, dragPropagation = _d === void 0 ? false : _d, _e = _a.dragConstraints, dragConstraints = _e === void 0 ? false : _e, _f = _a.dragElastic, dragElastic = _f === void 0 ? defaultElastic : _f, _g = _a.dragMomentum, dragMomentum = _g === void 0 ? true : _g, remainingProps = __rest(_a, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
    this.props = __assign({
      drag: drag2,
      dragDirectionLock,
      dragPropagation,
      dragConstraints,
      dragElastic,
      dragMomentum
    }, remainingProps);
  };
  VisualElementDragControls2.prototype.getAxisMotionValue = function(axis) {
    var _a = this.props, layout = _a.layout, layoutId = _a.layoutId;
    var dragKey = "_drag" + axis.toUpperCase();
    if (this.props[dragKey]) {
      return this.props[dragKey];
    } else if (!layout && layoutId === void 0) {
      return this.visualElement.getValue(axis, 0);
    }
  };
  VisualElementDragControls2.prototype.isLayoutDrag = function() {
    return !this.getAxisMotionValue("x");
  };
  VisualElementDragControls2.prototype.isExternalDrag = function() {
    var _a = this.props, _dragX = _a._dragX, _dragY = _a._dragY;
    return _dragX || _dragY;
  };
  VisualElementDragControls2.prototype.animateDragEnd = function(velocity) {
    var _this = this;
    var _a = this.props, drag2 = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition;
    var isRelative = convertToRelativeProjection(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag());
    var constraints = this.constraints || {};
    if (isRelative && Object.keys(constraints).length && this.isLayoutDrag()) {
      var projectionParent = this.visualElement.getProjectionParent();
      if (projectionParent) {
        var relativeConstraints_1 = calcRelativeOffset(projectionParent.projection.targetFinal, constraints);
        eachAxis(function(axis) {
          var _a2 = relativeConstraints_1[axis], min = _a2.min, max = _a2.max;
          constraints[axis] = {
            min: isNaN(min) ? void 0 : min,
            max: isNaN(max) ? void 0 : max
          };
        });
      }
    }
    var momentumAnimations = eachAxis(function(axis) {
      var _a2;
      if (!shouldDrag(axis, drag2, _this.currentDirection)) {
        return;
      }
      var transition = (_a2 = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a2 !== void 0 ? _a2 : {};
      var bounceStiffness = dragElastic ? 200 : 1e6;
      var bounceDamping = dragElastic ? 40 : 1e7;
      var inertia2 = __assign(__assign({
        type: "inertia",
        velocity: dragMomentum ? velocity[axis] : 0,
        bounceStiffness,
        bounceDamping,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10
      }, dragTransition), transition);
      return _this.getAxisMotionValue(axis) ? _this.startAxisValueAnimation(axis, inertia2) : _this.visualElement.startLayoutAnimation(axis, inertia2, isRelative);
    });
    return Promise.all(momentumAnimations).then(function() {
      var _a2, _b;
      (_b = (_a2 = _this.props).onDragTransitionEnd) === null || _b === void 0 ? void 0 : _b.call(_a2);
    });
  };
  VisualElementDragControls2.prototype.stopMotion = function() {
    var _this = this;
    eachAxis(function(axis) {
      var axisValue = _this.getAxisMotionValue(axis);
      axisValue ? axisValue.stop() : _this.visualElement.stopLayoutAnimation();
    });
  };
  VisualElementDragControls2.prototype.startAxisValueAnimation = function(axis, transition) {
    var axisValue = this.getAxisMotionValue(axis);
    if (!axisValue)
      return;
    var currentValue = axisValue.get();
    axisValue.set(currentValue);
    axisValue.set(currentValue);
    return startAnimation(axis, axisValue, 0, transition);
  };
  VisualElementDragControls2.prototype.scalePoint = function() {
    var _this = this;
    var _a = this.props, drag2 = _a.drag, dragConstraints = _a.dragConstraints;
    if (!isRefObject(dragConstraints) || !this.constraintsBox)
      return;
    this.stopMotion();
    var boxProgress = { x: 0, y: 0 };
    eachAxis(function(axis) {
      boxProgress[axis] = calcOrigin2(_this.visualElement.projection.target[axis], _this.constraintsBox[axis]);
    });
    this.updateConstraints(function() {
      eachAxis(function(axis) {
        if (!shouldDrag(axis, drag2, null))
          return;
        var _a2 = calcPositionFromProgress(_this.visualElement.projection.target[axis], _this.constraintsBox[axis], boxProgress[axis]), min = _a2.min, max = _a2.max;
        _this.visualElement.setProjectionTargetAxis(axis, min, max);
      });
    });
    setTimeout(flushLayout, 1);
  };
  VisualElementDragControls2.prototype.updateConstraints = function(onReady) {
    var _this = this;
    this.cancelLayout = batchLayout(function(read, write) {
      var ancestors = collectProjectingAncestors(_this.visualElement);
      write(function() {
        return ancestors.forEach(function(element) {
          return element.resetTransform();
        });
      });
      read(function() {
        return updateLayoutMeasurement(_this.visualElement);
      });
      write(function() {
        return ancestors.forEach(function(element) {
          return element.restoreTransform();
        });
      });
      read(function() {
        _this.resolveDragConstraints();
      });
      if (onReady)
        write(onReady);
    });
  };
  VisualElementDragControls2.prototype.mount = function(visualElement2) {
    var _this = this;
    var element = visualElement2.getInstance();
    var stopPointerListener = addPointerEvent(element, "pointerdown", function(event) {
      var _a = _this.props, drag2 = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
      drag2 && dragListener && _this.start(event);
    });
    var stopResizeListener = addDomEvent(window, "resize", function() {
      _this.scalePoint();
    });
    var stopLayoutUpdateListener = visualElement2.onLayoutUpdate(function() {
      if (_this.isDragging) {
        _this.resolveDragConstraints();
      }
    });
    var prevDragCursor = visualElement2.prevDragCursor;
    if (prevDragCursor) {
      this.start(lastPointerEvent, { cursorProgress: prevDragCursor });
    }
    return function() {
      stopPointerListener === null || stopPointerListener === void 0 ? void 0 : stopPointerListener();
      stopResizeListener === null || stopResizeListener === void 0 ? void 0 : stopResizeListener();
      stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 ? void 0 : stopLayoutUpdateListener();
      _this.cancelDrag();
    };
  };
  return VisualElementDragControls2;
}();
function shouldDrag(direction, drag2, currentDirection) {
  return (drag2 === true || drag2 === direction) && (currentDirection === null || currentDirection === direction);
}
function getCurrentDirection(offset, lockThreshold) {
  if (lockThreshold === void 0) {
    lockThreshold = 10;
  }
  var direction = null;
  if (Math.abs(offset.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}

// ../../node_modules/framer-motion/dist/es/gestures/drag/use-drag.js
function useDrag(props) {
  var groupDragControls = props.dragControls, visualElement2 = props.visualElement;
  var transformPagePoint = (0, import_react31.useContext)(MotionConfigContext).transformPagePoint;
  var dragControls = useConstant(function() {
    return new VisualElementDragControls({
      visualElement: visualElement2
    });
  });
  dragControls.setProps(__assign(__assign({}, props), { transformPagePoint }));
  (0, import_react31.useEffect)(function() {
    return groupDragControls && groupDragControls.subscribe(dragControls);
  }, [dragControls]);
  (0, import_react31.useEffect)(function() {
    return dragControls.mount(visualElement2);
  }, []);
}

// ../../node_modules/framer-motion/dist/es/gestures/use-pan-gesture.js
var import_react32 = require("react");
function usePanGesture(_a) {
  var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement2 = _a.visualElement;
  var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
  var panSession = (0, import_react32.useRef)(null);
  var transformPagePoint = (0, import_react32.useContext)(MotionConfigContext).transformPagePoint;
  var handlers = {
    onSessionStart: onPanSessionStart,
    onStart: onPanStart,
    onMove: onPan,
    onEnd: function(event, info) {
      panSession.current = null;
      onPanEnd && onPanEnd(event, info);
    }
  };
  (0, import_react32.useEffect)(function() {
    if (panSession.current !== null) {
      panSession.current.updateHandlers(handlers);
    }
  });
  function onPointerDown(event) {
    panSession.current = new PanSession(event, handlers, {
      transformPagePoint
    });
  }
  usePointerEvent(visualElement2, "pointerdown", hasPanEvents && onPointerDown);
  useUnmountEffect(function() {
    return panSession.current && panSession.current.end();
  });
}

// ../../node_modules/framer-motion/dist/es/motion/features/drag.js
var drag = {
  pan: makeRenderlessComponent(usePanGesture),
  drag: makeRenderlessComponent(useDrag)
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout/Animate.js
var React10 = __toESM(require("react"));

// ../../node_modules/framer-motion/dist/es/components/AnimateSharedLayout/types.js
var Presence;
(function(Presence2) {
  Presence2[Presence2["Entering"] = 0] = "Entering";
  Presence2[Presence2["Present"] = 1] = "Present";
  Presence2[Presence2["Exiting"] = 2] = "Exiting";
})(Presence || (Presence = {}));
var VisibilityAction;
(function(VisibilityAction2) {
  VisibilityAction2[VisibilityAction2["Hide"] = 0] = "Hide";
  VisibilityAction2[VisibilityAction2["Show"] = 1] = "Show";
})(VisibilityAction || (VisibilityAction = {}));

// ../../node_modules/framer-motion/dist/es/render/dom/utils/css-variables-conversion.js
function isCSSVariable2(value) {
  return typeof value === "string" && value.startsWith("var(--");
}
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
  var match = cssVariableRegex.exec(current);
  if (!match)
    return [,];
  var _a = __read(match, 3), token = _a[1], fallback = _a[2];
  return [token, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element, depth) {
  if (depth === void 0) {
    depth = 1;
  }
  invariant(depth <= maxDepth, 'Max CSS variable fallback depth detected in property "' + current + '". This may indicate a circular fallback dependency.');
  var _a = __read(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
  if (!token)
    return;
  var resolved = window.getComputedStyle(element).getPropertyValue(token);
  if (resolved) {
    return resolved.trim();
  } else if (isCSSVariable2(fallback)) {
    return getVariableValue(fallback, element, depth + 1);
  } else {
    return fallback;
  }
}
function resolveCSSVariables(visualElement2, _a, transitionEnd) {
  var _b;
  var target = __rest(_a, []);
  var element = visualElement2.getInstance();
  if (!(element instanceof HTMLElement))
    return { target, transitionEnd };
  if (transitionEnd) {
    transitionEnd = __assign({}, transitionEnd);
  }
  visualElement2.forEachValue(function(value) {
    var current2 = value.get();
    if (!isCSSVariable2(current2))
      return;
    var resolved2 = getVariableValue(current2, element);
    if (resolved2)
      value.set(resolved2);
  });
  for (var key in target) {
    var current = target[key];
    if (!isCSSVariable2(current))
      continue;
    var resolved = getVariableValue(current, element);
    if (!resolved)
      continue;
    target[key] = resolved;
    if (transitionEnd)
      (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
  }
  return { target, transitionEnd };
}

// ../../node_modules/framer-motion/dist/es/render/dom/projection/default-scale-correctors.js
function pixelsToPercent(pixels, axis) {
  return pixels / (axis.max - axis.min) * 100;
}
function correctBorderRadius(latest, _layoutState, _a) {
  var target = _a.target;
  if (typeof latest === "string") {
    if (px.test(latest)) {
      latest = parseFloat(latest);
    } else {
      return latest;
    }
  }
  var x2 = pixelsToPercent(latest, target.x);
  var y2 = pixelsToPercent(latest, target.y);
  return x2 + "% " + y2 + "%";
}
var varToken = "_$css";
function correctBoxShadow(latest, _a) {
  var delta2 = _a.delta, treeScale = _a.treeScale;
  var original = latest;
  var containsCSSVariables = latest.includes("var(");
  var cssVariables = [];
  if (containsCSSVariables) {
    latest = latest.replace(cssVariableRegex, function(match) {
      cssVariables.push(match);
      return varToken;
    });
  }
  var shadow = complex.parse(latest);
  if (shadow.length > 5)
    return original;
  var template = complex.createTransformer(latest);
  var offset = typeof shadow[0] !== "number" ? 1 : 0;
  var xScale = delta2.x.scale * treeScale.x;
  var yScale = delta2.y.scale * treeScale.y;
  shadow[0 + offset] /= xScale;
  shadow[1 + offset] /= yScale;
  var averageScale = mix(xScale, yScale, 0.5);
  if (typeof shadow[2 + offset] === "number")
    shadow[2 + offset] /= averageScale;
  if (typeof shadow[3 + offset] === "number")
    shadow[3 + offset] /= averageScale;
  var output = template(shadow);
  if (containsCSSVariables) {
    var i_1 = 0;
    output = output.replace(varToken, function() {
      var cssVariable = cssVariables[i_1];
      i_1++;
      return cssVariable;
    });
  }
  return output;
}
var borderCorrectionDefinition = {
  process: correctBorderRadius
};
var defaultScaleCorrectors = {
  borderRadius: __assign(__assign({}, borderCorrectionDefinition), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: borderCorrectionDefinition,
  borderTopRightRadius: borderCorrectionDefinition,
  borderBottomLeftRadius: borderCorrectionDefinition,
  borderBottomRightRadius: borderCorrectionDefinition,
  boxShadow: {
    process: correctBoxShadow
  }
};

// ../../node_modules/framer-motion/dist/es/motion/features/layout/Animate.js
var progressTarget = 1e3;
var Animate = function(_super) {
  __extends(Animate2, _super);
  function Animate2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.frameTarget = axisBox();
    _this.currentAnimationTarget = axisBox();
    _this.isAnimating = {
      x: false,
      y: false
    };
    _this.stopAxisAnimation = {
      x: void 0,
      y: void 0
    };
    _this.isAnimatingTree = false;
    _this.animate = function(target, origin, _a) {
      if (_a === void 0) {
        _a = {};
      }
      var originBox = _a.originBox, targetBox = _a.targetBox, visibilityAction = _a.visibilityAction, shouldStackAnimate = _a.shouldStackAnimate, onComplete = _a.onComplete, prevParent = _a.prevParent, config = __rest(_a, ["originBox", "targetBox", "visibilityAction", "shouldStackAnimate", "onComplete", "prevParent"]);
      var _b = _this.props, visualElement2 = _b.visualElement, layout = _b.layout;
      if (shouldStackAnimate === false) {
        _this.isAnimatingTree = false;
        return _this.safeToRemove();
      }
      if (_this.isAnimatingTree && shouldStackAnimate !== true) {
        return;
      } else if (shouldStackAnimate) {
        _this.isAnimatingTree = true;
      }
      origin = originBox || origin;
      target = targetBox || target;
      var isRelative = false;
      var projectionParent = visualElement2.getProjectionParent();
      if (projectionParent) {
        var prevParentViewportBox = projectionParent.prevViewportBox;
        var parentLayout = projectionParent.getLayoutState().layout;
        if (prevParent) {
          if (targetBox) {
            parentLayout = prevParent.getLayoutState().layout;
          }
          if (originBox && !checkIfParentHasChanged(prevParent, projectionParent) && prevParent.prevViewportBox) {
            prevParentViewportBox = prevParent.prevViewportBox;
          }
        }
        if (prevParentViewportBox && isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox)) {
          isRelative = true;
          origin = calcRelativeOffset(prevParentViewportBox, origin);
          target = calcRelativeOffset(parentLayout, target);
        }
      }
      var boxHasMoved = hasMoved(origin, target);
      var animations2 = eachAxis(function(axis) {
        var _a2, _b2;
        if (layout === "position") {
          var targetLength = target[axis].max - target[axis].min;
          origin[axis].max = origin[axis].min + targetLength;
        }
        if (visualElement2.projection.isTargetLocked) {
          return;
        } else if (visibilityAction !== void 0) {
          visualElement2.setVisibility(visibilityAction === VisibilityAction.Show);
        } else if (boxHasMoved) {
          return _this.animateAxis(axis, target[axis], origin[axis], __assign(__assign({}, config), { isRelative }));
        } else {
          (_b2 = (_a2 = _this.stopAxisAnimation)[axis]) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
          return visualElement2.setProjectionTargetAxis(axis, target[axis].min, target[axis].max, isRelative);
        }
      });
      visualElement2.syncRender();
      return Promise.all(animations2).then(function() {
        _this.isAnimatingTree = false;
        onComplete && onComplete();
        visualElement2.notifyLayoutAnimationComplete();
      });
    };
    return _this;
  }
  Animate2.prototype.componentDidMount = function() {
    var _this = this;
    var visualElement2 = this.props.visualElement;
    visualElement2.animateMotionValue = startAnimation;
    visualElement2.enableLayoutProjection();
    this.unsubLayoutReady = visualElement2.onLayoutUpdate(this.animate);
    visualElement2.layoutSafeToRemove = function() {
      return _this.safeToRemove();
    };
    addScaleCorrection(defaultScaleCorrectors);
  };
  Animate2.prototype.componentWillUnmount = function() {
    var _this = this;
    this.unsubLayoutReady();
    eachAxis(function(axis) {
      var _a, _b;
      return (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a);
    });
  };
  Animate2.prototype.animateAxis = function(axis, target, origin, _a) {
    var _this = this;
    var _b, _c;
    var _d = _a === void 0 ? {} : _a, transition = _d.transition, isRelative = _d.isRelative;
    if (this.isAnimating[axis] && axisIsEqual(target, this.currentAnimationTarget[axis])) {
      return;
    }
    (_c = (_b = this.stopAxisAnimation)[axis]) === null || _c === void 0 ? void 0 : _c.call(_b);
    this.isAnimating[axis] = true;
    var visualElement2 = this.props.visualElement;
    var frameTarget = this.frameTarget[axis];
    var layoutProgress = visualElement2.getProjectionAnimationProgress()[axis];
    layoutProgress.clearListeners();
    layoutProgress.set(0);
    layoutProgress.set(0);
    var frame2 = function() {
      var p2 = layoutProgress.get() / progressTarget;
      tweenAxis(frameTarget, origin, target, p2);
      visualElement2.setProjectionTargetAxis(axis, frameTarget.min, frameTarget.max, isRelative);
    };
    frame2();
    var unsubscribeProgress = layoutProgress.onChange(frame2);
    this.stopAxisAnimation[axis] = function() {
      _this.isAnimating[axis] = false;
      layoutProgress.stop();
      unsubscribeProgress();
    };
    this.currentAnimationTarget[axis] = target;
    var layoutTransition = transition || visualElement2.getDefaultTransition() || defaultLayoutTransition;
    var animation = startAnimation(axis === "x" ? "layoutX" : "layoutY", layoutProgress, progressTarget, layoutTransition && getValueTransition(layoutTransition, "layout")).then(this.stopAxisAnimation[axis]);
    return animation;
  };
  Animate2.prototype.safeToRemove = function() {
    var _a, _b;
    (_b = (_a = this.props).safeToRemove) === null || _b === void 0 ? void 0 : _b.call(_a);
  };
  Animate2.prototype.render = function() {
    return null;
  };
  return Animate2;
}(React10.Component);
function AnimateLayoutContextProvider(props) {
  var _a = __read(usePresence(), 2), safeToRemove = _a[1];
  return React10.createElement(Animate, __assign({}, props, { safeToRemove }));
}
function hasMoved(a3, b3) {
  return !isZeroBox(a3) && !isZeroBox(b3) && (!axisIsEqual(a3.x, b3.x) || !axisIsEqual(a3.y, b3.y));
}
var zeroAxis = { min: 0, max: 0 };
function isZeroBox(a3) {
  return axisIsEqual(a3.x, zeroAxis) && axisIsEqual(a3.y, zeroAxis);
}
function axisIsEqual(a3, b3) {
  return a3.min === b3.min && a3.max === b3.max;
}
var defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox) {
  return prevParent || !prevParent && !(originBox || targetBox);
}

// ../../node_modules/framer-motion/dist/es/motion/features/layout/Measure.js
var import_react34 = __toESM(require("react"));

// ../../node_modules/framer-motion/dist/es/context/SharedLayoutContext.js
var import_react33 = require("react");

// ../../node_modules/framer-motion/dist/es/components/AnimateSharedLayout/utils/batcher.js
var defaultHandler = {
  layoutReady: function(child) {
    return child.notifyLayoutReady();
  }
};
function createBatcher() {
  var queue = /* @__PURE__ */ new Set();
  return {
    add: function(child) {
      return queue.add(child);
    },
    flush: function(_a) {
      var _b = _a === void 0 ? defaultHandler : _a, layoutReady = _b.layoutReady, parent = _b.parent;
      batchLayout(function(read, write) {
        var order2 = Array.from(queue).sort(compareByDepth);
        var ancestors = parent ? collectProjectingAncestors(parent) : [];
        write(function() {
          var allElements = __spreadArray(__spreadArray([], __read(ancestors)), __read(order2));
          allElements.forEach(function(element) {
            return element.resetTransform();
          });
        });
        read(function() {
          order2.forEach(updateLayoutMeasurement);
        });
        write(function() {
          ancestors.forEach(function(element) {
            return element.restoreTransform();
          });
          order2.forEach(layoutReady);
        });
        read(function() {
          order2.forEach(function(child) {
            if (child.isPresent)
              child.presence = Presence.Present;
          });
        });
        write(function() {
          flushSync.preRender();
          flushSync.render();
        });
        read(function() {
          es_default.postRender(function() {
            return order2.forEach(assignProjectionToSnapshot);
          });
          queue.clear();
        });
      });
      flushLayout();
    }
  };
}
function assignProjectionToSnapshot(child) {
  child.prevViewportBox = child.projection.target;
}

// ../../node_modules/framer-motion/dist/es/context/SharedLayoutContext.js
var SharedLayoutContext = (0, import_react33.createContext)(createBatcher());
var FramerTreeLayoutContext = (0, import_react33.createContext)(createBatcher());
function isSharedLayout(context) {
  return !!context.forceUpdate;
}

// ../../node_modules/framer-motion/dist/es/motion/features/layout/Measure.js
var Measure = function(_super) {
  __extends(Measure2, _super);
  function Measure2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Measure2.prototype.componentDidMount = function() {
    var _a = this.props, syncLayout = _a.syncLayout, framerSyncLayout = _a.framerSyncLayout, visualElement2 = _a.visualElement;
    isSharedLayout(syncLayout) && syncLayout.register(visualElement2);
    isSharedLayout(framerSyncLayout) && framerSyncLayout.register(visualElement2);
    visualElement2.onUnmount(function() {
      if (isSharedLayout(syncLayout)) {
        syncLayout.remove(visualElement2);
      }
      if (isSharedLayout(framerSyncLayout)) {
        framerSyncLayout.remove(visualElement2);
      }
    });
  };
  Measure2.prototype.getSnapshotBeforeUpdate = function() {
    var _a = this.props, syncLayout = _a.syncLayout, visualElement2 = _a.visualElement;
    if (isSharedLayout(syncLayout)) {
      syncLayout.syncUpdate();
    } else {
      snapshotViewportBox(visualElement2);
      syncLayout.add(visualElement2);
    }
    return null;
  };
  Measure2.prototype.componentDidUpdate = function() {
    var syncLayout = this.props.syncLayout;
    if (!isSharedLayout(syncLayout))
      syncLayout.flush();
  };
  Measure2.prototype.render = function() {
    return null;
  };
  return Measure2;
}(import_react34.default.Component);
function MeasureContextProvider(props) {
  var syncLayout = (0, import_react34.useContext)(SharedLayoutContext);
  var framerSyncLayout = (0, import_react34.useContext)(FramerTreeLayoutContext);
  return import_react34.default.createElement(Measure, __assign({}, props, { syncLayout, framerSyncLayout }));
}

// ../../node_modules/framer-motion/dist/es/motion/features/layout/index.js
var layoutAnimations = {
  measureLayout: MeasureContextProvider,
  layoutAnimation: AnimateLayoutContextProvider
};

// ../../node_modules/framer-motion/dist/es/render/utils/state.js
var createProjectionState = function() {
  return {
    isEnabled: false,
    isHydrated: false,
    isTargetLocked: false,
    target: axisBox(),
    targetFinal: axisBox()
  };
};
function createLayoutState() {
  return {
    isHydrated: false,
    layout: axisBox(),
    layoutCorrected: axisBox(),
    treeScale: { x: 1, y: 1 },
    delta: delta(),
    deltaFinal: delta(),
    deltaTransform: ""
  };
}
var zeroLayout = createLayoutState();

// ../../node_modules/framer-motion/dist/es/render/html/utils/build-projection-transform.js
function buildLayoutProjectionTransform(_a, treeScale, latestTransform) {
  var x2 = _a.x, y2 = _a.y;
  var xTranslate = x2.translate / treeScale.x;
  var yTranslate = y2.translate / treeScale.y;
  var transform = "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) ";
  if (latestTransform) {
    var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
    if (rotate)
      transform += "rotate(" + rotate + ") ";
    if (rotateX)
      transform += "rotateX(" + rotateX + ") ";
    if (rotateY)
      transform += "rotateY(" + rotateY + ") ";
  }
  transform += "scale(" + x2.scale + ", " + y2.scale + ")";
  return !latestTransform && transform === identityProjection ? "" : transform;
}
function buildLayoutProjectionTransformOrigin(_a) {
  var deltaFinal = _a.deltaFinal;
  return deltaFinal.x.origin * 100 + "% " + deltaFinal.y.origin * 100 + "% 0";
}
var identityProjection = buildLayoutProjectionTransform(zeroLayout.delta, zeroLayout.treeScale, { x: 1, y: 1 });

// ../../node_modules/framer-motion/dist/es/render/utils/lifecycles.js
var names = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function createLifecycles() {
  var managers = names.map(function() {
    return new SubscriptionManager();
  });
  var propSubscriptions = {};
  var lifecycles = {
    clearAllListeners: function() {
      return managers.forEach(function(manager) {
        return manager.clear();
      });
    },
    updatePropListeners: function(props) {
      return names.forEach(function(name) {
        var _a;
        (_a = propSubscriptions[name]) === null || _a === void 0 ? void 0 : _a.call(propSubscriptions);
        var on = "on" + name;
        var propListener = props[on];
        if (propListener) {
          propSubscriptions[name] = lifecycles[on](propListener);
        }
      });
    }
  };
  managers.forEach(function(manager, i2) {
    lifecycles["on" + names[i2]] = function(handler) {
      return manager.add(handler);
    };
    lifecycles["notify" + names[i2]] = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return manager.notify.apply(manager, __spreadArray([], __read(args)));
    };
  });
  return lifecycles;
}

// ../../node_modules/framer-motion/dist/es/render/utils/motion-values.js
function updateMotionValuesFromProps(element, next, prev) {
  var _a;
  for (var key in next) {
    var nextValue = next[key];
    var prevValue = prev[key];
    if (isMotionValue(nextValue)) {
      element.addValue(key, nextValue);
    } else if (isMotionValue(prevValue)) {
      element.addValue(key, motionValue(nextValue));
    } else if (prevValue !== nextValue) {
      if (element.hasValue(key)) {
        var existingValue = element.getValue(key);
        !existingValue.hasAnimated && existingValue.set(nextValue);
      } else {
        element.addValue(key, motionValue((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
      }
    }
  }
  for (var key in prev) {
    if (next[key] === void 0)
      element.removeValue(key);
  }
  return next;
}

// ../../node_modules/framer-motion/dist/es/render/utils/projection.js
function updateLayoutDeltas(_a, _b, treePath, transformOrigin) {
  var delta2 = _a.delta, layout = _a.layout, layoutCorrected = _a.layoutCorrected, treeScale = _a.treeScale;
  var target = _b.target;
  resetBox(layoutCorrected, layout);
  applyTreeDeltas(layoutCorrected, treeScale, treePath);
  updateBoxDelta(delta2, layoutCorrected, target, transformOrigin);
}

// ../../node_modules/framer-motion/dist/es/render/utils/flat-tree.js
var FlatTree = function() {
  function FlatTree2() {
    this.children = [];
    this.isDirty = false;
  }
  FlatTree2.prototype.add = function(child) {
    addUniqueItem(this.children, child);
    this.isDirty = true;
  };
  FlatTree2.prototype.remove = function(child) {
    removeItem(this.children, child);
    this.isDirty = true;
  };
  FlatTree2.prototype.forEach = function(callback) {
    this.isDirty && this.children.sort(compareByDepth);
    this.isDirty = false;
    this.children.forEach(callback);
  };
  return FlatTree2;
}();

// ../../node_modules/framer-motion/dist/es/render/dom/projection/relative-set.js
function setCurrentViewportBox(visualElement2) {
  var projectionParent = visualElement2.getProjectionParent();
  if (!projectionParent) {
    visualElement2.rebaseProjectionTarget();
    return;
  }
  var relativeOffset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement2.getLayoutState().layout);
  eachAxis(function(axis) {
    visualElement2.setProjectionTargetAxis(axis, relativeOffset[axis].min, relativeOffset[axis].max, true);
  });
}

// ../../node_modules/framer-motion/dist/es/render/index.js
var visualElement = function(_a) {
  var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, resetTransform = _a.resetTransform, restoreTransform = _a.restoreTransform, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps3 = _a.scrapeMotionValuesFromProps;
  return function(_a2, options) {
    var parent = _a2.parent, props = _a2.props, presenceId2 = _a2.presenceId, blockInitialAnimation = _a2.blockInitialAnimation, visualState = _a2.visualState;
    if (options === void 0) {
      options = {};
    }
    var latestValues = visualState.latestValues, renderState = visualState.renderState;
    var instance;
    var lifecycles = createLifecycles();
    var projection = createProjectionState();
    var projectionParent;
    var leadProjection = projection;
    var leadLatestValues = latestValues;
    var unsubscribeFromLeadVisualElement;
    var layoutState = createLayoutState();
    var crossfader;
    var hasViewportBoxUpdated = false;
    var values = /* @__PURE__ */ new Map();
    var valueSubscriptions = /* @__PURE__ */ new Map();
    var prevMotionValues = {};
    var projectionTargetProgress;
    var baseTarget = __assign({}, latestValues);
    var removeFromVariantTree;
    function render() {
      if (!instance)
        return;
      if (element.isProjectionReady()) {
        applyBoxTransforms(leadProjection.targetFinal, leadProjection.target, leadLatestValues);
        updateBoxDelta(layoutState.deltaFinal, layoutState.layoutCorrected, leadProjection.targetFinal, latestValues);
      }
      triggerBuild();
      renderInstance(instance, renderState);
    }
    function triggerBuild() {
      var valuesToRender = latestValues;
      if (crossfader && crossfader.isActive()) {
        var crossfadedValues = crossfader.getCrossfadeState(element);
        if (crossfadedValues)
          valuesToRender = crossfadedValues;
      }
      build(element, renderState, valuesToRender, leadProjection, layoutState, options, props);
    }
    function update() {
      lifecycles.notifyUpdate(latestValues);
    }
    function updateLayoutProjection() {
      if (!element.isProjectionReady())
        return;
      var delta2 = layoutState.delta, treeScale = layoutState.treeScale;
      var prevTreeScaleX = treeScale.x;
      var prevTreeScaleY = treeScale.y;
      var prevDeltaTransform = layoutState.deltaTransform;
      updateLayoutDeltas(layoutState, leadProjection, element.path, latestValues);
      hasViewportBoxUpdated && element.notifyViewportBoxUpdate(leadProjection.target, delta2);
      hasViewportBoxUpdated = false;
      var deltaTransform = buildLayoutProjectionTransform(delta2, treeScale);
      if (deltaTransform !== prevDeltaTransform || prevTreeScaleX !== treeScale.x || prevTreeScaleY !== treeScale.y) {
        element.scheduleRender();
      }
      layoutState.deltaTransform = deltaTransform;
    }
    function updateTreeLayoutProjection() {
      element.layoutTree.forEach(fireUpdateLayoutProjection);
    }
    function bindToMotionValue(key2, value2) {
      var removeOnChange = value2.onChange(function(latestValue) {
        latestValues[key2] = latestValue;
        props.onUpdate && es_default.update(update, false, true);
      });
      var removeOnRenderRequest = value2.onRenderRequest(element.scheduleRender);
      valueSubscriptions.set(key2, function() {
        removeOnChange();
        removeOnRenderRequest();
      });
    }
    var initialMotionValues = scrapeMotionValuesFromProps3(props);
    for (var key in initialMotionValues) {
      var value = initialMotionValues[key];
      if (latestValues[key] !== void 0 && isMotionValue(value)) {
        value.set(latestValues[key], false);
      }
    }
    var isControllingVariants = checkIfControllingVariants(props);
    var isVariantNode = checkIfVariantNode(props);
    var element = __assign(__assign({
      treeType,
      current: null,
      depth: parent ? parent.depth + 1 : 0,
      parent,
      children: /* @__PURE__ */ new Set(),
      path: parent ? __spreadArray(__spreadArray([], __read(parent.path)), [parent]) : [],
      layoutTree: parent ? parent.layoutTree : new FlatTree(),
      presenceId: presenceId2,
      projection,
      variantChildren: isVariantNode ? /* @__PURE__ */ new Set() : void 0,
      isVisible: void 0,
      manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
      blockInitialAnimation,
      isMounted: function() {
        return Boolean(instance);
      },
      mount: function(newInstance) {
        instance = element.current = newInstance;
        element.pointTo(element);
        if (isVariantNode && parent && !isControllingVariants) {
          removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
        }
        parent === null || parent === void 0 ? void 0 : parent.children.add(element);
      },
      unmount: function() {
        cancelSync.update(update);
        cancelSync.render(render);
        cancelSync.preRender(element.updateLayoutProjection);
        valueSubscriptions.forEach(function(remove) {
          return remove();
        });
        element.stopLayoutAnimation();
        element.layoutTree.remove(element);
        removeFromVariantTree === null || removeFromVariantTree === void 0 ? void 0 : removeFromVariantTree();
        parent === null || parent === void 0 ? void 0 : parent.children.delete(element);
        unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 ? void 0 : unsubscribeFromLeadVisualElement();
        lifecycles.clearAllListeners();
      },
      addVariantChild: function(child) {
        var _a3;
        var closestVariantNode = element.getClosestVariantNode();
        if (closestVariantNode) {
          (_a3 = closestVariantNode.variantChildren) === null || _a3 === void 0 ? void 0 : _a3.add(child);
          return function() {
            return closestVariantNode.variantChildren.delete(child);
          };
        }
      },
      sortNodePosition: function(other) {
        if (!sortNodePosition || treeType !== other.treeType)
          return 0;
        return sortNodePosition(element.getInstance(), other.getInstance());
      },
      getClosestVariantNode: function() {
        return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
      },
      scheduleUpdateLayoutProjection: parent ? parent.scheduleUpdateLayoutProjection : function() {
        return es_default.preRender(element.updateTreeLayoutProjection, false, true);
      },
      getLayoutId: function() {
        return props.layoutId;
      },
      getInstance: function() {
        return instance;
      },
      getStaticValue: function(key2) {
        return latestValues[key2];
      },
      setStaticValue: function(key2, value2) {
        return latestValues[key2] = value2;
      },
      getLatestValues: function() {
        return latestValues;
      },
      setVisibility: function(visibility) {
        if (element.isVisible === visibility)
          return;
        element.isVisible = visibility;
        element.scheduleRender();
      },
      makeTargetAnimatable: function(target, canMutate) {
        if (canMutate === void 0) {
          canMutate = true;
        }
        return makeTargetAnimatable(element, target, props, canMutate);
      },
      addValue: function(key2, value2) {
        if (element.hasValue(key2))
          element.removeValue(key2);
        values.set(key2, value2);
        latestValues[key2] = value2.get();
        bindToMotionValue(key2, value2);
      },
      removeValue: function(key2) {
        var _a3;
        values.delete(key2);
        (_a3 = valueSubscriptions.get(key2)) === null || _a3 === void 0 ? void 0 : _a3();
        valueSubscriptions.delete(key2);
        delete latestValues[key2];
        removeValueFromRenderState(key2, renderState);
      },
      hasValue: function(key2) {
        return values.has(key2);
      },
      getValue: function(key2, defaultValue) {
        var value2 = values.get(key2);
        if (value2 === void 0 && defaultValue !== void 0) {
          value2 = motionValue(defaultValue);
          element.addValue(key2, value2);
        }
        return value2;
      },
      forEachValue: function(callback) {
        return values.forEach(callback);
      },
      readValue: function(key2) {
        var _a3;
        return (_a3 = latestValues[key2]) !== null && _a3 !== void 0 ? _a3 : readValueFromInstance(instance, key2, options);
      },
      setBaseTarget: function(key2, value2) {
        baseTarget[key2] = value2;
      },
      getBaseTarget: function(key2) {
        if (getBaseTarget) {
          var target = getBaseTarget(props, key2);
          if (target !== void 0 && !isMotionValue(target))
            return target;
        }
        return baseTarget[key2];
      }
    }, lifecycles), {
      build: function() {
        triggerBuild();
        return renderState;
      },
      scheduleRender: function() {
        es_default.render(render, false, true);
      },
      syncRender: render,
      setProps: function(newProps) {
        props = newProps;
        lifecycles.updatePropListeners(newProps);
        prevMotionValues = updateMotionValuesFromProps(element, scrapeMotionValuesFromProps3(props), prevMotionValues);
      },
      getProps: function() {
        return props;
      },
      getVariant: function(name) {
        var _a3;
        return (_a3 = props.variants) === null || _a3 === void 0 ? void 0 : _a3[name];
      },
      getDefaultTransition: function() {
        return props.transition;
      },
      getVariantContext: function(startAtParent) {
        if (startAtParent === void 0) {
          startAtParent = false;
        }
        if (startAtParent)
          return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
        if (!isControllingVariants) {
          var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
          if (props.initial !== void 0) {
            context_1.initial = props.initial;
          }
          return context_1;
        }
        var context = {};
        for (var i2 = 0; i2 < numVariantProps; i2++) {
          var name_1 = variantProps[i2];
          var prop = props[name_1];
          if (isVariantLabel(prop) || prop === false) {
            context[name_1] = prop;
          }
        }
        return context;
      },
      enableLayoutProjection: function() {
        projection.isEnabled = true;
        element.layoutTree.add(element);
      },
      lockProjectionTarget: function() {
        projection.isTargetLocked = true;
      },
      unlockProjectionTarget: function() {
        element.stopLayoutAnimation();
        projection.isTargetLocked = false;
      },
      getLayoutState: function() {
        return layoutState;
      },
      setCrossfader: function(newCrossfader) {
        crossfader = newCrossfader;
      },
      isProjectionReady: function() {
        return projection.isEnabled && projection.isHydrated && layoutState.isHydrated;
      },
      startLayoutAnimation: function(axis, transition, isRelative) {
        if (isRelative === void 0) {
          isRelative = false;
        }
        var progress2 = element.getProjectionAnimationProgress()[axis];
        var _a3 = isRelative ? projection.relativeTarget[axis] : projection.target[axis], min = _a3.min, max = _a3.max;
        var length = max - min;
        progress2.clearListeners();
        progress2.set(min);
        progress2.set(min);
        progress2.onChange(function(v2) {
          element.setProjectionTargetAxis(axis, v2, v2 + length, isRelative);
        });
        return element.animateMotionValue(axis, progress2, 0, transition);
      },
      stopLayoutAnimation: function() {
        eachAxis(function(axis) {
          return element.getProjectionAnimationProgress()[axis].stop();
        });
      },
      measureViewportBox: function(withTransform) {
        if (withTransform === void 0) {
          withTransform = true;
        }
        var viewportBox = measureViewportBox(instance, options);
        if (!withTransform)
          removeBoxTransforms(viewportBox, latestValues);
        return viewportBox;
      },
      getProjectionAnimationProgress: function() {
        projectionTargetProgress || (projectionTargetProgress = {
          x: motionValue(0),
          y: motionValue(0)
        });
        return projectionTargetProgress;
      },
      setProjectionTargetAxis: function(axis, min, max, isRelative) {
        if (isRelative === void 0) {
          isRelative = false;
        }
        var target;
        if (isRelative) {
          if (!projection.relativeTarget) {
            projection.relativeTarget = axisBox();
          }
          target = projection.relativeTarget[axis];
        } else {
          projection.relativeTarget = void 0;
          target = projection.target[axis];
        }
        projection.isHydrated = true;
        target.min = min;
        target.max = max;
        hasViewportBoxUpdated = true;
        lifecycles.notifySetAxisTarget();
      },
      rebaseProjectionTarget: function(force, box) {
        if (box === void 0) {
          box = layoutState.layout;
        }
        var _a3 = element.getProjectionAnimationProgress(), x2 = _a3.x, y2 = _a3.y;
        var shouldRebase = !projection.relativeTarget && !projection.isTargetLocked && !x2.isAnimating() && !y2.isAnimating();
        if (force || shouldRebase) {
          eachAxis(function(axis) {
            var _a4 = box[axis], min = _a4.min, max = _a4.max;
            element.setProjectionTargetAxis(axis, min, max);
          });
        }
      },
      notifyLayoutReady: function(config) {
        setCurrentViewportBox(element);
        element.notifyLayoutUpdate(layoutState.layout, element.prevViewportBox || layoutState.layout, config);
      },
      resetTransform: function() {
        return resetTransform(element, instance, props);
      },
      restoreTransform: function() {
        return restoreTransform(instance, renderState);
      },
      updateLayoutProjection,
      updateTreeLayoutProjection: function() {
        element.layoutTree.forEach(fireResolveRelativeTargetBox);
        es_default.preRender(updateTreeLayoutProjection, false, true);
      },
      getProjectionParent: function() {
        if (projectionParent === void 0) {
          var foundParent = false;
          for (var i2 = element.path.length - 1; i2 >= 0; i2--) {
            var ancestor = element.path[i2];
            if (ancestor.projection.isEnabled) {
              foundParent = ancestor;
              break;
            }
          }
          projectionParent = foundParent;
        }
        return projectionParent;
      },
      resolveRelativeTargetBox: function() {
        var relativeParent = element.getProjectionParent();
        if (!projection.relativeTarget || !relativeParent)
          return;
        calcRelativeBox(projection, relativeParent.projection);
        if (isDraggable(relativeParent)) {
          var target = projection.target;
          applyBoxTransforms(target, target, relativeParent.getLatestValues());
        }
      },
      shouldResetTransform: function() {
        return Boolean(props._layoutResetTransform);
      },
      pointTo: function(newLead) {
        leadProjection = newLead.projection;
        leadLatestValues = newLead.getLatestValues();
        unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 ? void 0 : unsubscribeFromLeadVisualElement();
        unsubscribeFromLeadVisualElement = pipe(newLead.onSetAxisTarget(element.scheduleUpdateLayoutProjection), newLead.onLayoutAnimationComplete(function() {
          var _a3;
          if (element.isPresent) {
            element.presence = Presence.Present;
          } else {
            (_a3 = element.layoutSafeToRemove) === null || _a3 === void 0 ? void 0 : _a3.call(element);
          }
        }));
      },
      isPresent: true,
      presence: Presence.Entering
    });
    return element;
  };
};
function fireResolveRelativeTargetBox(child) {
  child.resolveRelativeTargetBox();
}
function fireUpdateLayoutProjection(child) {
  child.updateLayoutProjection();
}
var variantProps = __spreadArray(["initial"], __read(variantPriorityOrder));
var numVariantProps = variantProps.length;

// ../../node_modules/framer-motion/dist/es/render/dom/utils/unit-conversion.js
var positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]);
var isPositionalKey = function(key) {
  return positionalKeys.has(key);
};
var hasPositionalKey = function(target) {
  return Object.keys(target).some(isPositionalKey);
};
var setAndResetVelocity = function(value, to) {
  value.set(to, false);
  value.set(to);
};
var isNumOrPxType = function(v2) {
  return v2 === number || v2 === px;
};
var BoundingBoxDimension;
(function(BoundingBoxDimension2) {
  BoundingBoxDimension2["width"] = "width";
  BoundingBoxDimension2["height"] = "height";
  BoundingBoxDimension2["left"] = "left";
  BoundingBoxDimension2["right"] = "right";
  BoundingBoxDimension2["top"] = "top";
  BoundingBoxDimension2["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function(matrix, pos) {
  return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function(pos2, pos3) {
  return function(_bbox, _a) {
    var transform = _a.transform;
    if (transform === "none" || !transform)
      return 0;
    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
      return getPosFromMatrix(matrix3d[1], pos3);
    } else {
      var matrix = transform.match(/^matrix\((.+)\)$/);
      if (matrix) {
        return getPosFromMatrix(matrix[1], pos2);
      } else {
        return 0;
      }
    }
  };
};
var transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformProps.filter(function(key) {
  return !transformKeys.has(key);
});
function removeNonTranslationalTransform(visualElement2) {
  var removedTransforms = [];
  nonTranslationalTransformKeys.forEach(function(key) {
    var value = visualElement2.getValue(key);
    if (value !== void 0) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  if (removedTransforms.length)
    visualElement2.syncRender();
  return removedTransforms;
}
var positionalValues = {
  width: function(_a) {
    var x2 = _a.x;
    return x2.max - x2.min;
  },
  height: function(_a) {
    var y2 = _a.y;
    return y2.max - y2.min;
  },
  top: function(_bbox, _a) {
    var top = _a.top;
    return parseFloat(top);
  },
  left: function(_bbox, _a) {
    var left = _a.left;
    return parseFloat(left);
  },
  bottom: function(_a, _b) {
    var y2 = _a.y;
    var top = _b.top;
    return parseFloat(top) + (y2.max - y2.min);
  },
  right: function(_a, _b) {
    var x2 = _a.x;
    var left = _b.left;
    return parseFloat(left) + (x2.max - x2.min);
  },
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
var convertChangedValueTypes = function(target, visualElement2, changedKeys) {
  var originBbox = visualElement2.measureViewportBox();
  var element = visualElement2.getInstance();
  var elementComputedStyle = getComputedStyle(element);
  var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
  var originComputedStyle = { top, left, bottom, right, transform };
  if (display === "none") {
    visualElement2.setStaticValue("display", target.display || "block");
  }
  visualElement2.syncRender();
  var targetBbox = visualElement2.measureViewportBox();
  changedKeys.forEach(function(key) {
    var value = visualElement2.getValue(key);
    setAndResetVelocity(value, positionalValues[key](originBbox, originComputedStyle));
    target[key] = positionalValues[key](targetBbox, elementComputedStyle);
  });
  return target;
};
var checkAndConvertChangedValueTypes = function(visualElement2, target, origin, transitionEnd) {
  if (origin === void 0) {
    origin = {};
  }
  if (transitionEnd === void 0) {
    transitionEnd = {};
  }
  target = __assign({}, target);
  transitionEnd = __assign({}, transitionEnd);
  var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
  var removedTransformValues = [];
  var hasAttemptedToRemoveTransformValues = false;
  var changedValueTypeKeys = [];
  targetPositionalKeys.forEach(function(key) {
    var value = visualElement2.getValue(key);
    if (!visualElement2.hasValue(key))
      return;
    var from = origin[key];
    var to = target[key];
    var fromType = findDimensionValueType(from);
    var toType;
    if (isKeyframesTarget(to)) {
      var numKeyframes = to.length;
      for (var i2 = to[0] === null ? 1 : 0; i2 < numKeyframes; i2++) {
        if (!toType) {
          toType = findDimensionValueType(to[i2]);
          invariant(toType === fromType || isNumOrPxType(fromType) && isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
        } else {
          invariant(findDimensionValueType(to[i2]) === toType, "All keyframes must be of the same type");
        }
      }
    } else {
      toType = findDimensionValueType(to);
    }
    if (fromType !== toType) {
      if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
        var current = value.get();
        if (typeof current === "string") {
          value.set(parseFloat(current));
        }
        if (typeof to === "string") {
          target[key] = parseFloat(to);
        } else if (Array.isArray(to) && toType === px) {
          target[key] = to.map(parseFloat);
        }
      } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
        if (from === 0) {
          value.set(toType.transform(from));
        } else {
          target[key] = fromType.transform(to);
        }
      } else {
        if (!hasAttemptedToRemoveTransformValues) {
          removedTransformValues = removeNonTranslationalTransform(visualElement2);
          hasAttemptedToRemoveTransformValues = true;
        }
        changedValueTypeKeys.push(key);
        transitionEnd[key] = transitionEnd[key] !== void 0 ? transitionEnd[key] : target[key];
        setAndResetVelocity(value, to);
      }
    }
  });
  if (changedValueTypeKeys.length) {
    var convertedTarget = convertChangedValueTypes(target, visualElement2, changedValueTypeKeys);
    if (removedTransformValues.length) {
      removedTransformValues.forEach(function(_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        visualElement2.getValue(key).set(value);
      });
    }
    visualElement2.syncRender();
    return { target: convertedTarget, transitionEnd };
  } else {
    return { target, transitionEnd };
  }
};
function unitConversion(visualElement2, target, origin, transitionEnd) {
  return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(visualElement2, target, origin, transitionEnd) : { target, transitionEnd };
}

// ../../node_modules/framer-motion/dist/es/render/dom/utils/parse-dom-variant.js
var parseDomVariant = function(visualElement2, target, origin, transitionEnd) {
  var resolved = resolveCSSVariables(visualElement2, target, transitionEnd);
  target = resolved.target;
  transitionEnd = resolved.transitionEnd;
  return unitConversion(visualElement2, target, origin, transitionEnd);
};

// ../../node_modules/framer-motion/dist/es/render/html/visual-element.js
function getComputedStyle2(element) {
  return window.getComputedStyle(element);
}
var htmlConfig = {
  treeType: "dom",
  readValueFromInstance: function(domElement, key) {
    if (isTransformProp(key)) {
      var defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    } else {
      var computedStyle = getComputedStyle2(domElement);
      return (isCSSVariable(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
    }
  },
  sortNodePosition: function(a3, b3) {
    return a3.compareDocumentPosition(b3) & 2 ? 1 : -1;
  },
  getBaseTarget: function(props, key) {
    var _a;
    return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
  },
  measureViewportBox: function(element, _a) {
    var transformPagePoint = _a.transformPagePoint;
    return getBoundingBox(element, transformPagePoint);
  },
  resetTransform: function(element, domElement, props) {
    var transformTemplate = props.transformTemplate;
    domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
    element.scheduleRender();
  },
  restoreTransform: function(instance, mutableState) {
    instance.style.transform = mutableState.style.transform;
  },
  removeValueFromRenderState: function(key, _a) {
    var vars = _a.vars, style = _a.style;
    delete vars[key];
    delete style[key];
  },
  makeTargetAnimatable: function(element, _a, _b, isMounted) {
    var transformValues = _b.transformValues;
    if (isMounted === void 0) {
      isMounted = true;
    }
    var transition = _a.transition, transitionEnd = _a.transitionEnd, target = __rest(_a, ["transition", "transitionEnd"]);
    var origin = getOrigin(target, transition || {}, element);
    if (transformValues) {
      if (transitionEnd)
        transitionEnd = transformValues(transitionEnd);
      if (target)
        target = transformValues(target);
      if (origin)
        origin = transformValues(origin);
    }
    if (isMounted) {
      checkTargetForNewValues(element, target, origin);
      var parsed = parseDomVariant(element, target, origin, transitionEnd);
      transitionEnd = parsed.transitionEnd;
      target = parsed.target;
    }
    return __assign({
      transition,
      transitionEnd
    }, target);
  },
  scrapeMotionValuesFromProps,
  build: function(element, renderState, latestValues, projection, layoutState, options, props) {
    if (element.isVisible !== void 0) {
      renderState.style.visibility = element.isVisible ? "visible" : "hidden";
    }
    var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
    buildHTMLStyles(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? buildLayoutProjectionTransform : void 0, isProjectionTranform ? buildLayoutProjectionTransformOrigin : void 0);
  },
  render: renderHTML
};
var htmlVisualElement = visualElement(htmlConfig);

// ../../node_modules/framer-motion/dist/es/render/svg/visual-element.js
var svgVisualElement = visualElement(__assign(__assign({}, htmlConfig), {
  getBaseTarget: function(props, key) {
    return props[key];
  },
  readValueFromInstance: function(domElement, key) {
    var _a;
    if (isTransformProp(key)) {
      return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
    }
    key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
    return domElement.getAttribute(key);
  },
  scrapeMotionValuesFromProps: scrapeMotionValuesFromProps2,
  build: function(_element, renderState, latestValues, projection, layoutState, options, props) {
    var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
    buildSVGAttrs(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? buildLayoutProjectionTransform : void 0, isProjectionTranform ? buildLayoutProjectionTransformOrigin : void 0);
  },
  render: renderSVG
}));

// ../../node_modules/framer-motion/dist/es/render/dom/create-visual-element.js
var createDomVisualElement = function(Component2, options) {
  return isSVGComponent(Component2) ? svgVisualElement(options, { enableHardwareAcceleration: false }) : htmlVisualElement(options, { enableHardwareAcceleration: true });
};

// ../../node_modules/framer-motion/dist/es/render/dom/motion.js
var featureBundle = __assign(__assign(__assign(__assign({}, animations), gestureAnimations), drag), layoutAnimations);
var motion = /* @__PURE__ */ createMotionProxy(function(Component2, config) {
  return createDomMotionConfig(Component2, config, featureBundle, createDomVisualElement);
});

// ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.js
var React12 = __toESM(require("react"));
var import_react37 = require("react");

// ../../node_modules/framer-motion/dist/es/utils/use-force-update.js
var import_react35 = require("react");
function useForceUpdate() {
  var unloadingRef = (0, import_react35.useRef)(false);
  var _a = __read((0, import_react35.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
  useUnmountEffect(function() {
    return unloadingRef.current = true;
  });
  return (0, import_react35.useCallback)(function() {
    !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
  }, [forcedRenderCount]);
}

// ../../node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.js
var React11 = __toESM(require("react"));
var import_react36 = require("react");
var presenceId = 0;
function getPresenceId() {
  var id = presenceId;
  presenceId++;
  return id;
}
var PresenceChild = function(_a) {
  var children = _a.children, initial = _a.initial, isPresent2 = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
  var presenceChildren = useConstant(newChildrenMap);
  var id = useConstant(getPresenceId);
  var context = (0, import_react36.useMemo)(function() {
    return {
      id,
      initial,
      isPresent: isPresent2,
      custom,
      onExitComplete: function(childId) {
        presenceChildren.set(childId, true);
        var allComplete = true;
        presenceChildren.forEach(function(isComplete) {
          if (!isComplete)
            allComplete = false;
        });
        allComplete && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
      },
      register: function(childId) {
        presenceChildren.set(childId, false);
        return function() {
          return presenceChildren.delete(childId);
        };
      }
    };
  }, presenceAffectsLayout ? void 0 : [isPresent2]);
  (0, import_react36.useMemo)(function() {
    presenceChildren.forEach(function(_, key) {
      return presenceChildren.set(key, false);
    });
  }, [isPresent2]);
  React11.useEffect(function() {
    !isPresent2 && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
  }, [isPresent2]);
  return React11.createElement(PresenceContext.Provider, { value: context }, children);
};
function newChildrenMap() {
  return /* @__PURE__ */ new Map();
}

// ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.js
function getChildKey(child) {
  return child.key || "";
}
function updateChildLookup(children, allChildren) {
  var seenChildren = true ? /* @__PURE__ */ new Set() : null;
  children.forEach(function(child) {
    var key = getChildKey(child);
    if (seenChildren) {
      if (seenChildren.has(key)) {
        console.warn('Children of AnimatePresence require unique keys. "' + key + '" is a duplicate.');
      }
      seenChildren.add(key);
    }
    allChildren.set(key, child);
  });
}
function onlyElements(children) {
  var filtered = [];
  import_react37.Children.forEach(children, function(child) {
    if ((0, import_react37.isValidElement)(child))
      filtered.push(child);
  });
  return filtered;
}
var AnimatePresence = function(_a) {
  var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
  var forceRender = useForceUpdate();
  var layoutContext = (0, import_react37.useContext)(SharedLayoutContext);
  if (isSharedLayout(layoutContext)) {
    forceRender = layoutContext.forceUpdate;
  }
  var isInitialRender = (0, import_react37.useRef)(true);
  var filteredChildren = onlyElements(children);
  var presentChildren = (0, import_react37.useRef)(filteredChildren);
  var allChildren = (0, import_react37.useRef)(/* @__PURE__ */ new Map()).current;
  var exiting = (0, import_react37.useRef)(/* @__PURE__ */ new Set()).current;
  updateChildLookup(filteredChildren, allChildren);
  if (isInitialRender.current) {
    isInitialRender.current = false;
    return React12.createElement(React12.Fragment, null, filteredChildren.map(function(child) {
      return React12.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? void 0 : false, presenceAffectsLayout }, child);
    }));
  }
  var childrenToRender = __spreadArray([], __read(filteredChildren));
  var presentKeys = presentChildren.current.map(getChildKey);
  var targetKeys = filteredChildren.map(getChildKey);
  var numPresent = presentKeys.length;
  for (var i2 = 0; i2 < numPresent; i2++) {
    var key = presentKeys[i2];
    if (targetKeys.indexOf(key) === -1) {
      exiting.add(key);
    } else {
      exiting.delete(key);
    }
  }
  if (exitBeforeEnter && exiting.size) {
    childrenToRender = [];
  }
  exiting.forEach(function(key2) {
    if (targetKeys.indexOf(key2) !== -1)
      return;
    var child = allChildren.get(key2);
    if (!child)
      return;
    var insertionIndex = presentKeys.indexOf(key2);
    var onExit = function() {
      allChildren.delete(key2);
      exiting.delete(key2);
      var removeIndex = presentChildren.current.findIndex(function(presentChild) {
        return presentChild.key === key2;
      });
      presentChildren.current.splice(removeIndex, 1);
      if (!exiting.size) {
        presentChildren.current = filteredChildren;
        forceRender();
        onExitComplete && onExitComplete();
      }
    };
    childrenToRender.splice(insertionIndex, 0, React12.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom, presenceAffectsLayout }, child));
  });
  childrenToRender = childrenToRender.map(function(child) {
    var key2 = child.key;
    return exiting.has(key2) ? child : React12.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout }, child);
  });
  presentChildren.current = childrenToRender;
  if (exitBeforeEnter && childrenToRender.length > 1) {
    console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
  }
  return React12.createElement(React12.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map(function(child) {
    return (0, import_react37.cloneElement)(child);
  }));
};

// src/libs/motion.ts
var springTransition = {
  type: "tween",
  duration: 0.08
};

// src/components/Popper/Popper.tsx
var Popper = ({
  children,
  entry,
  placement = "bottom-start",
  offset = 6,
  arrow = false,
  arrowOffset = 32,
  stretched = false,
  disableAutoClose = false,
  onChangeVisible
}) => {
  const [visible, setVisible] = (0, import_react38.useState)(false);
  (0, import_react38.useEffect)(() => {
    if (!onChangeVisible)
      return;
    onChangeVisible(visible);
  }, [onChangeVisible, visible]);
  const onClose = (0, import_react38.useCallback)(() => {
    setVisible(false);
  }, [setVisible]);
  const onTriggerClick = (0, import_react38.useCallback)(() => {
    setVisible((v2) => !v2);
  }, [setVisible]);
  const onLayerClick = (0, import_react38.useCallback)(() => {
    if (disableAutoClose)
      return;
    onClose();
  }, [disableAutoClose, onClose]);
  const { arrowProps, triggerProps, layerProps, renderLayer, triggerBounds, layerSide } = useLayer({
    isOpen: visible,
    auto: true,
    placement,
    possiblePlacements: [
      "bottom-start",
      "bottom-center",
      "bottom-end",
      "top-start",
      "top-center",
      "top-end"
    ],
    triggerOffset: offset,
    onOutsideClick: onClose
  });
  const layerMinWidth = (0, import_react38.useMemo)(() => stretched ? triggerBounds == null ? void 0 : triggerBounds.width : void 0, [stretched, triggerBounds == null ? void 0 : triggerBounds.width]);
  const layerDirectionFactor = (0, import_react38.useMemo)(() => layerSide === "bottom" ? -1 : 1, [layerSide]);
  return /* @__PURE__ */ import_react38.default.createElement(import_react38.default.Fragment, null, children({ ...triggerProps, hovered: visible, onClick: onTriggerClick }), renderLayer(/* @__PURE__ */ import_react38.default.createElement(AnimatePresence, null, visible && /* @__PURE__ */ import_react38.default.createElement(motion.div, {
    ref: layerProps.ref,
    style: { ...layerProps.style, minWidth: layerMinWidth },
    transition: springTransition,
    initial: { opacity: 0, y: 4 * layerDirectionFactor },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 4 * layerDirectionFactor },
    onClick: onLayerClick
  }, arrow && /* @__PURE__ */ import_react38.default.createElement(Arrow, {
    ...arrowProps,
    style: layerDirectionFactor > 0 ? { ...arrowProps.style, marginTop: -1, left: arrowOffset } : { ...arrowProps.style, marginBottom: -1, left: arrowOffset },
    size: 8,
    borderWidth: 1,
    borderColor: "#c5d0db"
  }), typeof entry === "function" ? entry({ onClose }) : entry))));
};

// src/components/ButtonMore/ButtonMore.tsx
var ButtonMore = (0, import_react39.forwardRef)(function forwardedButtonMore({ children, entry, palette = "action", ...buttonProps }, ref) {
  const paletteObj = palettes[palette];
  return /* @__PURE__ */ import_react39.default.createElement(StyledButtonMore, null, /* @__PURE__ */ import_react39.default.createElement(Button, {
    ...buttonProps,
    ref,
    palette
  }, children, /* @__PURE__ */ import_react39.default.createElement(Expander, null)), !buttonProps.fetching && /* @__PURE__ */ import_react39.default.createElement(Popper, {
    entry,
    placement: "bottom-center"
  }, (referenceProps) => /* @__PURE__ */ import_react39.default.createElement(Trigger, {
    ...referenceProps,
    disabled: buttonProps.disabled,
    palette: paletteObj,
    type: "button"
  }, /* @__PURE__ */ import_react39.default.createElement(import_ui_icons2.ChevronDownMini, {
    size: 24
  }))));
});

// src/components/ButtonSquare/ButtonSquare.tsx
var import_react40 = __toESM(require("react"));

// src/components/ButtonSquare/styled.tsx
var import_styled_components11 = __toESM(require("styled-components"));
var paletteMap = makeSafetyMap([
  ["action", palettes.action],
  ["brand", palettes.brand],
  ["danger", palettes.danger],
  ["muted", palettes.muted],
  ["warning", palettes.warning]
]);
var StyledButtonSquare = import_styled_components11.default.button`
  position: relative;
  background-color: transparent;
  border: 1px solid ${(p2) => paletteMap.get(p2.$palette).overlay};
  color: ${(p2) => paletteMap.get(p2.$palette).regular};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  height: 44px;
  width: 44px;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color ease-in-out 80ms, color ease-in-out 80ms, box-shadow ease-in-out 80ms,
    transform ease-in-out 80ms;

  ${(p2) => p2.fetching && import_styled_components11.css`
      pointer-events: none;

      ${LabelWrapper} {
        filter: blur(12px);
        opacity: 0.4;
      }
    `}

  &[data-hovered='true'],
  &:hover {
    background-color: ${(p2) => paletteMap.get(p2.$palette).transparent};
  }

  &:active {
    background-color: ${(p2) => paletteMap.get(p2.$palette).regular};
    border-color: ${(p2) => p2.$palette};
    color: ${(p2) => p2.theme.colors.white};
    transform: scale(0.98);
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px ${(p2) => p2.$palette};
  }

  &[disabled] {
    pointer-events: none;
    background-color: ${(p2) => p2.theme.colors.disabled};
    border-color: ${(p2) => p2.theme.colors.disabled};
    color: ${(p2) => p2.theme.colors.white};
  }
`;

// src/components/ButtonSquare/ButtonSquare.tsx
var ButtonSquare = (0, import_react40.forwardRef)(function forwardButtonSquare({
  children,
  palette = "action",
  fetching = false,
  hovered = false,
  disabled = false,
  ...rest
}, ref) {
  return /* @__PURE__ */ import_react40.default.createElement(StyledButtonSquare, {
    ref,
    $palette: palette,
    fetching,
    disabled,
    "data-hovered": hovered,
    ...rest
  }, fetching && /* @__PURE__ */ import_react40.default.createElement(FetchingWrapper, null, /* @__PURE__ */ import_react40.default.createElement(Spinner, {
    color: "inherit"
  })), /* @__PURE__ */ import_react40.default.createElement(LabelWrapper, null, children));
});

// src/components/CardBanner/CardBanner.tsx
var import_react41 = __toESM(require("react"));
var import_styled_components12 = __toESM(require("styled-components"));
var StyledCardBanner = import_styled_components12.default.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 24px 32px;
  background-color: #fff;
  border-radius: 8px;
`;
var RelativeBody = import_styled_components12.default.div`
  position: relative;
`;
var StyledBadge = import_styled_components12.default.div`
  ${(p2) => p2.theme.typography.graphikFontFamily};
  ${(p2) => p2.theme.typography.label};

  position: absolute;
  top: -8px;
  left: -32px;
  display: flex;
  height: 26px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  background-color: rgb(0, 115, 247);
  color: white;
`;
var StyledBanner = import_styled_components12.default.img`
  width: calc(100% + 64px);
  height: 130px;
  padding-bottom: 8px;
  margin: -24px -32px 0;
  border-radius: 8px 8px 0 0;
  object-fit: cover;
`;
var CardBanner = (0, import_react41.forwardRef)(function forwardedButton2({ src, badge, children, footer, ...rest }, ref) {
  return /* @__PURE__ */ import_react41.default.createElement(StyledCardBanner, {
    ref,
    ...rest
  }, /* @__PURE__ */ import_react41.default.createElement(RelativeBody, null, src && /* @__PURE__ */ import_react41.default.createElement(StyledBanner, {
    src,
    alt: "banner"
  }), src && badge && /* @__PURE__ */ import_react41.default.createElement(StyledBadge, null, badge), children), !!footer && footer);
});

// src/components/Checkbox/Checkbox.tsx
var import_react43 = __toESM(require("react"));
var import_ui_core = require("@xsolla/ui-core");
var import_ui_icons3 = require("@xsolla/ui-icons");
var import_styled_components14 = require("styled-components");

// src/hooks/useCheckboxBlur.ts
var import_react42 = require("react");
var useCheckboxBlur = (checked, onBlur) => {
  (0, import_react42.useEffect)(() => {
    if (!onBlur)
      return;
    onBlur();
  }, [checked]);
};

// src/components/Checkbox/styled.tsx
var import_styled_components13 = __toESM(require("styled-components"));
var StyledCheckbox = import_styled_components13.default.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  user-select: none;
  min-width: 16px;
  min-height: 16px;
`;
var Status2 = import_styled_components13.default.div`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  color: ${(p2) => p2.theme.colors.white};
  width: 16px;
  height: 16px;
`;
var Entry2 = import_styled_components13.default.div`
  ${(p2) => p2.theme.typography.description};
  padding-left: 24px;
  line-height: 20px;
  cursor: pointer;
`;
var Input = import_styled_components13.default.input`
  position: absolute;
  top: 2px;
  left: 0;
  width: 16px;
  height: 16px;
  border: 1px solid ${(p2) => p2.theme.colors.muted};
  margin: 0;
  appearance: none;
  cursor: pointer;
  border-radius: 3px;
  transition: border-color ease-in-out 80ms, background-color ease-in-out 80ms,
    transform ease-in-out 80ms;

  &:not(&[disabled]):not(&[data-error='true']):hover {
    border-color: ${(p2) => p2.$palette.regular};
  }

  &:not(&[disabled]):not(&[data-error='true']):focus-visible {
    border-color: ${(p2) => p2.$palette.regular};
    box-shadow: 0 0 0 3px ${(p2) => p2.$palette.overlay};
  }

  &:not(&[disabled]):active {
    transform: scale(0.95);
  }

  &:checked {
    border-color: ${(p2) => p2.$palette.regular};
    background-color: ${(p2) => p2.$palette.regular};
    & + ${Status2} {
      opacity: 1;
    }
  }

  &[disabled] {
    background-color: ${(p2) => p2.theme.colors.stroke};
    border-color: ${(p2) => p2.theme.colors.stroke};

    & ~ ${Entry2} {
      color: ${(p2) => p2.theme.colors.disabled};
      pointer-events: none;
    }
  }

  &[data-error='true'] {
    background-color: ${(p2) => p2.theme.palettes.danger.transparent};
    border-color: ${(p2) => p2.theme.colors.danger};
    color: ${(p2) => p2.theme.colors.danger};
  }

  &[data-error='true']:focus-visible {
    border-color: ${(p2) => p2.theme.colors.danger};
    box-shadow: 0 0 0 3px ${(p2) => p2.theme.palettes.danger.overlay};
  }

  &[data-error='true']:checked ~ ${Status2} {
    color: ${(p2) => p2.theme.colors.danger};
  }
`;

// src/components/Checkbox/Checkbox.tsx
var Checkbox = (0, import_react43.forwardRef)(function forwardedCheckbox({ children, tooltip, errorMessage, ...inputProps }, ref) {
  const theme = (0, import_styled_components14.useTheme)();
  useCheckboxBlur(inputProps.checked, inputProps.onBlur);
  if (!children && tooltip) {
    throw Error("The `tooltip` should be transmitted together with `children`.");
  }
  return /* @__PURE__ */ import_react43.default.createElement(import_ui_core.FieldWrapper, {
    inline: true
  }, /* @__PURE__ */ import_react43.default.createElement(import_ui_core.FieldRow, {
    gap: "sm"
  }, /* @__PURE__ */ import_react43.default.createElement(StyledCheckbox, null, /* @__PURE__ */ import_react43.default.createElement(Input, {
    ...inputProps,
    ref,
    type: "checkbox",
    "data-error": !!errorMessage,
    $palette: theme.palettes.brand
  }), /* @__PURE__ */ import_react43.default.createElement(Status2, null, /* @__PURE__ */ import_react43.default.createElement(import_ui_icons3.Checkmark, {
    size: 16
  })), children && /* @__PURE__ */ import_react43.default.createElement(Entry2, null, children)), tooltip && /* @__PURE__ */ import_react43.default.createElement(import_ui_core.Tooltip, {
    content: tooltip
  })), !!errorMessage && /* @__PURE__ */ import_react43.default.createElement(import_ui_core.ValidationMessage, null, errorMessage));
});

// src/components/Collapse/Collapse.tsx
var import_react44 = __toESM(require("react"));
var import_ui_core2 = require("@xsolla/ui-core");
var import_ui_icons4 = require("@xsolla/ui-icons");
var import_styled_components15 = __toESM(require("styled-components"));
var defaultLabelFn = (expanded) => expanded ? "Collapse" : "Expand";
var StyledCollapse = import_styled_components15.default.div``;
var Entry3 = (0, import_styled_components15.default)(motion.div)`
  margin-bottom: 8px;
`;
var Collapse = (0, import_react44.forwardRef)(function forwardedCollapse({ children, labelFn = defaultLabelFn, initial = false }, ref) {
  const [expanded, setExpanded] = (0, import_react44.useState)(initial);
  const onToggleExpanded = (0, import_react44.useCallback)(() => {
    setExpanded((e2) => !e2);
  }, [setExpanded]);
  return /* @__PURE__ */ import_react44.default.createElement(StyledCollapse, {
    ref
  }, /* @__PURE__ */ import_react44.default.createElement(AnimatePresence, {
    initial: false
  }, expanded && /* @__PURE__ */ import_react44.default.createElement(Entry3, {
    initial: "close",
    animate: "open",
    exit: "close",
    transition: import_ui_core2.springTransition,
    variants: {
      close: { opacity: 0, height: 0 },
      open: { opacity: 1, height: "auto" }
    }
  }, children)), /* @__PURE__ */ import_react44.default.createElement(import_ui_core2.Button, {
    palette: "brand",
    look: "link",
    onClick: onToggleExpanded
  }, /* @__PURE__ */ import_react44.default.createElement("span", null, labelFn(expanded)), expanded ? /* @__PURE__ */ import_react44.default.createElement(import_ui_icons4.ChevronUpMini, {
    size: 24
  }) : /* @__PURE__ */ import_react44.default.createElement(import_ui_icons4.ChevronDownMini, {
    size: 24
  })));
});

// src/components/FieldGroup/FieldGroup.tsx
var import_react45 = __toESM(require("react"));
var import_ui_core3 = require("@xsolla/ui-core");

// src/components/FieldGroup/styled.tsx
var import_styled_components16 = __toESM(require("styled-components"));
var StyledFieldGroup = import_styled_components16.default.div`
  width: 100%;

  ${(p2) => p2.size === "xlg" && import_styled_components16.css`
      margin-bottom: 40px;
    `}

  ${(p2) => p2.size === "lg" && import_styled_components16.css`
      margin-bottom: 32px;
    `}

  ${(p2) => p2.size === "md" && import_styled_components16.css`
      margin-bottom: 24px;
    `}

  ${(p2) => p2.size === "sm" && import_styled_components16.css`
      margin-bottom: 16px;
    `}

  ${(p2) => p2.size === "xs" && import_styled_components16.css`
      margin-bottom: 8px;
    `}

  &:last-child {
    margin-bottom: 0;
  }
`;
var Label = import_styled_components16.default.div`
  ${(p2) => p2.theme.typography.descriptionCompact};
  display: flex;
  align-items: center;
  min-height: 24px;
  margin-bottom: 4px;
  color: ${(p2) => p2.theme.colors.muted};
`;
var Footer = import_styled_components16.default.div`
  ${(p2) => p2.theme.typography.caption};
  margin-top: 4px;
  color: ${(p2) => p2.theme.colors.muted};
`;

// src/components/FieldGroup/FieldGroup.tsx
var FieldGroup = (0, import_react45.forwardRef)(function forwardedFieldGroup({ children, label, tooltip, footer, tooltipContainer, size = "md" }, ref) {
  return /* @__PURE__ */ import_react45.default.createElement(StyledFieldGroup, {
    ref,
    size
  }, label && /* @__PURE__ */ import_react45.default.createElement(Label, null, /* @__PURE__ */ import_react45.default.createElement(import_ui_core3.FieldRow, {
    gap: "sm"
  }, /* @__PURE__ */ import_react45.default.createElement("span", null, label), tooltip && /* @__PURE__ */ import_react45.default.createElement(import_ui_core3.Tooltip, {
    content: tooltip,
    container: tooltipContainer
  }))), /* @__PURE__ */ import_react45.default.createElement("div", null, children), footer && /* @__PURE__ */ import_react45.default.createElement(Footer, null, footer));
});

// src/components/FieldRow/FieldRow.tsx
var import_react46 = __toESM(require("react"));

// src/components/FieldRow/styled.tsx
var import_styled_components17 = __toESM(require("styled-components"));
var StyledFieldRow = import_styled_components17.default.div`
  align-items: ${(p2) => p2.align};
  justify-content: ${(p2) => p2.justify};

  & > * {
    &:last-child {
      margin-right: 0 !important;
    }
  }

  ${(p2) => p2.gap === "lg" && import_styled_components17.css`
      > * {
        margin-right: 24px;
      }
    `}

  ${(p2) => p2.gap === "md" && import_styled_components17.css`
      > * {
        margin-right: 16px;
      }
    `}
  
  ${(p2) => p2.gap === "sm" && import_styled_components17.css`
      > * {
        margin-right: 8px;
      }
    `}
  
  ${(p2) => p2.stretched ? import_styled_components17.css`
          display: flex;
          width: 100%;
        ` : import_styled_components17.css`
          display: inline-flex;
        `}
`;

// src/components/FieldRow/FieldRow.tsx
var FieldRow3 = (0, import_react46.forwardRef)(function forwardedFieldRow({
  children,
  gap = "md",
  align = "center",
  justify = "flex-start",
  stretched = false
}, ref) {
  return /* @__PURE__ */ import_react46.default.createElement(StyledFieldRow, {
    ref,
    gap,
    align,
    justify,
    stretched
  }, import_react46.Children.map(children, (child) => !!child && child));
});

// src/components/FloatingArea/FloatingArea.tsx
var import_react47 = __toESM(require("react"));
var import_styled_components18 = __toESM(require("styled-components"));
var StyledFloatingArea = import_styled_components18.default.div`
  background-color: ${(p2) => p2.theme.colors.white};
  border-radius: 6px;
  border: 1px solid ${(p2) => p2.theme.colors.stroke};
  max-width: 468px;
  min-width: 140px;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0 3px 12px 0 rgb(0 36 77 / 20%);
`;
var FloatingArea = (0, import_react47.forwardRef)(function forwardedFloatingArea({ children, ...rest }, ref) {
  return /* @__PURE__ */ import_react47.default.createElement(StyledFloatingArea, {
    ...rest,
    ref
  }, children);
});

// src/components/FormFooter/FormFooter.tsx
var import_react48 = __toESM(require("react"));
var import_styled_components19 = __toESM(require("styled-components"));
var StyledFormFooter = import_styled_components19.default.div`
  background-color: ${(p2) => p2.theme.colors.white};
  border-top: 1px solid ${(p2) => p2.theme.colors.stroke};
  padding: 24px 32px;
  margin: 24px -32px -24px -32px;
  border-radius: 0 0 ${(p2) => p2.theme.misc.borderRadiusMd} ${(p2) => p2.theme.misc.borderRadiusMd};

  ${(p2) => p2.$sticky && import_styled_components19.css`
      position: sticky;
      left: 0;
      bottom: 0;
      z-index: 10;
    `}
`;
var FormFooter = (0, import_react48.forwardRef)(function forwardedFormFooter({ children, sticky = false }, ref) {
  return /* @__PURE__ */ import_react48.default.createElement(StyledFormFooter, {
    ref,
    $sticky: sticky
  }, children);
});

// src/components/Grid/Grid.tsx
var import_react49 = __toESM(require("react"));
var import_styled_components20 = __toESM(require("styled-components"));
var StyledGrid = import_styled_components20.default.div`
  display: grid;
  grid-auto-rows: auto;
  width: 100%;
`;
var Grid = (0, import_react49.forwardRef)(function forwardedGrid({ children, cols, gap = 16, allowOverflow = false }, ref) {
  const gridTemplateColumns = (0, import_react49.useMemo)(() => Array(cols).fill("1fr").join(" "), [cols]);
  return /* @__PURE__ */ import_react49.default.createElement(StyledGrid, {
    ref,
    style: { gridTemplateColumns, gridGap: gap }
  }, import_react49.Children.map(children, (child) => child ? /* @__PURE__ */ import_react49.default.createElement("div", {
    style: { overflow: allowOverflow ? "" : "hidden" }
  }, child) : null));
});

// src/components/HintCircle/HintCircle.tsx
var import_react51 = __toESM(require("react"));

// src/components/HintCircle/QuestionIcon.tsx
var import_react50 = __toESM(require("react"));
var QuestionIcon = () => /* @__PURE__ */ import_react50.default.createElement("svg", {
  width: "6",
  height: "8",
  viewBox: "0 0 7 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ import_react50.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.8322 5.8881V6.9231H2.2937V5.3566L3.5944 4.4336C3.7743 4.296 3.9142 4.1985 4.014 4.1289C4.0461 4.1065 4.0741 4.087 4.0979 4.0699C4.1958 4 4.3077 3.8881 4.4336 3.7483C4.6993 3.4685 4.7552 3.2028 4.7552 2.76923C4.7552 2.02797 4.2378 1.3986 3.2448 1.3986C2.1399 1.3986 1.4685 2.0979 1.4685 3.2587H0C0 2.23776 0.30769 1.44056 0.90909 0.86713C1.5105 0.29371 2.2937 0 3.2448 0C4.2098 0 4.965 0.26573 5.4965 0.7972C6.028 1.32867 6.2937 1.97203 6.2937 2.74126C6.2937 3.3427 6.0699 3.8881 5.8462 4.2378C5.7483 4.4056 5.5804 4.5874 5.3566 4.7832C5.1469 4.979 4.979 5.1189 4.8531 5.2028L4.3217 5.5524L3.8322 5.8881ZM3.8741 8.2797V10H2.2517V8.2797H3.8741Z",
  fill: "currentColor"
}));

// src/components/HintCircle/styled.ts
var import_styled_components21 = __toESM(require("styled-components"));
var StyledHintCircle = import_styled_components21.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 16px;
  height: 16px;
  padding: 0;
  flex-shrink: 0;
  background-color: ${(p2) => p2.theme.colors.white};
  border: 1px solid ${(p2) => p2.theme.colors.stroke};
  color: ${(p2) => p2.theme.colors.stroke};
  cursor: pointer;
  user-select: none;
  border-radius: 50%;
  box-sizing: border-box;
  transition: background-color ease-in-out 80ms, border-color ease-in-out 80ms,
    color ease-in-out 80ms, box-shadow ease-in-out 80ms;

  ${(p2) => p2.$hovered && import_styled_components21.css`
      background-color: ${(p3) => p3.theme.colors.brand};
      border-color: ${(p3) => p3.theme.colors.brand};
      color: ${(p3) => p3.theme.colors.white};
    `}

  &:hover {
    background-color: ${(p2) => p2.theme.colors.brand};
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.white};
  }
`;

// src/components/HintCircle/HintCircle.tsx
var HintCircle = (0, import_react51.forwardRef)(function forwardedHintCircle({ hovered = false, ...rest }, ref) {
  return /* @__PURE__ */ import_react51.default.createElement(StyledHintCircle, {
    ...rest,
    ref,
    $hovered: hovered
  }, /* @__PURE__ */ import_react51.default.createElement(QuestionIcon, null));
});

// src/components/Input/Input.tsx
var import_react54 = __toESM(require("react"));

// src/components/Input/styled.tsx
var import_styled_components23 = __toESM(require("styled-components"));

// src/components/InputTemplate/styled.tsx
var import_styled_components22 = __toESM(require("styled-components"));
var InputRelativeWrapper = import_styled_components22.default.div`
  position: relative;
`;
var Extra = import_styled_components22.default.div`
  position: absolute;
  top: 0;
  width: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p2) => p2.theme.colors.muted};
  pointer-events: none;

  ${(p2) => p2.extraAlign === "left" && import_styled_components22.css`
      left: 0;
    `}

  ${(p2) => p2.extraAlign === "right" && import_styled_components22.css`
      right: 0;
    `}

  ${(p2) => p2.extraAllowClick && import_styled_components22.css`
      pointer-events: auto;
    `}
`;

// src/components/Input/styled.tsx
var StyledInput = import_styled_components23.default.input`
  ${(p2) => p2.theme.typography.graphikFontFamily};
  ${(p2) => p2.theme.typography.body};

  background-color: ${(p2) => p2.theme.colors.white};
  border: 1px solid ${(p2) => p2.theme.colors.stroke};
  color: ${(p2) => p2.theme.colors.text};
  display: flex;
  width: 100%;
  padding: 10px 12px;
  box-sizing: border-box;
  border-radius: ${(p2) => p2.theme.misc.borderRadiusMd};
  box-shadow: inset 0 0 0 1px transparent;
  transition: background-color ease-in-out 80ms, border-color ease-in-out 80ms,
    color ease-in-out 80ms, box-shadow ease-in-out 80ms;

  ${(p2) => p2.uiSize === "sm" && import_styled_components23.css`
      height: 36px;
    `}

  ${(p2) => p2.uiSize === "md" && import_styled_components23.css`
      height: 44px;
    `}

  ${(p2) => p2.extraAlign === "left" && import_styled_components23.css`
      padding-left: 38px;
    `}

  ${(p2) => p2.extraAlign === "right" && import_styled_components23.css`
      padding-right: 38px;
    `}
  
  ${(p2) => p2.hasError && import_styled_components23.css`
      background-color: ${p2.theme.palettes.danger.transparent};
      border-color: ${(p3) => p3.theme.colors.danger};
      color: ${(p3) => p3.theme.colors.danger};

      & + ${Extra} {
        color: ${(p3) => p3.theme.colors.danger};
      }

      &:not(:hover, :focus)::placeholder {
        color: ${p2.theme.palettes.danger.overlay};
      }
    `}

  &::placeholder {
    color: ${(p2) => p2.theme.colors.muted};
  }

  &:hover {
    background-color: ${(p2) => p2.theme.colors.white};
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.text};
  }

  &:focus-visible {
    border-color: ${(p2) => p2.theme.colors.brand};
  }

  &:not([readonly]):focus {
    background-color: ${(p2) => p2.theme.colors.white};
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.text};
    box-shadow: inset 0 0 0 1px ${(p2) => p2.theme.colors.brand};
  }

  &:not([readonly]):hover + ${Extra}, &:not([readonly]):focus + ${Extra} {
    color: ${(p2) => p2.theme.colors.brand};
  }

  &[disabled] {
    pointer-events: none;
    background-color: ${(p2) => p2.theme.colors.overlay};
    border-color: ${(p2) => p2.theme.colors.disabled};
    color: ${(p2) => p2.theme.colors.disabled};
  }

  &[readonly] {
    background-color: ${(p2) => p2.theme.colors.overlay};
    border-color: ${(p2) => p2.theme.colors.stroke};
  }
`;

// src/components/InputTemplate/InputTemplate.tsx
var import_react53 = __toESM(require("react"));
var import_ui_icons5 = require("@xsolla/ui-icons");

// src/components/FieldWrapper.tsx
var import_react52 = __toESM(require("react"));
var import_styled_components24 = __toESM(require("styled-components"));
var StyledFieldWrapper = import_styled_components24.default.div`
  width: 100%;
  max-width: 468px;
  min-width: 140px;

  ${(p2) => p2.$inline && import_styled_components24.css`
      width: auto;
      min-width: auto;
    `}
`;
var FieldWrapper2 = ({ children, inline = false }) => /* @__PURE__ */ import_react52.default.createElement(StyledFieldWrapper, {
  $inline: inline
}, children);

// src/components/InputTemplate/InputTemplate.tsx
var import_ui_core4 = require("@xsolla/ui-core");
var InputTemplate = ({
  children,
  extra,
  extraAlign,
  extraAllowClick,
  errorMessage
}) => {
  const isXsollaIcon = (0, import_ui_icons5.useIsXsollaIcon)(extra);
  return /* @__PURE__ */ import_react53.default.createElement(FieldWrapper2, null, /* @__PURE__ */ import_react53.default.createElement(InputRelativeWrapper, null, children, extra && /* @__PURE__ */ import_react53.default.createElement(Extra, {
    extraAlign,
    extraAllowClick
  }, isXsollaIcon ? (0, import_react53.createElement)(extra, { size: 24 }) : (0, import_react53.createElement)(extra))), errorMessage && /* @__PURE__ */ import_react53.default.createElement(import_ui_core4.ValidationMessage, null, errorMessage));
};

// src/components/Input/Input.tsx
var Input2 = (0, import_react54.forwardRef)(function forwardedInput({
  uiSize = "md",
  extra,
  extraAlign = "left",
  extraAllowClick = false,
  errorMessage,
  ...rest
}, ref) {
  return /* @__PURE__ */ import_react54.default.createElement(InputTemplate, {
    extra,
    extraAlign,
    extraAllowClick,
    errorMessage
  }, /* @__PURE__ */ import_react54.default.createElement(StyledInput, {
    ...rest,
    ref,
    uiSize,
    extraAlign: extra ? extraAlign : void 0,
    hasError: !!errorMessage
  }));
});

// src/components/InputCopy/InputCopy.tsx
var import_react58 = __toESM(require("react"));

// ../../node_modules/react-use/esm/useEnsuredForwardedRef.js
var import_react55 = require("react");
function useEnsuredForwardedRef(forwardedRef) {
  var ensuredRef = (0, import_react55.useRef)(forwardedRef && forwardedRef.current);
  (0, import_react55.useEffect)(function() {
    if (!forwardedRef) {
      return;
    }
    forwardedRef.current = ensuredRef.current;
  }, [forwardedRef]);
  return ensuredRef;
}

// ../../node_modules/throttle-debounce/esm/index.js
function throttle(delay, noTrailing, callback, debounceMode) {
  var timeoutID;
  var cancelled = false;
  var lastExec = 0;
  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  }
  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  }
  if (typeof noTrailing !== "boolean") {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = void 0;
  }
  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }
    var self2 = this;
    var elapsed = Date.now() - lastExec;
    if (cancelled) {
      return;
    }
    function exec() {
      lastExec = Date.now();
      callback.apply(self2, arguments_);
    }
    function clear() {
      timeoutID = void 0;
    }
    if (debounceMode && !timeoutID) {
      exec();
    }
    clearExistingTimeout();
    if (debounceMode === void 0 && elapsed > delay) {
      exec();
    } else if (noTrailing !== true) {
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === void 0 ? delay - elapsed : delay);
    }
  }
  wrapper.cancel = cancel;
  return wrapper;
}
function debounce(delay, atBegin, callback) {
  return callback === void 0 ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}

// ../../node_modules/react-use/esm/usePrevious.js
var import_react56 = require("react");
function usePrevious(state) {
  var ref = (0, import_react56.useRef)();
  (0, import_react56.useEffect)(function() {
    ref.current = state;
  });
  return ref.current;
}

// src/components/ButtonCopy/ButtonCopy.tsx
var import_react57 = __toESM(require("react"));
var import_ui_core5 = require("@xsolla/ui-core");
var import_ui_icons6 = require("@xsolla/ui-icons");
var ButtonCopy = ({ ensuredForwardRef: ensuredForwardRef2, successfulLabel }) => {
  const [visibleTooltip, setVisibleTooltip] = (0, import_react57.useState)(false);
  (0, import_react57.useEffect)(() => {
    const copiedTimeout = setTimeout(() => {
      setVisibleTooltip(false);
    }, 2e3);
    return () => {
      clearTimeout(copiedTimeout);
    };
  }, [visibleTooltip, setVisibleTooltip]);
  const onToggleVisible = (0, import_react57.useCallback)(async () => {
    await navigator.clipboard.writeText(ensuredForwardRef2.current.value);
    setVisibleTooltip(true);
  }, [setVisibleTooltip]);
  return /* @__PURE__ */ import_react57.default.createElement(import_ui_core5.Tooltip, {
    content: successfulLabel,
    controlledVisible: visibleTooltip,
    uppercase: true,
    offset: 8
  }, /* @__PURE__ */ import_react57.default.createElement(import_ui_core5.Button, {
    palette: "brand",
    look: "icon",
    onClick: onToggleVisible
  }, /* @__PURE__ */ import_react57.default.createElement(import_ui_icons6.Copy, null)));
};

// src/components/InputCopy/InputCopy.tsx
var InputCopy = (0, import_react58.forwardRef)(function fwdInputCopy({ successfulLabel = "Copied", ...inputProps }, ref) {
  const ensuredForwardRef2 = useEnsuredForwardedRef(ref);
  return /* @__PURE__ */ import_react58.default.createElement(Input2, {
    ...inputProps,
    ref: ensuredForwardRef2,
    readOnly: true,
    extra: () => /* @__PURE__ */ import_react58.default.createElement(ButtonCopy, {
      ensuredForwardRef: ensuredForwardRef2,
      successfulLabel
    }),
    extraAlign: "right",
    extraAllowClick: true
  });
});

// src/components/InputPassword/InputPassword.tsx
var import_react59 = __toESM(require("react"));
var import_ui_icons7 = require("@xsolla/ui-icons");
var InputPassword = (0, import_react59.forwardRef)(function forwardedInputPassword({ initialVisible = false, type = "text", ...rest }, ref) {
  const [visiblePassword, setVisiblePassword] = (0, import_react59.useState)(initialVisible);
  const onToggleVisible = (0, import_react59.useCallback)(() => {
    setVisiblePassword((v2) => !v2);
  }, [setVisiblePassword]);
  return /* @__PURE__ */ import_react59.default.createElement(Input2, {
    ...rest,
    ref,
    type: visiblePassword ? type : "password",
    extra: () => /* @__PURE__ */ import_react59.default.createElement(Button, {
      type: "button",
      palette: "brand",
      look: "icon",
      hovered: visiblePassword,
      onClick: onToggleVisible
    }, visiblePassword ? /* @__PURE__ */ import_react59.default.createElement(import_ui_icons7.EyeClose, null) : /* @__PURE__ */ import_react59.default.createElement(import_ui_icons7.EyeOpen, null)),
    extraAlign: "right",
    extraAllowClick: true
  });
});

// src/components/List/List.tsx
var import_react62 = __toESM(require("react"));
var import_ui_core7 = require("@xsolla/ui-core");

// src/hooks/a11y/useA11yNavigation.ts
var import_react60 = require("react");
var reducer = (state, action) => {
  switch (action.type) {
    case 0 /* Set */:
      return {
        ...state,
        ...action.payload
      };
    case 1 /* Top */:
      return { ...state, cursor: 0, mouse: false };
    case 2 /* Bottom */:
      return { ...state, cursor: state.length - 1, mouse: false };
    case 3 /* Up */:
      return { ...state, cursor: Math.max(state.cursor - 1, 0), mouse: false };
    case 4 /* Down */:
      return { ...state, cursor: Math.min(state.cursor + 1, state.length - 1), mouse: false };
  }
};
var defaultOptions = {
  initialCursor: -1,
  onHighlighted: () => void 0,
  onChange: () => void 0
};
var useA11yNavigation = (items, options = {}) => {
  const { initialCursor, onHighlighted, onChange } = {
    ...defaultOptions,
    ...options
  };
  const [state, dispatch] = (0, import_react60.useReducer)(reducer, {
    cursor: initialCursor,
    length: items.length,
    mouse: false
  });
  const listenMouseMove = (0, import_react60.useCallback)((index) => {
    if (state.cursor === index)
      return;
    return dispatch({ type: 0 /* Set */, payload: { cursor: index, mouse: true } });
  }, [state.cursor, dispatch]);
  const listenKeyDown = (0, import_react60.useCallback)((e2) => {
    if (e2.key === "ArrowUp") {
      e2.preventDefault();
      return dispatch({ type: e2.shiftKey ? 1 /* Top */ : 3 /* Up */ });
    }
    if (e2.key === "ArrowDown") {
      e2.preventDefault();
      return dispatch({ type: e2.shiftKey ? 2 /* Bottom */ : 4 /* Down */ });
    }
    if (e2.key === "Home") {
      e2.preventDefault();
      return dispatch({ type: 1 /* Top */ });
    }
    if (e2.key === "End") {
      e2.preventDefault();
      return dispatch({ type: 2 /* Bottom */ });
    }
    if (e2.key === "Enter" || e2.code === "Space") {
      onChange(e2, state.cursor);
    }
  }, [dispatch, onChange]);
  const getItemTriggers = (0, import_react60.useCallback)((cursor) => ({ onMouseMove: () => listenMouseMove(cursor) }), [listenMouseMove]);
  (0, import_react60.useEffect)(() => {
    dispatch({
      type: 0 /* Set */,
      payload: { cursor: initialCursor, length: items.length, mouse: false }
    });
  }, [items.length]);
  (0, import_react60.useEffect)(() => {
    if (state.mouse)
      return;
    onHighlighted(state.cursor);
  }, [state.cursor, state.mouse]);
  (0, import_react60.useEffect)(() => {
    document.addEventListener("keydown", listenKeyDown, { capture: true });
    return () => {
      document.removeEventListener("keydown", listenKeyDown, { capture: true });
    };
  }, [listenKeyDown]);
  return { state, getItemTriggers };
};

// src/libs/getRandomString.ts
var getRandomString = () => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

// src/components/List/Search.tsx
var import_react61 = __toESM(require("react"));
var import_ui_core6 = require("@xsolla/ui-core");
var import_ui_icons8 = require("@xsolla/ui-icons");
var import_styled_components25 = __toESM(require("styled-components"));
var StyledSearch = import_styled_components25.default.div`
  padding: 8px 12px 8px 12px;
`;
var Empty = import_styled_components25.default.div`
  margin: 16px 0 0 0;
  color: ${(p2) => p2.theme.colors.muted};
`;
var Search = ({ empty = false, placeholder, emptyMessage, onSearch }) => {
  const [fetching, setFetching] = (0, import_react61.useState)(false);
  const debounceFunc = debounce(500, async (q) => {
    setFetching(true);
    await onSearch(q);
    setFetching(false);
  });
  const onChange = (0, import_react61.useCallback)(async (e2) => {
    setFetching(true);
    await debounceFunc(e2.currentTarget.value);
  }, []);
  const onClick = (0, import_react61.useCallback)((e2) => {
    e2.stopPropagation();
  }, []);
  return /* @__PURE__ */ import_react61.default.createElement(StyledSearch, null, /* @__PURE__ */ import_react61.default.createElement(import_ui_core6.Input, {
    tabIndex: 0,
    placeholder,
    uiSize: "sm",
    extra: fetching ? () => /* @__PURE__ */ import_react61.default.createElement(import_ui_core6.Spinner, null) : import_ui_icons8.Search,
    onChange,
    onClick
  }), empty && /* @__PURE__ */ import_react61.default.createElement(Empty, null, emptyMessage));
};

// src/components/List/styled.ts
var import_styled_components26 = __toESM(require("styled-components"));
var StyledList = import_styled_components26.default.div`
  padding: 4px 0;
  width: 100%;
  max-height: 280px;
  overflow-x: auto;
  user-select: none;
`;

// src/components/List/List.tsx
var defaultSearchFn = async (q, items) => items.filter((i2) => {
  var _a, _b;
  return ((_a = i2.children) == null ? void 0 : _a.toString().toLocaleLowerCase().includes(q.toLocaleLowerCase())) || ((_b = i2.caption) == null ? void 0 : _b.toString().toLocaleLowerCase().includes(q.toLocaleLowerCase()));
});
var List = ({ items, search, selected = -1, uniquePrefix }) => {
  const listRef = (0, import_react62.useRef)(null);
  const [filteredItems, setFilteredItems] = (0, import_react62.useState)(items);
  (0, import_react62.useEffect)(() => {
    setFilteredItems(items);
  }, [items]);
  const uniqueId = (0, import_react62.useMemo)(() => {
    return uniquePrefix || getRandomString();
  }, [uniquePrefix, filteredItems.length]);
  const indexes = (0, import_react62.useMemo)(() => {
    return Object.keys(filteredItems).map(Number);
  }, [filteredItems.length]);
  const { state, getItemTriggers } = useA11yNavigation(indexes, {
    initialCursor: selected,
    onHighlighted: (cursor) => {
      if (!listRef.current)
        return;
      const itemElement = listRef.current.children[cursor];
      listRef.current.scroll({
        top: (itemElement == null ? void 0 : itemElement.offsetTop) ? itemElement.offsetTop - 64 : 0,
        behavior: "auto"
      });
    },
    onChange: (e2, cursor) => {
      const item = filteredItems[cursor] || void 0;
      if ((item == null ? void 0 : item.disabled) || !(item == null ? void 0 : item.onClick))
        return;
      item.onClick(e2);
    }
  });
  const searchFn = (search == null ? void 0 : search.fn) || defaultSearchFn;
  const onSearch = async (q) => setFilteredItems(await searchFn(q, items));
  return /* @__PURE__ */ import_react62.default.createElement(import_ui_core7.FloatingArea, null, /* @__PURE__ */ import_react62.default.createElement(StyledList, {
    ref: listRef
  }, !!search && /* @__PURE__ */ import_react62.default.createElement(Search, {
    empty: filteredItems.length === 0,
    placeholder: search.placeholder,
    emptyMessage: search.emptyMessage,
    onSearch
  }), filteredItems.map((item, index) => /* @__PURE__ */ import_react62.default.createElement(import_ui_core7.ListItem, {
    ...item,
    ...getItemTriggers(index),
    key: `list-${uniqueId}-item-${index}`,
    highlighted: state.cursor === index
  }, item.children))));
};

// src/components/ListItem/ListItem.tsx
var import_react63 = __toESM(require("react"));
var import_styled_components28 = require("styled-components");
var import_ui_icons9 = require("@xsolla/ui-icons");

// src/components/ListItem/styled.ts
var import_styled_components27 = __toESM(require("styled-components"));
var Icon2 = import_styled_components27.default.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
  transition: opacity ease-in-out 80ms;

  ${(p2) => p2.$align === "left" && import_styled_components27.css`
      margin-right: 12px;
    `}

  ${(p2) => p2.$align === "right" && import_styled_components27.css`
      margin-left: auto;
      padding-left: 12px;
      order: 1;
    `}
`;
var Entry4 = import_styled_components27.default.div`
  padding-right: 4px;
`;
var Label2 = import_styled_components27.default.div`
  line-height: 24px;
`;
var Caption = import_styled_components27.default.div`
  ${(p2) => p2.theme.typography.caption};
  margin-bottom: 4px;
  opacity: 0.6;
`;
var StyledListItem = import_styled_components27.default.div`
  padding: 8px 12px 8px 12px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  box-sizing: border-box;
  cursor: pointer;
  color: ${(p2) => p2.theme.colors.text};
  transition: background-color ease-in-out 80ms, border-radius ease-in-out 80ms;
  user-select: none;

  ${(p2) => p2.$palette && import_styled_components27.css`
      color: ${p2.$palette.regular};
    `}

  ${(p2) => p2.$look === "leading" && import_styled_components27.css`
      border-bottom: 1px solid ${p2.$palette ? p2.$palette.transparent : "rgba(0, 0, 0, 0.05)"};
      margin-bottom: 4px;
      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
      }
    `}

  ${(p2) => p2.$look === "bordered" && import_styled_components27.css`
      border-bottom: 1px solid ${p2.$palette ? p2.$palette.overlay : p2.theme.colors.stroke};
      &:last-child {
        border-bottom: none;
      }
    `}
  
  ${(p2) => p2.$highlighted && import_styled_components27.css`
      background-color: ${p2.$palette ? p2.$palette.transparent : p2.theme.colors.overlay};
      ${Icon2} {
        opacity: 1;
      }
    `}

  ${(p2) => p2.$disabled && import_styled_components27.css`
      pointer-events: none;
      background-color: transparent;
      color: ${(p3) => p3.theme.colors.disabled};
    `}
`;

// src/components/ListItem/ListItem.tsx
var ListItem2 = (0, import_react63.forwardRef)(function forwardedListItem({
  children,
  caption,
  icon,
  iconAlign = "left",
  look = "default",
  palette = null,
  highlighted = false,
  disabled = false,
  ...rest
}, ref) {
  const { palettes: palettes2 } = (0, import_styled_components28.useTheme)();
  const isXsollaIcon = (0, import_ui_icons9.useIsXsollaIcon)(icon);
  return /* @__PURE__ */ import_react63.default.createElement(StyledListItem, {
    ...rest,
    ref,
    $look: look,
    $palette: palette ? palettes2[palette] : null,
    $highlighted: highlighted,
    $disabled: disabled
  }, icon && /* @__PURE__ */ import_react63.default.createElement(Icon2, {
    $align: iconAlign
  }, isXsollaIcon ? (0, import_react63.createElement)(icon, { size: 24 }) : (0, import_react63.createElement)(icon)), /* @__PURE__ */ import_react63.default.createElement(Entry4, null, /* @__PURE__ */ import_react63.default.createElement(Label2, null, children), caption && /* @__PURE__ */ import_react63.default.createElement(Caption, null, caption)));
});

// src/components/Notification/Notification.tsx
var import_react64 = __toESM(require("react"));
var import_ui_icons10 = require("@xsolla/ui-icons");

// src/components/Notification/styled.ts
var import_styled_components29 = __toESM(require("styled-components"));
var StyledNotification = import_styled_components29.default.div`
  position: relative;
  background-color: ${(p2) => p2.theme.palettes[p2.$palette].transparent};
  border: 1px solid ${(p2) => p2.theme.palettes[p2.$palette].overlay};
  color: ${(p2) => p2.theme.palettes[p2.$palette].regular};
  display: flex;
  align-items: flex-start;
  padding: 12px 44px 12px 12px;
  border-radius: ${(p2) => p2.theme.misc.borderRadiusSm};

  ${(p2) => p2.$floating && import_styled_components29.css`
      max-width: 304px;
      box-shadow: 0 1px 4px ${p2.theme.palettes[p2.$palette].transparent};
    `}
`;
var Icon3 = import_styled_components29.default.div`
  margin-right: 8px;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;
var Entry5 = import_styled_components29.default.div``;
var Label3 = import_styled_components29.default.div`
  ${(p2) => p2.theme.typography.description};
  font-weight: 500;
`;
var Caption2 = import_styled_components29.default.div`
  ${(p2) => p2.theme.typography.caption};
`;
var Close = import_styled_components29.default.div`
  position: absolute;
  right: 12px;
  top: 12px;
  flex-shrink: 0;
`;

// src/components/Notification/Notification.tsx
var Notification = ({
  children,
  caption,
  palette = "brand",
  icon,
  floating = false,
  onClose
}) => {
  const isXsollaIcon = (0, import_ui_icons10.useIsXsollaIcon)(icon);
  return /* @__PURE__ */ import_react64.default.createElement(StyledNotification, {
    $palette: palette,
    $floating: floating
  }, icon && /* @__PURE__ */ import_react64.default.createElement(Icon3, null, isXsollaIcon ? (0, import_react64.createElement)(icon, { size: 24 }) : (0, import_react64.createElement)(icon)), /* @__PURE__ */ import_react64.default.createElement(Entry5, null, /* @__PURE__ */ import_react64.default.createElement(Label3, null, children), caption && /* @__PURE__ */ import_react64.default.createElement(Caption2, null, caption)), floating && onClose && /* @__PURE__ */ import_react64.default.createElement(Close, null, /* @__PURE__ */ import_react64.default.createElement(Button, {
    palette,
    look: "icon",
    onClick: onClose
  }, /* @__PURE__ */ import_react64.default.createElement(import_ui_icons10.Cross, {
    size: 16
  }))));
};

// src/components/Pagination/Pagination.tsx
var import_react65 = __toESM(require("react"));
var import_ui_icons11 = require("@xsolla/ui-icons");

// src/components/Pagination/getPaginatedArray.ts
var getRange = (start, end) => Array(end - start + 1).fill("").map((_v, i2) => i2 + start);
var getPaginatedArray = (pageCount, currentPage) => {
  let delta2;
  if (pageCount <= 7) {
    delta2 = 7;
  } else {
    delta2 = currentPage > 6 && currentPage < pageCount - 3 ? 4 : 6;
  }
  const range = {
    start: Math.round(currentPage - delta2 / 2),
    end: Math.round(currentPage + delta2 / 2)
  };
  if (range.start - 1 === 1 || range.end + 1 === pageCount) {
    range.start += 1;
    range.end += 1;
  }
  let pages = currentPage > delta2 ? getRange(Math.min(range.start, pageCount - delta2), Math.min(range.end, pageCount)) : getRange(1, Math.min(pageCount, delta2 + 1));
  const withDots = (value, pair) => pages.length + 1 !== pageCount ? pair : [value];
  if (pages[0] !== 1) {
    pages = withDots(1, [1, -1]).concat(pages);
  }
  if (pages[pages.length - 1] < pageCount) {
    pages = pages.concat(withDots(pageCount, [-1, pageCount]));
  }
  return pages;
};

// src/components/Pagination/styled.ts
var import_styled_components30 = __toESM(require("styled-components"));
var StyledPagination = import_styled_components30.default.div`
  display: flex;
  align-items: center;
`;
var Container = import_styled_components30.default.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
  :last-child {
    margin-right: 0;
  }
`;
var SideButton = import_styled_components30.default.button`
  ${(p2) => p2.theme.typography.subHeader3compact};

  background-color: ${(p2) => p2.theme.colors.white};
  border: 1px solid ${(p2) => p2.theme.colors.stroke};
  color: ${(p2) => p2.theme.colors.muted};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  margin-right: -1px;
  transition: background-color ease-in-out 80ms, border-color ease-in-out 80ms,
    color ease-in-out 80ms, box-shadow ease-in-out 80ms, z-index ease-in-out 80ms;

  ${(p2) => p2.$size === "sm" && import_styled_components30.css`
      width: 32px;
      height: 24px;
    `}

  ${(p2) => p2.$size === "md" && import_styled_components30.css`
      width: 40px;
      height: 34px;
    `}

  :first-child {
    border-radius: 4px 0 0 4px;
  }

  :last-child {
    border-radius: 0 4px 4px 0;
  }

  :first-child:last-child {
    border-radius: 4px;
  }

  :hover:not(:active) {
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.brand};
    z-index: 1;
  }

  :active {
    background-color: ${(p2) => p2.theme.colors.brand};
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.white};
    z-index: 1;
  }

  :focus-visible {
    border-color: ${(p2) => p2.theme.colors.brand};
    box-shadow: 0 0 0 3px ${(p2) => p2.theme.palettes.brand.overlay};
    z-index: 1;
  }

  :hover + button,
  :active + button,
  &:focus-visible + button {
    border-left-color: ${(p2) => p2.theme.colors.brand};
  }

  &[disabled] {
    background-color: ${(p2) => p2.theme.colors.overlay};
    color: ${(p2) => p2.theme.colors.disabled};
    pointer-events: none;
  }
`;
var PageButton = (0, import_styled_components30.default)(SideButton)`
  ${(p2) => p2.$active && import_styled_components30.css`
      background-color: ${(p3) => p3.theme.colors.brand};
      border-color: ${(p3) => p3.theme.colors.brand};
      color: ${(p3) => p3.theme.colors.white} !important;
      pointer-events: none;
      z-index: 1;
    `}

  ${(p2) => p2.$dots && import_styled_components30.css`
      background-color: ${(p3) => p3.theme.colors.overlay};
      pointer-events: none;
      letter-spacing: 1px;
    `}
`;

// src/components/Pagination/Pagination.tsx
var Pagination = (0, import_react65.forwardRef)(function forwardedPagination({ total, current, perPage = 10, size = "md", onChange }, ref) {
  const pageCount = (0, import_react65.useMemo)(() => Math.ceil(total / perPage), [total, perPage]);
  const paginatedPages = (0, import_react65.useMemo)(() => getPaginatedArray(pageCount, current), [pageCount, current]);
  const disabled = (0, import_react65.useMemo)(() => ({
    prev: current <= 1,
    next: current >= pageCount
  }), [current, pageCount]);
  const onClickPrev = () => {
    onChange(Math.max(current - 1, 1));
  };
  const onClickNext = () => {
    onChange(Math.min(current + 1, pageCount));
  };
  const onClickPage = (page) => {
    onChange(page);
  };
  if (!pageCount) {
    return null;
  }
  return /* @__PURE__ */ import_react65.default.createElement(StyledPagination, {
    ref
  }, /* @__PURE__ */ import_react65.default.createElement(Container, null, /* @__PURE__ */ import_react65.default.createElement(SideButton, {
    $size: size,
    disabled: disabled.prev,
    onClick: onClickPrev
  }, /* @__PURE__ */ import_react65.default.createElement(import_ui_icons11.ChevronLeft, null)), /* @__PURE__ */ import_react65.default.createElement(SideButton, {
    $size: size,
    disabled: disabled.next,
    onClick: onClickNext
  }, /* @__PURE__ */ import_react65.default.createElement(import_ui_icons11.ChevronRight, null))), /* @__PURE__ */ import_react65.default.createElement(Container, null, paginatedPages.map((value, index) => /* @__PURE__ */ import_react65.default.createElement(PageButton, {
    key: `${value}-${index}`,
    $size: size,
    $active: value === current,
    $dots: value === -1,
    onClick: () => onClickPage(value)
  }, value > 0 ? value : "..."))));
});

// src/components/Pill/Pill.tsx
var import_react66 = __toESM(require("react"));
var import_styled_components32 = require("styled-components");

// src/components/Pill/styled.ts
var import_styled_components31 = __toESM(require("styled-components"));
var StyledPill = import_styled_components31.default.div`
  ${(p2) => p2.theme.typography.subHeader3compact};
  background: ${(p2) => p2.$palette.transparent};
  padding: 4px 16px;
  display: inline-flex;
  color: ${(p2) => p2.$palette.regular};
  border-radius: 48px;
  box-sizing: border-box;
  user-select: none;
`;

// src/components/Pill/Pill.tsx
var Pill = (0, import_react66.forwardRef)(function forwardedPill({ children, palette, ...rest }, ref) {
  const { palettes: palettes2 } = (0, import_styled_components32.useTheme)();
  return /* @__PURE__ */ import_react66.default.createElement(StyledPill, {
    ref,
    ...rest,
    $palette: palettes2[palette]
  }, children);
});

// src/components/PillAction/PillAction.tsx
var import_react67 = __toESM(require("react"));
var import_styled_components34 = require("styled-components");

// src/components/PillAction/styled.ts
var import_ui_icons12 = require("@xsolla/ui-icons");
var import_styled_components33 = __toESM(require("styled-components"));
var StyledPillAction = (0, import_styled_components33.default)(StyledPill)`
  ${(p2) => p2.theme.typography.graphikFontFamily};
  ${(p2) => p2.theme.typography.label};

  cursor: pointer;
  border: none;
  box-shadow: inset 0 0 0 1px ${(p2) => p2.$palette.regular}, 0 0 0 1px transparent;
  transition: box-shadow ease-in-out 80ms;

  &:active,
  &:focus-visible {
    box-shadow: inset 0 0 0 1px ${(p2) => p2.$palette.regular}, 0 0 0 1px ${(p2) => p2.$palette.regular};
  }

  ${(p2) => p2.$hovered && import_styled_components33.css`
      box-shadow: inset 0 0 0 1px ${p2.$palette.regular}, 0 0 0 1px ${p2.$palette.regular};
    `}
`;
var Icon4 = import_styled_components33.default.span`
  margin: -4px 0 -4px -12px;
  display: flex;
`;
var Label4 = import_styled_components33.default.span`
  padding-right: 8px;
  margin-right: 6px;
  border-right: 1px solid ${(p2) => p2.$palette.regular};
`;
var StyledChevronDown = (0, import_styled_components33.default)(import_ui_icons12.ChevronDown)`
  margin-right: -8px;
  transition: transform ease-in-out 80ms;

  ${(p2) => p2.$hovered && import_styled_components33.css`
      transform: rotate(180deg);
    `};
`;

// src/components/PillAction/PillAction.tsx
var PillAction = (0, import_react67.forwardRef)(function forwardedPillAction({ children, palette, hovered = false, ...rest }, ref) {
  const { palettes: palettes2 } = (0, import_styled_components34.useTheme)();
  const isIconChildElement = typeof children === "object";
  return /* @__PURE__ */ import_react67.default.createElement(StyledPillAction, {
    ref,
    as: "button",
    ...rest,
    $palette: palettes2[palette],
    $hovered: hovered
  }, isIconChildElement ? /* @__PURE__ */ import_react67.default.createElement(Icon4, null, children) : /* @__PURE__ */ import_react67.default.createElement(Label4, {
    $palette: palettes2[palette]
  }, children), /* @__PURE__ */ import_react67.default.createElement(StyledChevronDown, {
    size: 16,
    $palette: palettes2[palette],
    $hovered: hovered
  }));
});

// src/components/PillLink/PillLink.tsx
var import_react68 = __toESM(require("react"));
var import_styled_components36 = require("styled-components");

// src/components/PillLink/styled.ts
var import_styled_components35 = __toESM(require("styled-components"));
var import_ui_icons13 = require("@xsolla/ui-icons");
var StyledPillLink = (0, import_styled_components35.default)(StyledPill)`
  ${(p2) => p2.theme.typography.graphikFontFamily};
  ${(p2) => p2.theme.typography.label};
  text-decoration: none;
  box-shadow: inset 0 0 0 1px ${(p2) => p2.$palette.regular}, 0 0 0 1px transparent;
  transition: box-shadow ease-in-out 80ms;
  cursor: pointer;

  &:active,
  &:focus-visible {
    box-shadow: inset 0 0 0 1px ${(p2) => p2.$palette.regular}, 0 0 0 1px ${(p2) => p2.$palette.regular};
  }
`;
var StyledChevronRight = (0, import_styled_components35.default)(import_ui_icons13.ChevronRight)`
  margin-right: -8px;
  margin-left: 4px;
`;

// src/components/PillLink/PillLink.tsx
var PillLink = (0, import_react68.forwardRef)(function forwardedPillLink({ children, palette, ...rest }, ref) {
  const { palettes: palettes2 } = (0, import_styled_components36.useTheme)();
  return /* @__PURE__ */ import_react68.default.createElement(StyledPillLink, {
    ref,
    as: "a",
    ...rest,
    $palette: palettes2[palette]
  }, children, /* @__PURE__ */ import_react68.default.createElement(StyledChevronRight, {
    size: 16,
    $palette: palettes2[palette]
  }));
});

// src/components/ProgressBar/ProgressBar.tsx
var import_react69 = __toESM(require("react"));
var import_styled_components37 = __toESM(require("styled-components"));
var infinitelyKeyframes = import_styled_components37.keyframes`
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
`;
var StyledProgressBar = import_styled_components37.default.div`
  position: relative;
  overflow: hidden;
  height: 2px;
`;
var Bar = import_styled_components37.default.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: ${(p2) => p2.theme.colors.action};
  transition: width linear 120ms;

  ${(p2) => p2.$infinitely && import_styled_components37.css`
      width: 80%;
      animation: ${infinitelyKeyframes} ease-in-out 800ms infinite;
    `}
`;
var ProgressBar = ({ progress: progress2 = Infinity }) => /* @__PURE__ */ import_react69.default.createElement(StyledProgressBar, null, /* @__PURE__ */ import_react69.default.createElement(Bar, {
  style: progress2 ? { width: `${progress2}%` } : {},
  $infinitely: progress2 === Infinity
}));

// src/components/Radio/Radio.tsx
var import_react70 = __toESM(require("react"));
var import_ui_core8 = require("@xsolla/ui-core");
var import_styled_components39 = require("styled-components");

// src/components/Radio/styled.tsx
var import_styled_components38 = __toESM(require("styled-components"));
var Circle = import_styled_components38.default.div`
  background-color: inherit;
  width: 14px;
  height: 14px;
  margin: 3px 1px 0 1px;
  border: 2px solid ${(p2) => p2.theme.colors.white};
  border-radius: 50%;
  box-sizing: border-box;
`;
var Input4 = (0, import_styled_components38.default)(Input)`
  border-radius: 50%;

  &[data-error='true']:checked {
    background-color: ${(p2) => p2.theme.colors.danger};
  }
`;

// src/components/Radio/Radio.tsx
var Radio = (0, import_react70.forwardRef)(function forwardedRadio({ children, tooltip, errorMessage, ...inputProps }, ref) {
  const theme = (0, import_styled_components39.useTheme)();
  useCheckboxBlur(inputProps.checked, inputProps.onBlur);
  return /* @__PURE__ */ import_react70.default.createElement(import_ui_core8.FieldWrapper, {
    inline: true
  }, /* @__PURE__ */ import_react70.default.createElement(import_ui_core8.FieldRow, {
    gap: "sm"
  }, /* @__PURE__ */ import_react70.default.createElement(StyledCheckbox, null, /* @__PURE__ */ import_react70.default.createElement(Input4, {
    ...inputProps,
    ref,
    type: "radio",
    "data-error": !!errorMessage,
    $palette: theme.palettes.action
  }), /* @__PURE__ */ import_react70.default.createElement(Status2, null, /* @__PURE__ */ import_react70.default.createElement(Circle, null)), children && /* @__PURE__ */ import_react70.default.createElement(Entry2, null, children)), tooltip && /* @__PURE__ */ import_react70.default.createElement(import_ui_core8.Tooltip, {
    content: tooltip
  })), !!errorMessage && /* @__PURE__ */ import_react70.default.createElement(import_ui_core8.ValidationMessage, null, errorMessage));
});

// src/components/RadioGroup/RadioGroup.tsx
var import_react72 = __toESM(require("react"));
var import_ui_core10 = require("@xsolla/ui-core");
var import_styled_components41 = __toESM(require("styled-components"));

// src/components/RadioGroup/Option/Option.tsx
var import_react71 = __toESM(require("react"));
var import_ui_core9 = require("@xsolla/ui-core");

// src/components/RadioGroup/Option/styled.tsx
var import_styled_components40 = __toESM(require("styled-components"));
var StyledOption = import_styled_components40.default.div`
  max-width: 468px;
  width: 100%;

  ${(p2) => p2.$compact && import_styled_components40.css`
      max-width: 152px;
    `}

  &:first-child label {
    border-radius: 6px 0 0 6px;
  }

  &:last-child label {
    margin-right: 0;
    border-radius: 0 6px 6px 0;
  }

  &:first-child:last-child label {
    border-radius: 6px;
  }
`;
var Trigger2 = import_styled_components40.default.label`
  position: relative;
  background-color: ${(p2) => p2.theme.colors.white};
  border: 1px solid ${(p2) => p2.theme.colors.stroke};
  display: flex;
  align-items: flex-start;
  padding: 11px 16px;
  margin-right: -1px;
  cursor: pointer;
  box-sizing: border-box;
  z-index: 1;
  transition: background-color ease-in-out 80ms, border-color ease-in-out 80ms,
    z-index ease-in-out 80ms;
`;
var Status3 = import_styled_components40.default.div`
  border: 1px solid ${(p2) => p2.theme.colors.stroke};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(p2) => p2.theme.colors.white};
  margin: 2px 8px 0 0;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  border-radius: 50%;
  transition: border-color ease-in-out 80ms;
`;
var Circle2 = import_styled_components40.default.div`
  background-color: ${(p2) => p2.theme.colors.action};
  border: 3px solid ${(p2) => p2.theme.colors.white};
  width: 14px;
  height: 14px;
  box-sizing: border-box;
  border-radius: 50%;
  opacity: 0;
  transition: opacity ease-in-out 80ms;
`;
var Label5 = import_styled_components40.default.div`
  ${(p2) => p2.theme.typography.bodyCompact};
`;
var HiddenInput = import_styled_components40.default.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;

  &:hover {
    & ~ ${Trigger2} {
      border-color: ${(p2) => p2.theme.colors.action};
      z-index: 2;
    }

    & ~ ${Trigger2} ${Status3} {
      border-color: ${(p2) => p2.theme.colors.action};
    }
  }

  &:checked {
    & ~ ${Trigger2} {
      border-color: ${(p2) => p2.theme.colors.action};
      box-shadow: inset 0 0 0 1px ${(p2) => p2.theme.colors.action};
      z-index: 2;
    }

    & ~ ${Trigger2} ${Status3} {
      border-color: ${(p2) => p2.theme.colors.action};
    }

    & ~ ${Trigger2} ${Circle2} {
      opacity: 1;
    }
  }

  &[disabled] {
    & ~ ${Trigger2} {
      background-color: ${(p2) => p2.theme.colors.overlay};
      border-color: ${(p2) => p2.theme.colors.disabled};
      color: ${(p2) => p2.theme.colors.disabled};
      pointer-events: none;
    }
  }

  &[disabled]:checked {
    & ~ ${Trigger2} {
      box-shadow: inset 0 0 0 1px ${(p2) => p2.theme.colors.disabled};
      z-index: 2;
    }

    & ~ ${Trigger2} ${Status3} {
      border-color: ${(p2) => p2.theme.colors.disabled};
    }

    & ~ ${Trigger2} ${Circle2} {
      background-color: ${(p2) => p2.theme.colors.disabled};
      border-color: ${(p2) => p2.theme.colors.overlay};
    }
  }
`;

// src/components/RadioGroup/Option/Option.tsx
var Option = ({ children, compact = false, ...inputProps }) => {
  const uniqueId = (0, import_react71.useMemo)(import_ui_core9.getRandomString, [inputProps.value]);
  useCheckboxBlur(inputProps.checked, inputProps.onBlur);
  return /* @__PURE__ */ import_react71.default.createElement(StyledOption, {
    $compact: compact
  }, /* @__PURE__ */ import_react71.default.createElement(HiddenInput, {
    ...inputProps,
    id: uniqueId,
    type: "radio"
  }), /* @__PURE__ */ import_react71.default.createElement(Trigger2, {
    htmlFor: uniqueId
  }, /* @__PURE__ */ import_react71.default.createElement(Status3, null, /* @__PURE__ */ import_react71.default.createElement(Circle2, null)), /* @__PURE__ */ import_react71.default.createElement(Label5, null, children)));
};

// src/components/RadioGroup/RadioGroup.tsx
var StyledRadioGroup = import_styled_components41.default.div`
  display: flex;
  align-items: center;
`;
var RadioGroup = ({
  value,
  options,
  compact = false,
  errorMessage,
  onChange = () => void 0,
  ...inputProps
}) => {
  const uniqueId = (0, import_react72.useMemo)(import_ui_core10.getRandomString, []);
  const onChangeOption = (0, import_react72.useCallback)((e2) => {
    onChange(e2.currentTarget.value);
  }, [onChange]);
  return /* @__PURE__ */ import_react72.default.createElement(import_ui_core10.FieldWrapper, null, /* @__PURE__ */ import_react72.default.createElement(StyledRadioGroup, null, options.map((option) => /* @__PURE__ */ import_react72.default.createElement(Option, {
    ...option,
    ...inputProps,
    key: `option-${uniqueId}-${option.value}`,
    checked: option.value === value,
    compact,
    onChange: onChangeOption
  }, option.children))), errorMessage && /* @__PURE__ */ import_react72.default.createElement(import_ui_core10.ValidationMessage, null, errorMessage));
};

// src/components/Select/Select.tsx
var import_react73 = __toESM(require("react"));
var import_ui_core11 = require("@xsolla/ui-core");

// src/components/Select/styled.ts
var import_styled_components42 = __toESM(require("styled-components"));
var import_ui_icons14 = require("@xsolla/ui-icons");
var Chevron = (0, import_styled_components42.default)(import_ui_icons14.ChevronUpDown)`
  color: ${(p2) => p2.theme.colors.muted};
  flex-shrink: 0;
  margin: 0 -8px 0 8px;
  transition: color ease-in-out 80ms;
`;
var Entry6 = import_styled_components42.default.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
var StyledSelect = import_styled_components42.default.button`
  ${(p2) => p2.theme.typography.graphikFontFamily};
  ${(p2) => p2.theme.typography.body};

  position: relative;
  background-color: ${(p2) => p2.theme.colors.white};
  border: 1px solid ${(p2) => p2.theme.colors.stroke};
  color: ${(p2) => p2.theme.colors.text};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  border-radius: ${(p2) => p2.theme.misc.borderRadiusMd};
  cursor: pointer;
  user-select: none;
  box-shadow: inset 0 0 0 1px transparent;
  transition: background-color ease-in-out 80ms, border-color ease-in-out 80ms,
    color ease-in-out 80ms, box-shadow ease-in-out 80ms;

  ${(p2) => p2.size === "sm" && import_styled_components42.css`
      max-width: 304px;
      min-height: 36px;
      padding: 0 12px;
    `}

  ${(p2) => p2.size === "md" && import_styled_components42.css`
      min-height: 44px;
      padding: 0 12px;
    `}

  ${(p2) => p2.inline && import_styled_components42.css`
      width: auto;
      min-width: 140px;
    `}

  ${(p2) => p2.isEmpty && import_styled_components42.css`
      color: ${(p3) => p3.theme.colors.muted};
    `}
  
  ${(p2) => p2.isError && import_styled_components42.css`
      background-color: ${(p3) => p3.theme.palettes.danger.transparent};
      border-color: ${(p3) => p3.theme.colors.danger};
      color: ${(p3) => p3.theme.colors.danger};
      ${Chevron} {
        color: ${(p3) => p3.theme.colors.danger};
      }
    `}

    ${(p2) => p2.isError && p2.isEmpty && import_styled_components42.css`
      color: ${(p3) => p3.theme.palettes.danger.overlay};
    `}

  &:hover {
    background-color: ${(p2) => p2.theme.colors.white};
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.text};
    ${Chevron} {
      color: ${(p2) => p2.theme.colors.brand};
    }
  }

  &:focus {
    background-color: ${(p2) => p2.theme.colors.white};
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.text};
    box-shadow: inset 0 0 0 1px ${(p2) => p2.theme.colors.brand};
    ${Chevron} {
      color: ${(p2) => p2.theme.colors.brand};
    }
  }

  &[disabled] {
    pointer-events: none;
    background-color: ${(p2) => p2.theme.colors.overlay};
    border-color: ${(p2) => p2.theme.colors.disabled};
    color: ${(p2) => p2.theme.colors.disabled};
  }
`;

// src/components/Select/Select.tsx
var DefaultRenderValue = ({ item, placeholder }) => {
  if (item)
    return /* @__PURE__ */ import_react73.default.createElement(import_react73.default.Fragment, null, item.children);
  return /* @__PURE__ */ import_react73.default.createElement(import_react73.default.Fragment, null, placeholder);
};
var Select = ({
  value,
  options,
  search,
  size = "md",
  inline = false,
  placeholder = "Select...",
  errorMessage,
  renderValue = DefaultRenderValue,
  onChange,
  onBlur,
  ...rest
}) => {
  const [visiblePopper, setVisiblePopper] = (0, import_react73.useState)(false);
  const previousVisiblePopper = usePrevious(visiblePopper);
  const selectedItem = (0, import_react73.useMemo)(() => options.find((o2) => o2.value === value), [options, value]);
  const items = (0, import_react73.useMemo)(() => {
    return options.map((option) => {
      var _a;
      return {
        ...option,
        value: void 0,
        "data-value": (_a = option.value) == null ? void 0 : _a.toString(),
        onClick: onChange ? () => onChange(option.value) : void 0
      };
    });
  }, [options, onChange]);
  const conditions = {
    isEmpty: !selectedItem,
    isError: !!errorMessage
  };
  (0, import_react73.useEffect)(() => {
    if (!previousVisiblePopper || !onBlur)
      return;
    onBlur();
  }, [previousVisiblePopper, onBlur]);
  return /* @__PURE__ */ import_react73.default.createElement(import_ui_core11.FieldWrapper, {
    inline
  }, /* @__PURE__ */ import_react73.default.createElement(import_ui_core11.Popper, {
    entry: /* @__PURE__ */ import_react73.default.createElement(import_ui_core11.List, {
      items,
      search,
      selected: options.findIndex((i2) => i2.value === value)
    }),
    stretched: true,
    onChangeVisible: setVisiblePopper
  }, (referenceProps) => /* @__PURE__ */ import_react73.default.createElement(StyledSelect, {
    ...rest,
    ...referenceProps,
    ...conditions,
    type: "button",
    size,
    inline
  }, /* @__PURE__ */ import_react73.default.createElement(Entry6, null, renderValue({ item: selectedItem, placeholder })), /* @__PURE__ */ import_react73.default.createElement(Chevron, null))), !!errorMessage && /* @__PURE__ */ import_react73.default.createElement(import_ui_core11.ValidationMessage, null, errorMessage));
};

// src/components/Dots/Dots.tsx
var import_react74 = __toESM(require("react"));

// src/components/Dots/styled.tsx
var import_styled_components43 = __toESM(require("styled-components"));

// src/components/Dots/colorMap.ts
var colorMap2 = makeSafetyMap([
  ["gray", lightTheme.colors.stroke],
  ["blue", lightTheme.colors.brand],
  ["black", lightTheme.colors.text],
  ["white", lightTheme.colors.white],
  ["inherit", "inherit"]
]);

// src/components/Dots/styled.tsx
var fadeDots = import_styled_components43.keyframes`
  0% {
    opacity: 0.24;
  }
  40% {
    opacity: 1;
  }
  100% {
    opacity: 0.24;
  }
`;
var dotsContainerPadding = 2;
var StyledDots = import_styled_components43.default.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  padding: ${`${dotsContainerPadding}px`};
  box-sizing: border-box;

  ${({ $size }) => {
  const sizeMinusPadding = $size - dotsContainerPadding * 2;
  const dotIndent = sizeMinusPadding / 3 * 2;
  const width = sizeMinusPadding * 3 + dotIndent * 2;
  return import_styled_components43.css`
      width: ${`${width}px`};
      height: ${`${sizeMinusPadding}px`};
    `;
}}
`;
var Dot = import_styled_components43.default.div`
  width: ${({ $size }) => `${$size - dotsContainerPadding * 2}px`};
  height: ${({ $size }) => `${$size - dotsContainerPadding * 2}px`};
  background-color: ${(p2) => colorMap2.get(p2.$color)};
  border-radius: 50%;
  animation: ${fadeDots} 1s linear infinite;
  flex-shrink: 0;
`;
var DotLeft = (0, import_styled_components43.default)(Dot)`
  animation-delay: 0;
`;
var DotCenter = (0, import_styled_components43.default)(Dot)`
  animation-delay: 200ms;
`;
var DotRight = (0, import_styled_components43.default)(Dot)`
  animation-delay: 400ms;
`;

// src/components/Dots/Dots.tsx
var Dots = ({ size = 16, color: color2 = "gray" }) => /* @__PURE__ */ import_react74.default.createElement(StyledDots, {
  $size: size
}, /* @__PURE__ */ import_react74.default.createElement(DotLeft, {
  $color: color2,
  $size: size
}), /* @__PURE__ */ import_react74.default.createElement(DotCenter, {
  $color: color2,
  $size: size
}), /* @__PURE__ */ import_react74.default.createElement(DotRight, {
  $color: color2,
  $size: size
}));

// src/components/StatusDot/StatusDot.tsx
var import_react75 = __toESM(require("react"));
var import_styled_components44 = __toESM(require("styled-components"));
var StyledStatusDot = import_styled_components44.default.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  color: ${(p2) => p2.$palette.regular};
`;
var Dot2 = import_styled_components44.default.div`
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.3) 100%
  );
  background-color: ${(p2) => p2.$palette.regular};
  box-shadow: 0 2px 4px ${(p2) => p2.$palette.overlay};
  width: 8px;
  height: 8px;
  border-radius: 50%;
`;
var Label6 = import_styled_components44.default.div`
  ${(p2) => p2.theme.typography.label};
  margin-left: 5px;
`;
var StatusDot = (0, import_react75.forwardRef)(function forwardedStatusDot({ children, palette, ...rest }, ref) {
  const { palettes: palettes2 } = (0, import_styled_components44.useTheme)();
  return /* @__PURE__ */ import_react75.default.createElement(StyledStatusDot, {
    ref,
    ...rest,
    $palette: palettes2[palette]
  }, /* @__PURE__ */ import_react75.default.createElement(Dot2, {
    $palette: palettes2[palette]
  }), children && /* @__PURE__ */ import_react75.default.createElement(Label6, null, children));
});

// src/components/Switch/Switch.tsx
var import_react76 = __toESM(require("react"));
var import_ui_core12 = require("@xsolla/ui-core");

// src/components/Switch/styled.tsx
var import_styled_components45 = __toESM(require("styled-components"));
var StyledSwitch = import_styled_components45.default.div`
  display: flex;
  align-items: flex-start;
  user-select: none;

  ${(p2) => p2.$disabled && import_styled_components45.css`
      pointer-events: none;
    `}
`;
var Trigger3 = import_styled_components45.default.label`
  position: relative;
  width: 64px;
  height: 24px;
  display: flex;
  flex-shrink: 0;
  border: transparent;
  align-items: center;
  background-color: ${(p2) => p2.theme.colors.disabled};
  color: ${(p2) => p2.theme.colors.white};
  border-radius: 25px;
  cursor: pointer;
  transition: background-color ease-in-out 80ms, transform ease-in-out 80ms;

  &:active {
    transform: scale(0.98);
  }
`;
var Dot3 = import_styled_components45.default.div`
  position: absolute;
  width: 16px;
  height: 16px;
  background-color: ${(p2) => p2.theme.colors.white};
  border-radius: 25px;
  transform: translateX(4px);
  transition: transform ease-in-out 120ms;
  z-index: 1;
`;
var DotLabel = import_styled_components45.default.div`
  position: absolute;
  left: 12px;
  right: 12px;
  top: 0;
  font-size: 8px;
  font-weight: 500;
  text-transform: uppercase;

  & > div {
    position: absolute;
    top: 0;
    transition: opacity ease-in-out 120ms;
  }

  & > div:first-child {
    left: 0;
    opacity: 0;
  }
  & > div:last-child {
    right: 0;
  }
`;
var Entry7 = import_styled_components45.default.div`
  margin-left: 16px;
`;
var Label7 = import_styled_components45.default.label`
  display: inline-flex;
  font-weight: 500;
  line-height: 24px;
  color: ${(p2) => p2.theme.colors.text};
  cursor: pointer;
`;
var Caption3 = import_styled_components45.default.div`
  margin-top: 4px;
  font-size: 14px;
  line-height: 24px;
  color: ${(p2) => p2.theme.colors.muted};

  ${(p2) => p2.$disabled && import_styled_components45.css`
      color: ${(p3) => p3.theme.colors.disabled};
    `}
`;
var HiddenInput2 = import_styled_components45.default.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;

  &:hover:not(:checked) ~ ${Trigger3} {
    background-color: #949ea9;
  }

  &:hover:checked ~ ${Trigger3} {
    background-color: ${(p2) => p2.theme.palettes.action.dark};
  }

  &:checked ~ ${Trigger3} {
    background-color: ${(p2) => p2.theme.colors.action};
  }

  &:checked ~ ${Trigger3} {
    & ${Dot3} {
      transform: translateX(44px);
    }
    & ${DotLabel} > div:first-child {
      opacity: 1;
    }
    & ${DotLabel} > div:last-child {
      opacity: 0;
    }
  }

  &:focus-visible:not(checked) ~ ${Trigger3} {
    box-shadow: 0 0 0 3px ${(p2) => p2.theme.palettes.muted.overlay};
  }

  &:focus-visible:checked ~ ${Trigger3} {
    box-shadow: 0 0 0 3px ${(p2) => p2.theme.palettes.action.overlay};
  }

  &[disabled] ~ ${Trigger3} {
    background-color: ${(p2) => p2.theme.colors.stroke};
    color: ${(p2) => p2.theme.colors.disabled};
  }

  &[disabled] ~ ${Label7} {
    color: ${(p2) => p2.theme.colors.disabled};
  }
`;

// src/components/Switch/Switch.tsx
var Switch = ({ children, caption, tooltip, errorMessage, ...inputProps }) => {
  useCheckboxBlur(inputProps.checked, inputProps.onBlur);
  const uniqueId = (0, import_react76.useMemo)(getRandomString, [inputProps.name]);
  if (!children && caption) {
    throw Error("The `caption` should be transmitted together with `children`.");
  }
  if (!children && tooltip) {
    throw Error("The `tooltip` should be transmitted together with `children`.");
  }
  return /* @__PURE__ */ import_react76.default.createElement(import_ui_core12.FieldWrapper, null, /* @__PURE__ */ import_react76.default.createElement(StyledSwitch, {
    $disabled: inputProps.disabled || false
  }, /* @__PURE__ */ import_react76.default.createElement(HiddenInput2, {
    ...inputProps,
    id: uniqueId,
    type: "checkbox"
  }), /* @__PURE__ */ import_react76.default.createElement(Trigger3, {
    htmlFor: uniqueId
  }, /* @__PURE__ */ import_react76.default.createElement(Dot3, null), /* @__PURE__ */ import_react76.default.createElement(DotLabel, null, /* @__PURE__ */ import_react76.default.createElement("div", null, "On"), /* @__PURE__ */ import_react76.default.createElement("div", null, "Off"))), children && /* @__PURE__ */ import_react76.default.createElement(Entry7, null, children && /* @__PURE__ */ import_react76.default.createElement(import_ui_core12.FieldRow, {
    gap: "sm"
  }, /* @__PURE__ */ import_react76.default.createElement(Label7, {
    htmlFor: uniqueId
  }, children), tooltip && /* @__PURE__ */ import_react76.default.createElement(import_ui_core12.Tooltip, {
    content: tooltip
  })), caption && /* @__PURE__ */ import_react76.default.createElement(Caption3, {
    $disabled: inputProps.disabled || false
  }, caption))), !!errorMessage && /* @__PURE__ */ import_react76.default.createElement(import_ui_core12.ValidationMessage, null, errorMessage));
};

// src/components/Tabs/Tabs.tsx
var import_react77 = __toESM(require("react"));

// src/components/Tabs/styled.ts
var import_styled_components46 = __toESM(require("styled-components"));
var borderAnimation = import_styled_components46.keyframes`
  from {
    width: 0;
    transform: translateX(-4px);
  }
`;
var StyledTabs = import_styled_components46.default.div`
  margin-bottom: 24px;
  border-bottom: 1px solid ${(p2) => p2.theme.colors.stroke};
  color: ${(p2) => p2.theme.colors.text};
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 44px;
  box-sizing: content-box;
`;
var TabItem = import_styled_components46.default.a`
  position: relative;
  margin-right: 24px;
  text-decoration: none;
  user-select: none;
  color: ${(p2) => p2.theme.colors.text};
  cursor: pointer;
  transition: color ease-in-out 80ms;

  ${(p2) => p2.$disabled && import_styled_components46.css`
      color: ${(p3) => p3.theme.colors.disabled};
      pointer-events: none;
    `}

  &.active {
    font-weight: 500;
    &::after {
      position: absolute;
      left: 0;
      bottom: -21px;
      background-color: ${(p2) => p2.theme.colors.brand};
      width: 100%;
      height: 2px;
      content: '';
      animation: ${borderAnimation} ease-in-out 80ms;
    }
  }

  &.active,
  &:active {
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.brand};
  }

  &:hover,
  &:focus-visible {
    color: ${(p2) => p2.theme.colors.brand};
  }

  &:last-child {
    margin-right: 0;
  }
`;
var Extra2 = import_styled_components46.default.div`
  display: flex;
  align-items: flex-start;
  margin-left: auto;
  height: 44px;
`;

// src/components/Tabs/Tabs.tsx
var Tabs = (0, import_react77.forwardRef)(function forwardedTabs({ children = [], content, extra }, ref) {
  return /* @__PURE__ */ import_react77.default.createElement(import_react77.default.Fragment, null, /* @__PURE__ */ import_react77.default.createElement(StyledTabs, {
    ref
  }, children, extra && /* @__PURE__ */ import_react77.default.createElement(Extra2, null, extra)), content);
});

// src/components/Tabs/useMemoryTabs.ts
var import_react78 = require("react");
var useMemoryTabs = (tabs, initialTabIndex = 0) => {
  const [currentIndex, setCurrentIndex] = (0, import_react78.useState)(initialTabIndex);
  const children = (0, import_react78.useMemo)(() => tabs.map((tab, index) => (0, import_react78.createElement)(TabItem, {
    key: `tab-${tab.name.toLowerCase()}`,
    children: tab.name,
    className: index === currentIndex ? "active" : "",
    onClick: () => setCurrentIndex(index),
    $disabled: tab.disabled
  })), [tabs, currentIndex, setCurrentIndex]);
  const content = (0, import_react78.useMemo)(() => tabs[currentIndex] ? (0, import_react78.createElement)(tabs[currentIndex].content) : null, [tabs, currentIndex]);
  return { children, content };
};

// src/components/Textarea/Textarea.tsx
var import_react79 = __toESM(require("react"));

// src/components/Textarea/styled.tsx
var import_styled_components47 = __toESM(require("styled-components"));
var StyledTextarea = import_styled_components47.default.textarea`
  ${(p2) => p2.theme.typography.graphikFontFamily};
  ${(p2) => p2.theme.typography.body};

  background-color: ${(p2) => p2.theme.colors.white};
  border: 1px solid ${(p2) => p2.theme.colors.stroke};
  color: ${(p2) => p2.theme.colors.text};
  display: flex;
  width: 100%;
  min-height: 44px;
  padding: 10px 12px;
  resize: none;
  box-sizing: border-box;
  border-radius: ${(p2) => p2.theme.misc.borderRadiusMd};
  box-shadow: inset 0 0 0 1px transparent;
  transition: background-color ease-in-out 80ms, border-color ease-in-out 80ms,
    color ease-in-out 80ms, box-shadow ease-in-out 80ms;

  ${(p2) => p2.$resize && import_styled_components47.css`
      resize: vertical;
    `}

  ${(p2) => p2.$hasError && import_styled_components47.css`
      background-color: ${p2.theme.palettes.danger.transparent};
      border-color: ${(p3) => p3.theme.colors.danger};
      color: ${(p3) => p3.theme.colors.danger};

      &:not(:hover, :focus)::placeholder {
        color: ${p2.theme.palettes.danger.overlay};
      }
    `}

  &::placeholder {
    color: ${(p2) => p2.theme.colors.muted};
  }

  &:hover {
    background-color: ${(p2) => p2.theme.colors.white};
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.text};
  }

  &:focus-visible {
    border-color: ${(p2) => p2.theme.colors.brand};
  }

  &:not([readonly]):focus {
    background-color: ${(p2) => p2.theme.colors.white};
    border-color: ${(p2) => p2.theme.colors.brand};
    color: ${(p2) => p2.theme.colors.text};
    box-shadow: inset 0 0 0 1px ${(p2) => p2.theme.colors.brand};
  }

  &[disabled] {
    pointer-events: none;
    background-color: ${(p2) => p2.theme.colors.overlay};
    border-color: ${(p2) => p2.theme.colors.disabled};
    color: ${(p2) => p2.theme.colors.disabled};
  }

  &[readonly] {
    background-color: ${(p2) => p2.theme.colors.overlay};
    border-color: ${(p2) => p2.theme.colors.stroke};
  }
`;

// src/components/Textarea/Textarea.tsx
var Textarea = (0, import_react79.forwardRef)(function forwardedTextarea({ resize = false, errorMessage, extra, extraAlign, extraAllowClick, ...rest }, ref) {
  return /* @__PURE__ */ import_react79.default.createElement(InputTemplate, {
    extra,
    extraAlign,
    extraAllowClick,
    errorMessage
  }, /* @__PURE__ */ import_react79.default.createElement(StyledTextarea, {
    ref,
    ...rest,
    $resize: resize,
    $hasError: !!errorMessage
  }));
});

// src/components/Title/Title.tsx
var import_react80 = __toESM(require("react"));
var import_styled_components48 = __toESM(require("styled-components"));
var StyledTitle = import_styled_components48.default.h1`
  ${(p2) => p2.theme.typography.title};

  display: flex;
  align-items: flex-start;

  ${(p2) => p2.$center && import_styled_components48.css`
      justify-content: center;
      text-align: center;
    `}

  ${(p2) => p2.$indent === "sm" && import_styled_components48.css`
      margin: 0 0 8px 0;
    `}

  ${(p2) => p2.$indent === "md" && import_styled_components48.css`
      margin: 0 0 16px 0;
    `}

  ${(p2) => p2.$indent === "lg" && import_styled_components48.css`
      margin: 0 0 24px 0;
    `}
`;
var Extra3 = import_styled_components48.default.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  height: 32px;
`;
var Title = (0, import_react80.forwardRef)(function forwardedTitle({ children, center = false, indent = "md", extra, ...rest }, ref) {
  return /* @__PURE__ */ import_react80.default.createElement(StyledTitle, {
    ref,
    ...rest,
    $center: center,
    $indent: indent
  }, children, extra && /* @__PURE__ */ import_react80.default.createElement(Extra3, null, extra));
});

// src/components/Tooltip/Tooltip.tsx
var import_react81 = __toESM(require("react"));

// src/components/Tooltip/styled.ts
var import_styled_components49 = __toESM(require("styled-components"));
var TooltipEntry = (0, import_styled_components49.default)(motion.div)`
  background-image: ${({ theme, $background }) => $background === "dark" ? "linear-gradient(270deg, #00244d 0%, #06182d 100%)" : theme.colors.white};
  box-shadow: 0 2px 4px rgba(0, 36, 77, 0.2);
  max-width: 304px;
  color: ${({ theme, $background }) => $background === "dark" ? theme.colors.white : theme.colors.text};
  border-radius: ${(p2) => p2.theme.misc.borderRadiusSm};

  ${(p2) => p2.$uppercase ? import_styled_components49.css`
          ${(p3) => p3.theme.typography.label};
          font-weight: normal;
          padding: 8px 12px;
        ` : import_styled_components49.css`
          ${(p3) => p3.theme.typography.captionCompact};
          padding: 12px;
        `}
`;

// src/components/Tooltip/Tooltip.tsx
var Tooltip6 = ({
  children = /* @__PURE__ */ import_react81.default.createElement(HintCircle, null),
  content,
  controlledVisible,
  placement = "top-center",
  uppercase = false,
  offset = 12,
  delayEnter = 0,
  delayLeave = 0,
  background = "dark",
  container
}) => {
  const [hovered, hoverProps] = useHover({ delayEnter, delayLeave });
  const visible = controlledVisible === void 0 ? hovered : controlledVisible;
  const { triggerProps, layerProps, renderLayer } = useLayer({
    isOpen: visible,
    auto: true,
    placement,
    container,
    triggerOffset: offset
  });
  return /* @__PURE__ */ import_react81.default.createElement(import_react81.default.Fragment, null, (0, import_react81.cloneElement)(children, {
    ...triggerProps,
    ...hoverProps,
    hovered: visible,
    onFocus: hoverProps.onMouseEnter,
    onBlur: hoverProps.onMouseLeave
  }), renderLayer(/* @__PURE__ */ import_react81.default.createElement(AnimatePresence, null, visible && /* @__PURE__ */ import_react81.default.createElement(TooltipEntry, {
    ...layerProps,
    $background: background,
    $uppercase: uppercase,
    transition: springTransition,
    initial: { opacity: 0, y: 4 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 4 },
    style: { ...layerProps.style }
  }, content))));
};

// src/components/ValidationMessage/ValidationMessage.tsx
var import_react82 = __toESM(require("react"));
var import_styled_components50 = __toESM(require("styled-components"));
var StyledValidationMessage = import_styled_components50.default.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  color: ${(p2) => p2.theme.colors.danger};
`;
var ValidationMessage7 = ({ children }) => /* @__PURE__ */ import_react82.default.createElement(StyledValidationMessage, null, children);

// src/components/WorkArea/WorkArea.tsx
var import_react83 = __toESM(require("react"));

// src/components/WorkArea/styled.ts
var import_styled_components51 = __toESM(require("styled-components"));
var StyledWorkArea = import_styled_components51.default.div`
  background-color: ${(p2) => p2.theme.colors.white};
  display: flex;
  box-shadow: 0 8px 32px rgba(196, 200, 204, 0.48), 0 1px 4px rgba(0, 36, 77, 0.08);
  border-radius: 8px;
  box-sizing: border-box;

  ${(p2) => p2.$indent === "sm" && import_styled_components51.css`
      padding: 16px 24px;
    `}

  ${(p2) => p2.$indent === "md" && import_styled_components51.css`
      padding: 24px 32px;
    `}

  ${(p2) => p2.$indent === "lg" && import_styled_components51.css`
      padding: 40px 64px;
    `}
  
  ${(p2) => p2.$stretched && import_styled_components51.css`
      height: 100%;
    `}
`;
var Entry8 = import_styled_components51.default.div`
  width: 100%;
`;
var SpinnerContainer = import_styled_components51.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

// src/components/WorkArea/WorkArea.tsx
var WorkArea = (0, import_react83.forwardRef)(function forwardedWorkArea({ children, indent = "md", stretched = false, fetching = false }, ref) {
  return /* @__PURE__ */ import_react83.default.createElement(StyledWorkArea, {
    ref,
    $indent: indent,
    $stretched: stretched
  }, /* @__PURE__ */ import_react83.default.createElement(Entry8, null, fetching ? /* @__PURE__ */ import_react83.default.createElement(SpinnerContainer, null, /* @__PURE__ */ import_react83.default.createElement(Spinner, {
    size: 24,
    color: "inherit"
  })) : children));
});

// src/libs/forms/validators.ts
var required = (value) => {
  if (!value) {
    return "Required";
  }
  return void 0;
};

// src/libs/fixSafariFocus.ts
var isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var fixSafariFocus = () => {
  if (!isSafari())
    return;
  document.addEventListener("click", (e2) => {
    const target = e2.target;
    if (target.matches("button")) {
      target.focus();
    }
  });
};

// src/UiProvider.tsx
var import_react84 = __toESM(require("react"));
var import_styled_components52 = require("styled-components");
var UiContext = (0, import_react84.createContext)({
  locale: "en"
});
var useUiContext = () => (0, import_react84.useContext)(UiContext);
var UiProvider = ({ children, locale = "en" }) => {
  (0, import_react84.useEffect)(fixSafariFocus, []);
  return /* @__PURE__ */ import_react84.default.createElement(UiContext.Provider, {
    value: { locale }
  }, /* @__PURE__ */ import_react84.default.createElement(import_styled_components52.ThemeProvider, {
    theme: lightTheme
  }, /* @__PURE__ */ import_react84.default.createElement(GlobalStyle, null), children));
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
